"use strict";
(self["webpackChunkmode_shopify"] = self["webpackChunkmode_shopify"] || []).push([[792],{

/***/ 784:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// UNUSED EXPORTS: AlexotosEditionLandingApp, BuildGuideApp, ConfiguratorV3App, EnvoyLandingPageApp, KeycapsLandingPageApp, OakAccentLandingApp, PCBGuideApp, SonnetProductPageApp

// EXTERNAL MODULE: ./node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js
var runtime_dom_esm_bundler = __webpack_require__(751);
// EXTERNAL MODULE: ./node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js
var runtime_core_esm_bundler = __webpack_require__(641);
// EXTERNAL MODULE: ./node_modules/@vue/shared/dist/shared.esm-bundler.js
var shared_esm_bundler = __webpack_require__(33);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/ConfiguratorV3.vue?vue&type=template&id=583bd1f9

var _hoisted_1 = {
  key: 0,
  id: "configurator-v3-app"
};
var _hoisted_2 = {
  class: "container-lg"
};
var _hoisted_3 = {
  class: "configurator-content row justify-content-center"
};
var _hoisted_4 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "configurator-spacer"
}, null, -1 /* HOISTED */);
var _hoisted_5 = {
  class: "configurator-wrapper container ps-0 col-12 col-md-8"
};
var _hoisted_6 = {
  class: "configurator-viewport"
};
var _hoisted_7 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("i", {
  class: "bi bi-x-circle-fill d-flex"
}, null, -1 /* HOISTED */);
var _hoisted_8 = [_hoisted_7];
var _hoisted_9 = {
  key: 1,
  class: "carousel-indicators"
};
var _hoisted_10 = ["data-bs-slide-to", "aria-current", "aria-label"];
var _hoisted_11 = {
  class: "carousel-inner-wrapper"
};
var _hoisted_12 = {
  class: "carousel-inner",
  role: "listbox"
};
var _hoisted_13 = {
  key: 0,
  class: "carousel-item active",
  id: "selected-image-background"
};
var _hoisted_14 = ["src"];
var _hoisted_15 = ["height", "src", "data-src"];
var _hoisted_16 = {
  key: 2,
  class: "carousel-control-prev",
  type: "button",
  "data-bs-target": "#viewportCarousel",
  "data-bs-slide": "prev"
};
var _hoisted_17 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  class: "carousel-control-prev-icon",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_18 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  class: "visually-hidden"
}, "Previous", -1 /* HOISTED */);
var _hoisted_19 = [_hoisted_17, _hoisted_18];
var _hoisted_20 = {
  key: 3,
  class: "carousel-control-next",
  type: "button",
  "data-bs-target": "#viewportCarousel",
  "data-bs-slide": "next"
};
var _hoisted_21 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  class: "carousel-control-next-icon",
  "aria-hidden": "true"
}, null, -1 /* HOISTED */);
var _hoisted_22 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  class: "visually-hidden"
}, "Next", -1 /* HOISTED */);
var _hoisted_23 = [_hoisted_21, _hoisted_22];
var _hoisted_24 = {
  key: 4,
  class: "controls d-flex justify-content-end"
};
var _hoisted_25 = {
  key: 0
};
var _hoisted_26 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "spinner-border",
  role: "status"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  class: "visually-hidden"
}, "Loading...")], -1 /* HOISTED */);
var _hoisted_27 = [_hoisted_26];
var _hoisted_28 = {
  key: 1,
  class: "d-flex flex-column justify-content-center"
};
var _hoisted_29 = {
  key: 5,
  class: "product-gallery__thumbnails",
  "aria-hidden": "true"
};
var _hoisted_30 = {
  class: "product-gallery__thumbnails-holder"
};
var _hoisted_31 = ["data-index"];
var _hoisted_32 = {
  class: "lazy-image lazy-image--small lazy-image--fit thumbnail__image lazyloaded"
};
var _hoisted_33 = ["src"];
var _hoisted_34 = {
  class: "thumbnail__badge"
};
var _hoisted_35 = {
  class: "d-flex flex-column justify-content-between mb-0"
};
var _hoisted_36 = {
  class: "text-muted d-flex flex-row justify-content-start"
};
var _hoisted_37 = {
  class: "me-2"
};
var _hoisted_38 = {
  class: "product__title heading-size--page-title"
};
var _hoisted_39 = ["innerHTML"];
var _hoisted_40 = {
  class: "sidebar-widget sidebar-widget--outline"
};
var _hoisted_41 = {
  class: "sidebar-widget__title font-display"
};
var _hoisted_42 = {
  class: "sidebar-widget__content"
};
var _hoisted_43 = {
  class: "product-variants no-js-hidden"
};
var _hoisted_44 = ["data-bs-target"];
var _hoisted_45 = {
  class: "font-text"
};
var _hoisted_46 = ["id"];
var _hoisted_47 = {
  class: "modal-dialog modal-lg modal-dialog-scrollable modal-fullscreen-sm-down"
};
var _hoisted_48 = {
  class: "modal-content"
};
var _hoisted_49 = {
  class: "modal-header"
};
var _hoisted_50 = {
  class: "modal-title fw-normal",
  id: "helperModal"
};
var _hoisted_51 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */);
var _hoisted_52 = {
  class: "modal-body p-4"
};
var _hoisted_53 = ["innerHTML"];
var _hoisted_54 = {
  key: 0
};
var _hoisted_55 = ["src"];
var _hoisted_56 = {
  key: 1
};
var _hoisted_57 = {
  key: 0
};
var _hoisted_58 = {
  class: "fw-bold"
};
var _hoisted_59 = {
  class: "product-variant__container product-variant__container--radio product-variant__container--radio--wrap",
  "data-js-product-variant-container": "radio"
};
var _hoisted_60 = ["onClick"];
var _hoisted_61 = ["name", "id", "onUpdate:modelValue", "checked"];
var _hoisted_62 = ["for"];
var _hoisted_63 = {
  class: "d-flex justify-content-between font-display"
};
var _hoisted_64 = {
  class: "me-1"
};
var _hoisted_65 = {
  class: "mt-3"
};
var _hoisted_66 = {
  class: "fw-bold"
};
var _hoisted_67 = {
  key: 0,
  class: "product-variant__container product-variant__container--radio product-variant__container--radio--wrap",
  "data-js-product-variant-container": "radio"
};
var _hoisted_68 = ["onClick"];
var _hoisted_69 = ["name", "id", "onUpdate:modelValue", "checked"];
var _hoisted_70 = ["for"];
var _hoisted_71 = {
  class: "d-flex justify-content-between font-display"
};
var _hoisted_72 = {
  class: "me-1"
};
var _hoisted_73 = {
  class: "ms-1 text-muted"
};
var _hoisted_74 = {
  class: "product-variant__container product-variant__container--radio product-variant__container--radio--wrap",
  "data-js-product-variant-container": "radio"
};
var _hoisted_75 = ["onClick"];
var _hoisted_76 = ["name", "id", "onUpdate:modelValue", "checked"];
var _hoisted_77 = ["for"];
var _hoisted_78 = {
  class: "d-flex justify-content-between font-display"
};
var _hoisted_79 = {
  class: "me-1"
};
var _hoisted_80 = {
  class: "ms-1 text-muted"
};
var _hoisted_81 = {
  class: "sidebar-widget sidebar-widget--outline"
};
var _hoisted_82 = {
  class: "sidebar-widget__title font-display"
};
var _hoisted_83 = {
  class: "sidebar-widget__content"
};
var _hoisted_84 = {
  class: "product-variants no-js-hidden"
};
var _hoisted_85 = ["data-bs-target"];
var _hoisted_86 = {
  class: "font-text"
};
var _hoisted_87 = ["id"];
var _hoisted_88 = {
  class: "modal-dialog modal-lg modal-dialog-scrollable modal-fullscreen-sm-down"
};
var _hoisted_89 = {
  class: "modal-content"
};
var _hoisted_90 = {
  class: "modal-header"
};
var _hoisted_91 = {
  class: "modal-title fw-normal",
  id: "helperModal"
};
var _hoisted_92 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */);
var _hoisted_93 = {
  class: "modal-body p-4"
};
var _hoisted_94 = ["innerHTML"];
var _hoisted_95 = {
  key: 0
};
var _hoisted_96 = ["src"];
var _hoisted_97 = {
  key: 1
};
var _hoisted_98 = {
  key: 0,
  class: "product-variant__container product-variant__container--radio product-variant__container--radio--wrap",
  "data-js-product-variant-container": "radio"
};
var _hoisted_99 = ["onClick"];
var _hoisted_100 = ["name", "id", "onUpdate:modelValue", "checked"];
var _hoisted_101 = {
  "f:for": "v.id",
  class: "product-variant__label text-size--small"
};
var _hoisted_102 = {
  class: "d-flex justify-content-between font-display"
};
var _hoisted_103 = {
  class: "me-1 option-wrap"
};
var _hoisted_104 = {
  class: "ms-1 text-muted"
};
var _hoisted_105 = {
  class: "w-100 mt-4"
};
var _hoisted_106 = {
  class: "mb-0"
};
var _hoisted_107 = {
  class: "text-muted"
};
var _hoisted_108 = {
  class: "continue"
};
var _hoisted_109 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", null, "Looking Good.", -1 /* HOISTED */);
var _hoisted_110 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "mt-4"
}, " You can hang on the code below to come back to this build later. Please note that custom configurations cannot be changed after ordering. ", -1 /* HOISTED */);
var _hoisted_111 = {
  class: "build-code-container d-flex"
};
var _hoisted_112 = {
  class: "m-0"
};
var _hoisted_113 = {
  class: "text-muted d-flex justify-content-between",
  style: {
    "line-height": "2rem"
  }
};
var _hoisted_114 = ["value"];
var _hoisted_115 = {
  key: 0,
  class: "text-success bi bi-check-circle"
};
var _hoisted_116 = {
  key: 1,
  class: "bi bi-pencil-square"
};
var _hoisted_117 = {
  class: "price-display-container container pe-lg-0"
};
var _hoisted_118 = {
  class: "row mb-3"
};
var _hoisted_119 = {
  class: "col-12 col-lg-4 offset-lg-8 price-display"
};
var _hoisted_120 = {
  key: 0,
  class: "d-flex flex-column justify-content-around"
};
var _hoisted_121 = {
  class: "row mb-3"
};
var _hoisted_122 = {
  class: "col-6"
};
var _hoisted_123 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "p-0"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "text-start fle mb-1"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("i", {
  class: "bi bi-calendar2-event me-1"
}), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Estimated Ship ")])])], -1 /* HOISTED */);
var _hoisted_124 = {
  class: "text-start fle fw-bold mb-0"
};
var _hoisted_125 = {
  class: "col-6",
  style: {
    "border-left": "1px solid #bcbcbc"
  }
};
var _hoisted_126 = {
  class: "p-0 d-flex flex-column justify-content-center h-100"
};
var _hoisted_127 = {
  class: "text-start fle fw-light mb-0"
};
var _hoisted_128 = ["id"];
var _hoisted_129 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
  type: "hidden",
  name: "form_type",
  value: "product"
}, null, -1 /* HOISTED */);
var _hoisted_130 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
  type: "hidden",
  name: "utf8",
  value: "✓"
}, null, -1 /* HOISTED */);
var _hoisted_131 = ["id"];
var _hoisted_132 = {
  key: 1,
  class: "d-flex flex-column justify-content-start"
};
var _hoisted_133 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("button", {
  disabled: "",
  class: "add-btn btn btn-dark"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "m-0 fw-bold"
}, "Add to Bag")], -1 /* HOISTED */);
var _hoisted_134 = {
  class: "text-center"
};
var _hoisted_135 = {
  key: 1,
  class: "d-flex flex-column justify-content-around"
};
var _hoisted_136 = {
  class: "row p-1"
};
var _hoisted_137 = {
  class: "col-6"
};
var _hoisted_138 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h5", {
  class: "text-start fle fw-bold mb-1"
}, "Coming Soon", -1 /* HOISTED */);
var _hoisted_139 = {
  class: "p-0 text-start fle mb-1",
  style: {
    "font-size": "0.94em"
  }
};
var _hoisted_140 = {
  class: "col-6",
  style: {
    "border-left": "1px solid #bcbcbc"
  }
};
var _hoisted_141 = {
  class: "p-0 d-flex flex-column justify-content-center h-100"
};
var _hoisted_142 = {
  class: "text-start fle fw-light mb-0"
};
var _hoisted_143 = {
  class: "build-code-modal modal fade",
  id: "codeModal",
  tabindex: "-1",
  "aria-labelledby": "codeModalLabel",
  "aria-hidden": "true"
};
var _hoisted_144 = {
  class: "modal-dialog modal-md modal-fullscreen-sm-down"
};
var _hoisted_145 = {
  class: "modal-content py-3"
};
var _hoisted_146 = {
  class: "modal-body text-start d-flex flex-row justify-content-center"
};
var _hoisted_147 = {
  class: "d-flex flex-column"
};
var _hoisted_148 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h2", {
  class: "fw-bold"
}, "Enter your build code", -1 /* HOISTED */);
var _hoisted_149 = ["placeholder"];
var _hoisted_150 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("button", {
  type: "submit",
  disabled: "",
  class: "btn-outline-dark",
  style: {
    "display": "none"
  },
  "aria-hidden": "true"
}, null, -1 /* HOISTED */);
function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_theme_symbols = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("theme-symbols");
  var _component_helper_video = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("helper-video");
  var _component_add_to_bag = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("add-to-bag");
  return $data.keyboard ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_1, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_2, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_3, [_hoisted_4, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" VIEWPORT "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_5, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_6, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" IMAGE CAROUSEL "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    id: "viewportCarousel",
    class: (0,shared_esm_bundler/* normalizeClass */.C4)([[$options.aspectRatioClass, {
      'carousel-dark': $options.needsDark
    }], "carousel slide carousel-fade"]),
    "data-bs-interval": "500",
    "data-ride": "true"
  }, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" Close button "), $data.selectedImage ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("button", {
    key: 0,
    class: "close-button",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.closeImage && $options.closeImage(...arguments);
    })
  }, _hoisted_8)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), !$data.selectedImage ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_9, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($data.keyboard.angles, function (angle, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("button", {
      key: angle,
      type: "button",
      "data-bs-target": "#viewportCarousel",
      "data-bs-slide-to": index,
      class: (0,shared_esm_bundler/* normalizeClass */.C4)({
        active: index === 0
      }),
      "aria-current": index === 0,
      "aria-label": 'Slide' + (index + 1)
    }, null, 10 /* CLASS, PROPS */, _hoisted_10);
  }), 128 /* KEYED_FRAGMENT */))])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_11, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_12, [$data.selectedImage ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_13, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    id: "selected-image",
    src: $data.images[$data.selectedImage],
    alt: "Selected image",
    class: "d-block w-100 img-fluid"
  }, null, 8 /* PROPS */, _hoisted_14)])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, {
    key: 1
  }, (0,runtime_core_esm_bundler/* renderList */.pI)($data.keyboard.angles, function (angle, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: angle,
      class: (0,shared_esm_bundler/* normalizeClass */.C4)(["carousel-item", {
        active: index === 0
      }])
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      width: "820",
      height: $props.imgHeight,
      src: $options.renderUrl,
      "data-src": $options.renderUrl,
      onLoad: _cache[1] || (_cache[1] = function ($event) {
        return $options.renderLoaded();
      }),
      class: "d-block w-100 img-fluid",
      alt: "..."
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15)], 2 /* CLASS */);
  }), 128 /* KEYED_FRAGMENT */))])]), !$data.selectedImage ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("button", _hoisted_16, _hoisted_19)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), !$data.selectedImage ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("button", _hoisted_20, _hoisted_23)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" CONTROLS "), !$data.selectedImage ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_24, [$data.loadingRender ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_25, [(0,runtime_core_esm_bundler/* createVNode */.bF)(runtime_dom_esm_bundler/* Transition */.eB, {
    name: "spinner"
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
        class: (0,shared_esm_bundler/* normalizeClass */.C4)([{
          'text-dark': $options.needsDark
        }, "control"])
      }, _hoisted_27, 2 /* CLASS */)];
    }),
    _: 1 /* STABLE */
  })])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_28, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", null, (0,shared_esm_bundler/* toDisplayString */.v_)($options.weight) + " lbs", 1 /* TEXT */)]))])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" Media Api Thumbnails "), $data.images.length > 0 && $props.showThumbnails ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_29, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_30, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($data.images, function (image, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("button", {
      key: index,
      class: "thumbnail element--border-radius",
      "data-index": index,
      tabindex: 0
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("figure", _hoisted_32, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      src: image,
      alt: "keyboard",
      loading: "lazy",
      sizes: "100px",
      width: "1640",
      height: "1230"
    }, null, 8 /* PROPS */, _hoisted_33)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_34, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_theme_symbols, {
      icon: "badge-model-thumbnail"
    })])], 8 /* PROPS */, _hoisted_31);
  }), 128 /* KEYED_FRAGMENT */))])])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" DISCLAIMER "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    class: (0,shared_esm_bundler/* normalizeClass */.C4)(["render-disclaimer text-muted", {
      'with-thumbnails': $data.images.length > 0 && $props.showThumbnails
    }])
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, "Actual finishes may appear different from " + (0,shared_esm_bundler/* toDisplayString */.v_)($options.rendersOrImages) + " shown.", 1 /* TEXT */)], 2 /* CLASS */)], 2 /* CLASS */)])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" OPTIONS "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    class: (0,shared_esm_bundler/* normalizeClass */.C4)(["col-12 col-md-4 configurator-options product-text pe-lg-0", [$data.keyboard.name == 'envoy' ? 'configurator-options-envoy' : 'configurator-options']])
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_35, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", _hoisted_36, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_37, "BUILDCODE // " + (0,shared_esm_bundler/* toDisplayString */.v_)($options.buildCode.toUpperCase()), 1 /* TEXT */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
    type: "button",
    class: "text-decoration-underline text-start",
    onClick: _cache[2] || (_cache[2] = function () {
      return $options.openCodeModal && $options.openCodeModal(...arguments);
    })
  }, " edit ")]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", _hoisted_38, (0,shared_esm_bundler/* toDisplayString */.v_)($props.title), 1 /* TEXT */)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    class: "ms-2",
    innerHTML: $props.description
  }, null, 8 /* PROPS */, _hoisted_39)]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" KEYBOARD CONFIGURATION OPTIONS "), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($data.productsCalc.filter(function (p) {
    return !$data.keyboard.excludedProducts.includes(p.title);
  }), function (p, index) {
    var _p$helper, _p$helper2, _p$helper3;
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      class: "option-set mt-4",
      key: index
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_40, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_41, " Select Your " + (0,shared_esm_bundler/* toDisplayString */.v_)($options.removeProductName(p.title)), 1 /* TEXT */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_42, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_43, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" HOW TO CHOOSE "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [p.helper ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("a", {
      key: 0,
      type: "button",
      "data-bs-toggle": "modal",
      "data-bs-target": '#' + p.handle + '-detail'
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", _hoisted_45, (0,shared_esm_bundler/* toDisplayString */.v_)(p.helper.prompt), 1 /* TEXT */)], 8 /* PROPS */, _hoisted_44)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" PRODUCT DESCRIPTION MODAL "), p.helper ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: 1,
      class: "modal fade",
      id: "".concat(p.handle, "-detail"),
      tabindex: "-1",
      "aria-labelledby": "helperModal",
      "aria-hidden": "true"
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_47, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_48, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_49, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h3", _hoisted_50, (0,shared_esm_bundler/* toDisplayString */.v_)(p.helper.title), 1 /* TEXT */), _hoisted_51]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_52, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
      innerHTML: $options.convertToHTML((_p$helper = p.helper) === null || _p$helper === void 0 ? void 0 : _p$helper.description)
    }, null, 8 /* PROPS */, _hoisted_53), (_p$helper2 = p.helper) !== null && _p$helper2 !== void 0 && _p$helper2.image_url ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_54, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      class: "img img-fluid",
      width: "820",
      src: p.helper.image_url
    }, null, 8 /* PROPS */, _hoisted_55)])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (_p$helper3 = p.helper) !== null && _p$helper3 !== void 0 && _p$helper3.video_url ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_56, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_helper_video, {
      ref_for: true,
      ref: "".concat(p.handle, "-helper-video"),
      "video-url": p.helper.video_url
    }, null, 8 /* PROPS */, ["video-url"])])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)])])])], 8 /* PROPS */, _hoisted_46)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" MULTIPLE OPTIONS "), p.variants[0].option2 ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_57, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", _hoisted_58, (0,shared_esm_bundler/* toDisplayString */.v_)(p.options[1]), 1 /* TEXT */)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_59, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.extractOptions(p), function (children, parent, i) {
      return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
        key: parent,
        onClick: function onClick(e) {
          $data.selectedParents[p.id] = parent;
          $options.setSelectedOption(p.id, parent);
        },
        class: (0,shared_esm_bundler/* normalizeClass */.C4)(["product-variant__item product-variant__item--radio", [$data.selectedParents[p.id] === parent ? 'checked' : 'unchecked']])
      }, [(0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
        type: "radio",
        class: "form-check-input product-variant__input product-variant-value",
        name: parent + index,
        id: parent + index,
        autocomplete: "off",
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return $data.selectedParents[p.id] = $event;
        },
        checked: $data.selectedParents[p.id] === parent
      }, null, 8 /* PROPS */, _hoisted_61), [[runtime_dom_esm_bundler/* vModelRadio */.XL, $data.selectedParents[p.id]]]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("label", {
        for: parent,
        class: "product-variant__label text-size--small"
      }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_63, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_64, (0,shared_esm_bundler/* toDisplayString */.v_)(parent), 1 /* TEXT */)])], 8 /* PROPS */, _hoisted_62)], 10 /* CLASS, PROPS */, _hoisted_60);
    }), 128 /* KEYED_FRAGMENT */))]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_65, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", _hoisted_66, (0,shared_esm_bundler/* toDisplayString */.v_)(p.options[0]), 1 /* TEXT */)]), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.extractOptions(p), function (children, parent) {
      return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
        key: parent
      }, [parent === $data.selectedParents[p.id] ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_67, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(children, function (v) {
        return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
          key: v,
          onClick: function onClick($event) {
            return $options.updateSelection(p.id, v);
          },
          class: (0,shared_esm_bundler/* normalizeClass */.C4)(["product-variant__item product-variant__item--radio", [$data.selections[p.id].id === v.id ? 'checked' : 'unchecked', v.instock || !$props.available ? '' : 'unavailable']])
        }, [(0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
          type: "radio",
          class: "form-check-input product-variant__input product-variant-value",
          name: p.id,
          id: v.id,
          autocomplete: "off",
          "onUpdate:modelValue": function onUpdateModelValue($event) {
            return $data.selections[p.id] = $event;
          },
          checked: $data.selections[p.id].id === v.id
        }, null, 8 /* PROPS */, _hoisted_69), [[runtime_dom_esm_bundler/* vModelRadio */.XL, $data.selections[p.id]]]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("label", {
          for: v.id,
          class: "product-variant__label text-size--small"
        }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_71, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_72, (0,shared_esm_bundler/* toDisplayString */.v_)(v.title.split('/')[0]), 1 /* TEXT */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_73, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, (0,shared_esm_bundler/* toDisplayString */.v_)($options.getVariantCost(v, p.price_min)), 1 /* TEXT */)])])], 8 /* PROPS */, _hoisted_70)], 10 /* CLASS, PROPS */, _hoisted_68);
      }), 128 /* KEYED_FRAGMENT */))])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)]);
    }), 128 /* KEYED_FRAGMENT */))])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, {
      key: 1
    }, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SINGLE OPTION "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_74, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(p.variants.filter(function (v) {
      return !$data.keyboard.excludedVariants.includes(v.sku);
    }), function (v) {
      return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
        key: v.id,
        onClick: function onClick($event) {
          return $options.updateSelection(p.id, v);
        },
        class: (0,shared_esm_bundler/* normalizeClass */.C4)(["product-variant__item product-variant__item--radio", [v.instock || !$props.available ? '' : 'unavailable']])
      }, [(0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
        type: "radio",
        class: "form-check-input product-variant__input product-variant-value",
        name: p.id,
        id: v.id,
        autocomplete: "off",
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return $data.selections[p.id] = $event;
        },
        checked: $data.selections[p.id].id === v.id
      }, null, 8 /* PROPS */, _hoisted_76), [[runtime_dom_esm_bundler/* vModelRadio */.XL, $data.selections[p.id]]]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("label", {
        for: v.id,
        class: "product-variant__label text-size--small"
      }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_78, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_79, (0,shared_esm_bundler/* toDisplayString */.v_)(v.title), 1 /* TEXT */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_80, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, (0,shared_esm_bundler/* toDisplayString */.v_)($options.getVariantCost(v, p.price_min)), 1 /* TEXT */)])])], 8 /* PROPS */, _hoisted_77)], 10 /* CLASS, PROPS */, _hoisted_75);
    }), 128 /* KEYED_FRAGMENT */))])], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))])])])])]);
  }), 128 /* KEYED_FRAGMENT */)), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" COMPONENT OPTIONS "), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($data.keyboard.components, function (component) {
    var _component$product$he, _component$product$he2, _component$product$he3;
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: component.type,
      class: "option-set mt-4"
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_81, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_82, (0,shared_esm_bundler/* toDisplayString */.v_)(component.title), 1 /* TEXT */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_83, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_84, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" HOW TO CHOOSE "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [component.product && component.product.helper ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("a", {
      key: 0,
      type: "button",
      "data-bs-toggle": "modal",
      "data-bs-target": '#' + component.type + '-detail'
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", _hoisted_86, (0,shared_esm_bundler/* toDisplayString */.v_)(component.product.helper.prompt), 1 /* TEXT */)], 8 /* PROPS */, _hoisted_85)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" COMPONENT DESCRIPTION MODAL "), component.product && component.product.helper ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: 1,
      class: "modal fade",
      id: "".concat(component.type, "-detail"),
      tabindex: "-1",
      "aria-labelledby": "helperModal",
      "aria-hidden": "true"
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_88, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_89, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_90, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h3", _hoisted_91, (0,shared_esm_bundler/* toDisplayString */.v_)(component.product.helper.title), 1 /* TEXT */), _hoisted_92]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_93, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
      innerHTML: $options.convertToHTML((_component$product$he = component.product.helper) === null || _component$product$he === void 0 ? void 0 : _component$product$he.description)
    }, null, 8 /* PROPS */, _hoisted_94), (_component$product$he2 = component.product.helper) !== null && _component$product$he2 !== void 0 && _component$product$he2.imageUrl ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_95, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      class: "img img-fluid",
      width: "820",
      src: component.product.helper.imageUrl
    }, null, 8 /* PROPS */, _hoisted_96)])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (_component$product$he3 = component.product.helper) !== null && _component$product$he3 !== void 0 && _component$product$he3.video_url ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_97, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_helper_video, {
      ref_for: true,
      ref: "".concat(component.type, "-helper-video"),
      "video-url": component.product.helper.video_url
    }, null, 8 /* PROPS */, ["video-url"])])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)])])])], 8 /* PROPS */, _hoisted_87)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" OPTIONS "), component.product ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_98, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(component.product.variants, function (v) {
      return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
        key: v.id,
        onClick: function onClick($event) {
          return $options.updateComponentsSelection(component.product.id, v);
        },
        class: (0,shared_esm_bundler/* normalizeClass */.C4)(["product-variant__item product-variant__item--radio", [v.instock || !$props.available ? '' : 'unavailable']])
      }, [(0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
        type: "radio",
        class: "form-check-input product-variant__input product-variant-value",
        name: component.product.id,
        id: v.id,
        autocomplete: "off",
        "onUpdate:modelValue": function onUpdateModelValue($event) {
          return $data.componentSelections[component.type] = $event;
        },
        checked: $data.componentSelections[component.type].id === v.id
      }, null, 8 /* PROPS */, _hoisted_100), [[runtime_dom_esm_bundler/* vModelRadio */.XL, $data.componentSelections[component.type]]]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("label", _hoisted_101, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_102, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_103, (0,shared_esm_bundler/* toDisplayString */.v_)(component.renameFunction(v.name)), 1 /* TEXT */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_104, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, (0,shared_esm_bundler/* toDisplayString */.v_)($options.formatPrice(v.originalPrice)), 1 /* TEXT */)])])])], 10 /* CLASS, PROPS */, _hoisted_99);
    }), 128 /* KEYED_FRAGMENT */)), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_105, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", _hoisted_106, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", _hoisted_107, (0,shared_esm_bundler/* toDisplayString */.v_)(component.subtitle), 1 /* TEXT */)])])])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)])])])])]);
  }), 128 /* KEYED_FRAGMENT */)), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" CONTINUE "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_108, [_hoisted_109, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" BUILD CODE "), _hoisted_110, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_111, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_112, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", _hoisted_113, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
    type: "text",
    disabled: "",
    id: "buildCode",
    value: $options.buildCode,
    class: "build-code pe-1"
  }, null, 8 /* PROPS */, _hoisted_114)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("button", {
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.copy('buildCode');
    }),
    class: "btn p-0 m-0",
    style: {
      "margin-left": "-16px !important"
    }
  }, [$data.copied ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("i", _hoisted_115)) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("i", _hoisted_116))])])])])])], 2 /* CLASS */), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" PRICE DISPLAY "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_117, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_118, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_119, [$props.available ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_120, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_121, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_122, [_hoisted_123, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", _hoisted_124, (0,shared_esm_bundler/* toDisplayString */.v_)($data.estimatedShipDateCalc), 1 /* TEXT */)])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_125, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_126, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h3", _hoisted_127, (0,shared_esm_bundler/* toDisplayString */.v_)($options.formatPrice($options.price)), 1 /* TEXT */)])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" ADD TO BAG "), $options.incompatibilities.length == 0 ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("form", {
    key: 0,
    id: $options.configId,
    method: "post",
    action: "/cart/add",
    class: "shopify-product-form d-flex justify-content-start",
    "accept-charset": "UTF-8",
    enctype: "multipart/form-data",
    novalidate: ""
  }, [_hoisted_129, _hoisted_130, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
    type: "hidden",
    name: "quantity",
    id: $options.configId + '-quantity-selector',
    value: "1",
    min: "1"
  }, null, 8 /* PROPS */, _hoisted_131), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_add_to_bag, {
    wide: true,
    lightMode: true,
    variants: $options.cartVariants,
    buildCode: $options.buildCode,
    cyb: $props.cybUrl
  }, null, 8 /* PROPS */, ["variants", "buildCode", "cyb"])], 8 /* PROPS */, _hoisted_128)) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_132, [_hoisted_133, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", _hoisted_134, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.incompatibilities, function (i, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("span", {
      class: "mb-0",
      key: index
    }, (0,shared_esm_bundler/* toDisplayString */.v_)(i), 1 /* TEXT */);
  }), 128 /* KEYED_FRAGMENT */))])]))])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", _hoisted_135, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_136, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_137, [_hoisted_138, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", _hoisted_139, " Pre-order June 26. Estimated to ship " + (0,shared_esm_bundler/* toDisplayString */.v_)($data.estimatedShipDateCalc) + ". ", 1 /* TEXT */)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_140, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_141, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h3", _hoisted_142, (0,shared_esm_bundler/* toDisplayString */.v_)($options.formatPrice($options.price)), 1 /* TEXT */)])])])]))])])])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" BUILD CODE MODAL "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_143, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_144, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_145, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_146, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("form", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", _hoisted_147, [_hoisted_148, (0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
    type: "text",
    class: "form-control text-start mb-4 text-uppercase",
    size: "18",
    placeholder: $options.buildCode,
    id: "codeInput",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.newCode = $event;
    }),
    maxlength: "21",
    minlength: "12"
  }, null, 8 /* PROPS */, _hoisted_149), [[runtime_dom_esm_bundler/* vModelText */.Jo, $data.newCode]]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" PREVENT SUBMIT ON ENTER "), _hoisted_150, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("button", {
    onClick: _cache[5] || (_cache[5] = function ($event) {
      return $options.updateBuildCode($data.newCode);
    }),
    type: "button",
    class: "btn btn-outline-dark"
  }, " Submit ")])])])])])])])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true);
}
;// CONCATENATED MODULE: ./src/Apps/ConfiguratorV3.vue?vue&type=template&id=583bd1f9

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/js/bootstrap.esm.js + 57 modules
var bootstrap_esm = __webpack_require__(336);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/AddToBag.vue?vue&type=template&id=360d5fea

var AddToBagvue_type_template_id_360d5fea_hoisted_1 = {
  class: "product--add-to-cart-form style--minimal w-100",
  "data-type": "overlay"
};
var AddToBagvue_type_template_id_360d5fea_hoisted_2 = ["id"];
var AddToBagvue_type_template_id_360d5fea_hoisted_3 = ["disabled"];
var AddToBagvue_type_template_id_360d5fea_hoisted_4 = {
  class: "button__text mb-0"
};
var AddToBagvue_type_template_id_360d5fea_hoisted_5 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  class: "button__preloader"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("svg", {
  class: "button__preloader-element",
  viewBox: "25 25 50 50"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("circle", {
  cx: "50",
  cy: "50",
  r: "20",
  fill: "none",
  "stroke-width": "4"
})])], -1 /* HOISTED */);
function AddToBagvue_type_template_id_360d5fea_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", AddToBagvue_type_template_id_360d5fea_hoisted_1, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    id: $data.id,
    class: "shopify-product-form"
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("button", {
    name: "add",
    type: "submit",
    "data-js-product-add-to-cart": "",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.addToBag($event);
    }),
    disabled: !$data.available,
    class: (0,shared_esm_bundler/* normalizeClass */.C4)([[$props.lightMode ? 'btn-dark' : 'btn-light', $props.wide ? 'w-100' : ''], "btn py-1 add-btn add-to-cart button--loader button--solid"])
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", AddToBagvue_type_template_id_360d5fea_hoisted_4, (0,shared_esm_bundler/* toDisplayString */.v_)($options.btnText), 1 /* TEXT */), AddToBagvue_type_template_id_360d5fea_hoisted_5], 10 /* CLASS, PROPS */, AddToBagvue_type_template_id_360d5fea_hoisted_3)], 8 /* PROPS */, AddToBagvue_type_template_id_360d5fea_hoisted_2)]);
}
;// CONCATENATED MODULE: ./src/components/AddToBag.vue?vue&type=template&id=360d5fea

// EXTERNAL MODULE: ./node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var reactivity_esm_bundler = __webpack_require__(953);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/AddToBag.vue?vue&type=script&lang=js
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

/* harmony default export */ const AddToBagvue_type_script_lang_js = ({
  name: "add-to-bag",
  props: {
    variants: Array,
    buildCode: String,
    lightMode: Boolean,
    wide: Boolean,
    cyb: String
  },
  setup(props) {
    var localVariants = (0,reactivity_esm_bundler/* ref */.KR)([...props.variants]);

    // Create a derived array of "id" values
    var ids = (0,runtime_core_esm_bundler/* computed */.EW)(function () {
      return props.variants.map(function (variant) {
        return variant.id;
      });
    });
    (0,runtime_core_esm_bundler/* watch */.wB)(ids, function (newIds, oldIds) {
      if (JSON.stringify(newIds) !== JSON.stringify(oldIds)) {
        localVariants.value = [...props.variants];
      }
    });
    return {
      localVariants
    };
  },
  data() {
    var available = true;
    var preOrder = false;
    this.variants.forEach(function (v) {
      if (!v.available) {
        available = false;
      }
      if (v.estimatedShipDate) {
        preOrder = true;
      }
    });
    return {
      available,
      id: performance.now().toString().replace(".", ""),
      preOrder,
      adding: false
    };
  },
  computed: {
    btnText() {
      var multiple = this.variants.length > 1;
      var preOrder = this.preOrder;
      var available = this.available;
      if (!available) return "Out of Stock";
      // if (preOrder && multiple) return "Preorder All";
      // if (preOrder) return "Preorder";
      if (multiple) return "Add all to bag";
      return "Add to bag";
    },
    items() {
      var items = this.variants.map(function (v) {
        var item = {
          id: v.id,
          quantity: 1,
          properties: v.properties
        };
        return item;
      });
      return items;
    }
  },
  methods: {
    addToBag(e) {
      var _this = this;
      return _asyncToGenerator(function* () {
        e.preventDefault();
        var addToCartForm = document.getElementById(_this.id);
        var submitButton = addToCartForm.querySelector("[data-js-product-add-to-cart]");
        submitButton.classList.add("working");
        for (var item of _this.items) {
          if (item.id === "bundle-config") {
            var variant = yield _this.fetchBundleVariant(_this.buildCode);
            if (variant) {
              item.id = variant.legacyResourceId;
            }
          }
        }
        var body = JSON.stringify({
          items: _this.items
        });
        var itemsCount = _this.items.length;
        var headers = {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        };
        var alert = "";
        fetch("".concat(KROWN.settings.routes.cart_add_url, ".js"), {
          body: body,
          headers: headers,
          method: "POST"
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement("span");
            alert.className = "alert alert--error";
            if (typeof response.description === "string") {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
            if (_this.cartType == "page") {
              if (document.getElementById("product-page-form-error-cart-alert")) {
                document.getElementById("product-page-form-error-cart-alert").remove();
              }
              alert.style.marginTop = "1em";
              alert.style.marginBottom = "0";
              alert.id = "product-page-form-error-cart-alert";
              _this.form.parentElement.append(alert);
              return false;
            }
            return fetch("?section_id=helper-cart");
          } else {
            if (_this.cartType == "page") {
              document.location.href = KROWN.settings.routes.cart_url;
              return false;
            } else {
              return fetch("?section_id=helper-cart");
            }
          }
        }).then(function (response) {
          return response.text();
        }).then(function (text) {
          var sectionInnerHTML = new DOMParser().parseFromString(text, "text/html");
          var cartFormInnerHTML = sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
          var cartSubtotalInnerHTML = sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;
          var cartItems = document.getElementById("AjaxCartForm");
          cartItems.innerHTML = cartFormInnerHTML;
          cartItems.ajaxifyCartItems();
          if (alert != "") {
            document.getElementById("AjaxCartForm").querySelector("form").prepend(alert);
          }
          document.getElementById("AjaxCartSubtotal").innerHTML = cartSubtotalInnerHTML;
          document.querySelectorAll("[data-header-cart-count]").forEach(function (elm) {
            elm.textContent = document.querySelector("#AjaxCartForm [data-cart-count]").textContent;
          });
          document.querySelectorAll("[data-header-cart-total").forEach(function (elm) {
            elm.textContent = document.querySelector("#AjaxCartForm [data-cart-total]").textContent;
          });
        }).catch(function (e) {
          console.log(e);
        }).finally(function () {
          submitButton.classList.remove("working");
          if (_this.cyb) {
            window.location.pathname = _this.cyb.replace(window.Shopify.shop, "");
          }
        });
      })();
    },
    fetchBundleVariant(buildcode) {
      return _asyncToGenerator(function* () {
        var query = "\n        query FindVariantBySku($sku: String!) {\n          productVariants(first: 1, query: $sku) {\n            edges {\n              node {\n                id\n                legacyResourceId\n                sku\n                title\n                price\n                product {\n                  id\n                  title\n                }\n              }\n            }\n          }\n        }\n      ";
        var variables = {
          sku: buildcode
        };
        try {
          var response = yield fetch('https://238l8kaug8.execute-api.us-east-1.amazonaws.com/prod/graphql', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              query,
              variables
            })
          });
          var result = yield response.json();
          if (result.errors) {
            console.error('GraphQL errors:', result.errors);
            return null;
          }
          return result.data.productVariants[0];
        } catch (error) {
          console.error('Error fetching variant:', error);
          return null;
        }
      })();
    },
    gaTagAdd() {
      for (var v of this.variants) {
        ga("ec:addProduct", {
          id: v.id,
          name: v.name,
          price: parseFloat(v.price),
          quantity: 1
        });
        ga("ec:setAction", "add");
        ga("send", "event", "UX", "click", "add to cart");
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/components/AddToBag.vue?vue&type=script&lang=js
 
// EXTERNAL MODULE: ./node_modules/vue-loader/dist/exportHelper.js
var exportHelper = __webpack_require__(262);
;// CONCATENATED MODULE: ./src/components/AddToBag.vue




;


const __exports__ = /*#__PURE__*/(0,exportHelper/* default */.A)(AddToBagvue_type_script_lang_js, [['render',AddToBagvue_type_template_id_360d5fea_render]])

/* harmony default export */ const AddToBag = (__exports__);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/ExtrasModal.vue?vue&type=template&id=5c10f260

var ExtrasModalvue_type_template_id_5c10f260_hoisted_1 = {
  class: "extras-modal"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_2 = {
  key: 0,
  class: "btn btn-extra btn-link me-2"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_3 = ["data-bs-target"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_4 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "m-0"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, "Add Extra")], -1 /* HOISTED */);
var ExtrasModalvue_type_template_id_5c10f260_hoisted_5 = [ExtrasModalvue_type_template_id_5c10f260_hoisted_4];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_6 = ["id"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_7 = {
  class: "modal-dialog modal-l modal-fullscreen-md-down"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_8 = {
  class: "modal-content"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_9 = {
  key: 0,
  class: "modal-header"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_10 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1 /* HOISTED */);
var ExtrasModalvue_type_template_id_5c10f260_hoisted_11 = [ExtrasModalvue_type_template_id_5c10f260_hoisted_10];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_12 = {
  class: "modal-body text-center text-md-start"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_13 = {
  key: 0,
  class: "loading"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_14 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "spinner-border",
  role: "status"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  class: "visually-hidden"
}, "Loading...")], -1 /* HOISTED */);
var ExtrasModalvue_type_template_id_5c10f260_hoisted_15 = {
  key: 1,
  class: "container"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_16 = {
  class: "row"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_17 = {
  class: "col-12"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_18 = {
  class: "modal-title mb-5"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_19 = {
  key: 0,
  class: "d-flex justify-content-between border-bottom mb-2"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_20 = ["for"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_21 = {
  class: "align-self-end"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_22 = {
  key: 1,
  class: "mb-3"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_23 = {
  class: "d-flex justify-content-between"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_24 = {
  class: "extras-label"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_25 = {
  class: "row mb-3"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_26 = ["onClick"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_27 = ["name", "id", "checked"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_28 = ["for"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_29 = {
  class: "d-flex flex-column justify-content-center"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_30 = {
  class: "mb-0"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_31 = {
  class: "fw-bold"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_32 = {
  key: 0,
  class: "row"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_33 = ["onClick"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_34 = ["name", "id", "checked"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_35 = ["for"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_36 = {
  class: "d-flex flex-column justify-content-center"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_37 = {
  class: "mb-0"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_38 = {
  class: "row mb-3"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_39 = ["onClick"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_40 = ["name", "id", "checked"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_41 = ["for"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_42 = {
  class: "mb-0"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_43 = {
  class: "product--add-to-cart-form style--minimal",
  "data-type": "overlay"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_44 = ["id"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_45 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
  type: "hidden",
  name: "form_type",
  value: "product"
}, null, -1 /* HOISTED */);
var ExtrasModalvue_type_template_id_5c10f260_hoisted_46 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
  type: "hidden",
  name: "utf8",
  value: "✓"
}, null, -1 /* HOISTED */);
var ExtrasModalvue_type_template_id_5c10f260_hoisted_47 = ["value"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_48 = ["id"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_49 = ["disabled"];
var ExtrasModalvue_type_template_id_5c10f260_hoisted_50 = {
  class: "fw-bold mb-0"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_51 = {
  key: 3,
  class: "mt-2 text-muted"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_52 = {
  class: "mt-5"
};
var ExtrasModalvue_type_template_id_5c10f260_hoisted_53 = ["innerHTML"];
function ExtrasModalvue_type_template_id_5c10f260_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_1, [$data.added ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("button", ExtrasModalvue_type_template_id_5c10f260_hoisted_2, "Added to cart.")) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("button", {
    key: 1,
    class: "btn btn-extra btn-outline-dark me-2 mt-1 px-3",
    "data-bs-toggle": "modal",
    "data-bs-target": '#' + $options.extraHandle
  }, ExtrasModalvue_type_template_id_5c10f260_hoisted_5, 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_3)), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    class: "modal fade",
    id: $options.extraHandle,
    tabindex: "-1",
    "aria-labelledby": "codeModalLabel",
    "aria-hidden": "true"
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_7, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_8, [!$data.loading ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_9, ExtrasModalvue_type_template_id_5c10f260_hoisted_11)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_12, [$data.loading ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_13, [(0,runtime_core_esm_bundler/* createVNode */.bF)(runtime_dom_esm_bundler/* Transition */.eB, {
    name: "spinner"
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [ExtrasModalvue_type_template_id_5c10f260_hoisted_14];
    }),
    _: 1 /* STABLE */
  })])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_15, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_16, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_17, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", ExtrasModalvue_type_template_id_5c10f260_hoisted_18, (0,shared_esm_bundler/* toDisplayString */.v_)($data.product.title), 1 /* TEXT */), !$options.isSingleVariant ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_19, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
    class: "extras-label mb-1",
    for: $data.product.id
  }, (0,shared_esm_bundler/* toDisplayString */.v_)($data.selection.title), 9 /* TEXT, PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_20), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", ExtrasModalvue_type_template_id_5c10f260_hoisted_21, (0,shared_esm_bundler/* toDisplayString */.v_)($options.formatPrice($data.selection.price)), 1 /* TEXT */)])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" MULTI-OPTION FORMAT TODO: Make this its own component "), $data.product.variants[0].option2 ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_22, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_23, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("label", ExtrasModalvue_type_template_id_5c10f260_hoisted_24, (0,shared_esm_bundler/* toDisplayString */.v_)($data.product.options[1]), 1 /* TEXT */)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_25, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.extractOptions($data.product), function (children, parent, i) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("span", {
      key: parent,
      class: "col-6"
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
      class: (0,shared_esm_bundler/* normalizeClass */.C4)(["form-check", [$data.selectedParents[$data.product.id] === parent ? 'checked' : 'unchecked']]),
      onClick: function onClick(e) {
        $data.selectedParents[$data.product.id] = parent;
        $options.setSelectedOption(parent);
      }
    }, [(0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
      type: "radio",
      class: "form-check-input",
      name: parent + _ctx.index,
      id: parent + _ctx.index,
      autocomplete: "off",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
        return $data.selectedParents[$data.product.id] = $event;
      }),
      checked: $data.selectedParents[$data.product.id] === parent
    }, null, 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_27), [[runtime_dom_esm_bundler/* vModelRadio */.XL, $data.selectedParents[$data.product.id]]]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("label", {
      class: "form-check-label me-4 mb-1 justify-content-start",
      for: parent
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_29, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", ExtrasModalvue_type_template_id_5c10f260_hoisted_30, (0,shared_esm_bundler/* toDisplayString */.v_)(parent), 1 /* TEXT */)])], 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_28)], 10 /* CLASS, PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_26)]);
  }), 128 /* KEYED_FRAGMENT */))]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", ExtrasModalvue_type_template_id_5c10f260_hoisted_31, (0,shared_esm_bundler/* toDisplayString */.v_)($data.product.options[0]), 1 /* TEXT */), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.extractOptions($data.product), function (children, parent) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: parent
    }, [parent === $data.selectedParents[$data.product.id] ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_32, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(children, function (v) {
      return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("span", {
        key: v,
        class: "col-6"
      }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
        class: (0,shared_esm_bundler/* normalizeClass */.C4)(["form-check", [$data.selection.id === v.id ? 'checked' : 'unchecked', $data.selection.instock ? '' : 'unavailable']]),
        onClick: function onClick($event) {
          return $options.updateSelection(v);
        }
      }, [(0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
        type: "radio",
        class: "form-check-input",
        name: $data.product.id,
        id: v.id,
        autocomplete: "off",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return $data.selection = $event;
        }),
        checked: $data.selection.id === v.id
      }, null, 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_34), [[runtime_dom_esm_bundler/* vModelRadio */.XL, $data.selection]]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("label", {
        class: "form-check-label me-4 mb-1 justify-content-start",
        for: v.id
      }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_36, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", ExtrasModalvue_type_template_id_5c10f260_hoisted_37, (0,shared_esm_bundler/* toDisplayString */.v_)(v.option1), 1 /* TEXT */)])], 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_35)], 10 /* CLASS, PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_33)]);
    }), 128 /* KEYED_FRAGMENT */))])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)]);
  }), 128 /* KEYED_FRAGMENT */))])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, {
    key: 2
  }, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SINGLE OPTION PRODUCT "), (0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_38, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($data.product.variants, function (v) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("span", {
      key: v.id,
      class: (0,shared_esm_bundler/* normalizeClass */.C4)([$data.product.variants.length < 3 ? 'col-12' : 'col-6'])
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
      class: (0,shared_esm_bundler/* normalizeClass */.C4)(["form-check", [$data.selection.id === v.id ? 'checked' : 'unchecked', $data.selection.instock ? '' : 'unavailable']]),
      onClick: function onClick($event) {
        return $options.updateSelection(v);
      }
    }, [(0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
      type: "radio",
      class: "form-check-input",
      name: $data.product.id,
      id: v.id,
      autocomplete: "off",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
        return $data.selection = $event;
      }),
      checked: $data.selection.id === v.id
    }, null, 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_40), [[runtime_dom_esm_bundler/* vModelRadio */.XL, $data.selection]]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("label", {
      class: "form-check-label me-4 mb-1 justify-content-start",
      for: v.id
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", ExtrasModalvue_type_template_id_5c10f260_hoisted_42, (0,shared_esm_bundler/* toDisplayString */.v_)(v.title), 1 /* TEXT */)], 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_41)], 10 /* CLASS, PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_39)], 2 /* CLASS */);
  }), 128 /* KEYED_FRAGMENT */))], 512 /* NEED_PATCH */), [[runtime_dom_esm_bundler/* vShow */.aG, !$options.isSingleVariant]])], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" ADD TO CART "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ExtrasModalvue_type_template_id_5c10f260_hoisted_43, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("form", {
    id: $data.product.id,
    method: "post",
    action: "/cart/add",
    class: "shopify-product-form",
    "accept-charset": "UTF-8",
    enctype: "multipart/form-data",
    novalidate: ""
  }, [ExtrasModalvue_type_template_id_5c10f260_hoisted_45, ExtrasModalvue_type_template_id_5c10f260_hoisted_46, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
    type: "hidden",
    name: "id",
    value: $data.selection.id
  }, null, 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_47), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
    type: "hidden",
    name: "quantity",
    id: $data.product.id + '-quantity-selector',
    value: "1",
    min: "1"
  }, null, 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_48), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("button", {
    name: "add",
    type: "submit",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.addToBag($data.selection, $event);
    }),
    disabled: !$data.selection.instock,
    class: "btn btn-dark w-100"
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", ExtrasModalvue_type_template_id_5c10f260_hoisted_50, (0,shared_esm_bundler/* toDisplayString */.v_)($data.selection.instock ? "Add To Bag" : "Sold Out"), 1 /* TEXT */)], 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_49)], 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_44)]), $data.selection.instock ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("p", ExtrasModalvue_type_template_id_5c10f260_hoisted_51)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", ExtrasModalvue_type_template_id_5c10f260_hoisted_52, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
    innerHTML: $data.product.description
  }, null, 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_53)])])])]))])])])], 8 /* PROPS */, ExtrasModalvue_type_template_id_5c10f260_hoisted_6)]);
}
;// CONCATENATED MODULE: ./src/components/ExtrasModal.vue?vue&type=template&id=5c10f260

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/ExtrasModal.vue?vue&type=script&lang=js
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function ExtrasModalvue_type_script_lang_js_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function ExtrasModalvue_type_script_lang_js_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { ExtrasModalvue_type_script_lang_js_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { ExtrasModalvue_type_script_lang_js_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

/* harmony default export */ const ExtrasModalvue_type_script_lang_js = ({
  name: "ExtrasModal",
  props: {
    handle: String,
    version: String
  },
  components: {},
  data() {
    return {
      added: false,
      product: undefined,
      selectedParents: {},
      loading: true,
      selection: undefined,
      html: undefined
    };
  },
  computed: {
    extraHandle() {
      console.log("version", this.version);
      return this.version === "v3" ? this.handle : this.handle.substring(0, this.handle.lastIndexOf("-"));
    },
    imageUrl() {
      if (this.selection && this.selection.featured_image) {
        return this.selection.featured_image.src;
      } else {
        return this.product.featured_image;
      }
    },
    isSingleVariant() {
      return this.product.variants[0].title === "Default Title";
    }
  },
  methods: {
    addToBag(selection, e) {
      var _this = this;
      return ExtrasModalvue_type_script_lang_js_asyncToGenerator(function* () {
        e.preventDefault();
        $("#site-cart form.cart").removeClass("cart--empty");
        var $form = document.getElementById(_this.product.id);
        var $cartCount = $(".cart-menu .count");
        var $cartQty = document.getElementById("".concat(_this.product.id, "-quantity-selector"));
        var itemName = selection.name;
        var itemPrice = selection.price;
        var itemId = selection.id;
        var cartAddRes = yield fetch("".concat(window.cart_add_url, ".json"), {
          body: window.serialize($form),
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": "XMLHttpRequest"
          }
        });
        if (cartAddRes.ok) {
          var getCartRes = yield fetch(window.cart_url, {
            credentials: "same-origin",
            method: "GET"
          });
          var html = yield getCartRes.text();
          // google pixel
          if (typeof ga !== "undefined") {
            ga("ec:addProduct", {
              id: itemId,
              name: itemName,
              price: parseFloat(itemPrice),
              quantity: $cartQty.length > 0 ? parseInt($cartQty.val()) : 1
            });
            ga("ec:setAction", "add");
            ga("send", "event", "UX", "click", "add to cart");
          }

          // totals update
          $("#site-cart .cart-items").html($(html).find(".cart-items")[0].innerHTML);
          $("#CartTotal").html($(html).find("#CartTotal").html());
          $("#CartDetails").html($(html).find("#CartDetails").html());
          $("#site-cart .cart-holder").attr("data-items", $(html).find(".cart-holder").data("items"));
          window.sidebarCartAjaxFunctions();
          if ($cartQty.length > 0) {
            var qty = parseInt($cartQty.val());
            if (qty == 1) {
              $("#site-cart .subtitle").html($("#site-cart .subtitle").data("added-singular").replace(/{{ count }}|count|{{count}}/g, qty));
            } else {
              $("#site-cart .subtitle").html($("#site-cart .subtitle").data("added-plural").replace(/{{ count }}|count|{{count}}/g, qty));
            }
            $cartCount.text(parseInt($cartCount.text()) + parseInt($cartQty.val()));
          } else {
            $cartCount.text(parseInt($cartCount.text()) + 1);
            $("#site-cart .subtitle").html($("#site-cart .subtitle").data("added-singular").replace(/{{ count }}|count|{{count}}/, 1));
          }
          _this.modal.hide();
          _this.added = true;
          setTimeout(function () {
            _this.added = false;
          }, 2500);
        } else {
          _this.modal.hide();
          cartAddRes.json().then(function (data) {
            alert("This product is no longer available.");
          });
        }
      })();
    },
    extractOptions(product) {
      var options = {};
      for (var v of product.variants) {
        if (!(v.option2 in options)) {
          options[v.option2] = [];
        }
        options[v.option2].push(v);
      }
      return options;
    },
    formatPrice(amount) {
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      });
      return formatter.format(amount / 100); // Shopfiy provides price as cents
    },
    setSelectedOption(option) {
      var variant = this.product.variants.find(function (v) {
        return v.option2 === option;
      });
      this.updateSelection(variant);
    },
    findInstockVariant(productId) {
      var variant = this.product.variants.find(function (v) {
        return v.instock;
      });
      if (variant) this.updateSelection(variant);
    },
    updateSelection(variant) {
      console.log("updateing", variant);
      if (this.selection) console.log("selection before", JSON.parse(JSON.stringify(this.selection)));
      this.selection = variant;
      this.selection = Object.assign(this.selection, _objectSpread({
        productId: this.product.id
      }, variant));
      if (this.selection) console.log("selection after", JSON.parse(JSON.stringify(this.selection)));
    }
  },
  mounted() {
    var handle = this.extraHandle;
    var extraHandle = this.extraHandle;
    console.log("getting modal by", handle, this.handle);
    var self = this;
    this.$nextTick(function () {
      var myModalEl = document.getElementById(extraHandle);
      myModalEl.addEventListener("show.bs.modal", function (event) {
        fetch("/products/".concat(handle), {
          credentials: "same-origin",
          method: "GET"
        }).then(function (response) {
          return response.text();
        }).then(function (html) {
          html = window.$(html);
          window.$("#".concat(extraHandle)).append(html.find(".productJson-".concat(extraHandle))[0]);
          window.$("#".concat(extraHandle)).append(html.find("#productJson-".concat(extraHandle))[0]);
          var productJson = JSON.parse(window.$("#".concat(extraHandle)).find(".product-json")[0].innerHTML);
          console.log("prodictJson", productJson);
          if (productJson) {
            self.product = productJson;
            self.findInstockVariant(self.product.id);
            var hasMultipleOptions = self.product.variants[0].option2 !== null;
            if (hasMultipleOptions) {
              var secondOption = self.product.variants[0].option2;
              self.selectedParents[self.product.id] = secondOption;
            }
          }
          self.loading = false;
        });
      });
    });
    this.modal = new bootstrap_esm/* Modal */.aF(document.getElementById(this.extraHandle));
  },
  watch: {}
});
;// CONCATENATED MODULE: ./src/components/ExtrasModal.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/ExtrasModal.vue




;


const ExtrasModal_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(ExtrasModalvue_type_script_lang_js, [['render',ExtrasModalvue_type_template_id_5c10f260_render]])

/* harmony default export */ const ExtrasModal = (ExtrasModal_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/DropDown.vue?vue&type=template&id=3d0c93db

var DropDownvue_type_template_id_3d0c93db_hoisted_1 = {
  class: "d-none"
};
var DropDownvue_type_template_id_3d0c93db_hoisted_2 = ["src"];
function DropDownvue_type_template_id_3d0c93db_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* renderSlot */.RG)(_ctx.$slots, "header")]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", DropDownvue_type_template_id_3d0c93db_hoisted_1, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "28",
    height: "28",
    ref: "icon",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $options.toggle();
    }),
    src: $options.icon,
    class: (0,shared_esm_bundler/* normalizeClass */.C4)([$data.show ? 'rotate-down' : 'rotate-up']),
    style: {
      "height": "70%"
    }
  }, null, 10 /* CLASS, PROPS */, DropDownvue_type_template_id_3d0c93db_hoisted_2)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    class: (0,shared_esm_bundler/* normalizeClass */.C4)([$data.show ? 'grow' : 'shrink', $props.light ? 'text-light' : 'text-dark'])
  }, [(0,runtime_core_esm_bundler/* renderSlot */.RG)(_ctx.$slots, "content")], 2 /* CLASS */)]);
}
;// CONCATENATED MODULE: ./src/components/DropDown.vue?vue&type=template&id=3d0c93db

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/DropDown.vue?vue&type=script&lang=js
/* harmony default export */ const DropDownvue_type_script_lang_js = ({
  name: "dropdown",
  props: {
    active: Boolean,
    arrow: String,
    light: {
      type: Boolean,
      default: false
    }
  },
  emits: ["toggle"],
  data() {
    return {
      show: true
    };
  },
  computed: {
    icon() {
      return this.light ? "https://mode-storefront.s3.us-east-2.amazonaws.com/sonnet/more-light.svg" : "https://mode-storefront.s3.us-east-2.amazonaws.com/more.svg";
    }
  },
  methods: {
    toggle() {
      this.show = !this.show;
      this.$emit("toggle", this.show);
    }
  },
  mounted() {
    this.show = this.active;
    document.getElementById(this.arrow).append(this.$refs.icon);
  }
});
;// CONCATENATED MODULE: ./src/components/DropDown.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/DropDown.vue




;


const DropDown_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(DropDownvue_type_script_lang_js, [['render',DropDownvue_type_template_id_3d0c93db_render]])

/* harmony default export */ const DropDown = (DropDown_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/HelperVideo.vue?vue&type=template&id=16ce8516

var HelperVideovue_type_template_id_16ce8516_hoisted_1 = ["src"];
var HelperVideovue_type_template_id_16ce8516_hoisted_2 = ["max"];
var HelperVideovue_type_template_id_16ce8516_hoisted_3 = {
  key: 0,
  ref: "playButton"
};
var HelperVideovue_type_template_id_16ce8516_hoisted_4 = ["src"];
function HelperVideovue_type_template_id_16ce8516_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
    id: "video-container",
    onMouseover: _cache[3] || (_cache[3] = function () {
      return $options.showControls && $options.showControls(...arguments);
    }),
    onMouseleave: _cache[4] || (_cache[4] = function () {
      return $options.hideControls && $options.hideControls(...arguments);
    }),
    onMousemove: _cache[5] || (_cache[5] = function () {
      return $options.resetHideControlsTimeout && $options.resetHideControlsTimeout(...arguments);
    }),
    onTouchstart: _cache[6] || (_cache[6] = function () {
      return $options.toggleControlsOnMobile && $options.toggleControlsOnMobile(...arguments);
    }),
    onClick: _cache[7] || (_cache[7] = function () {
      return $options.togglePlay && $options.togglePlay(...arguments);
    })
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("video", {
    ref: "videoPlayer",
    width: "1920",
    height: "1080",
    style: {
      "border-radius": "8px"
    },
    onTimeupdate: _cache[0] || (_cache[0] = function () {
      return $options.updateSeekBar && $options.updateSeekBar(...arguments);
    })
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("source", {
    src: $props.videoUrl,
    type: "video/mp4"
  }, null, 8 /* PROPS */, HelperVideovue_type_template_id_16ce8516_hoisted_1), (0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Your browser does not support the video tag. ")], 544 /* NEED_HYDRATION, NEED_PATCH */), (0,runtime_core_esm_bundler/* withDirectives */.bo)((0,runtime_core_esm_bundler/* createElementVNode */.Lk)("input", {
    type: "range",
    min: "0",
    max: $data.videoDuration,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return $data.currentTime = $event;
    }),
    onInput: _cache[2] || (_cache[2] = function () {
      return $options.seekVideo && $options.seekVideo(...arguments);
    })
  }, null, 40 /* PROPS, NEED_HYDRATION */, HelperVideovue_type_template_id_16ce8516_hoisted_2), [[runtime_dom_esm_bundler/* vModelText */.Jo, $data.currentTime]]), (0,runtime_core_esm_bundler/* createVNode */.bF)(runtime_dom_esm_bundler/* Transition */.eB, {
    name: "fade"
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [$data.showButton ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("button", HelperVideovue_type_template_id_16ce8516_hoisted_3, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
        src: $options.buttonIcon,
        alt: "Play/Pause"
      }, null, 8 /* PROPS */, HelperVideovue_type_template_id_16ce8516_hoisted_4)], 512 /* NEED_PATCH */)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)];
    }),
    _: 1 /* STABLE */
  })], 32 /* NEED_HYDRATION */);
}
;// CONCATENATED MODULE: ./src/components/HelperVideo.vue?vue&type=template&id=16ce8516

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/HelperVideo.vue?vue&type=script&lang=js
/* harmony default export */ const HelperVideovue_type_script_lang_js = ({
  name: "HelperVideo",
  props: {
    videoUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      playing: false,
      hovering: false,
      showButton: true,
      hideButtonTimeout: undefined,
      currentTime: 0,
      videoDuration: 0,
      animationFrameId: null,
      mouseMoveTimeout: null
    };
  },
  computed: {
    buttonIcon() {
      return this.playing ? "https://drg2mhzb9zcts.cloudfront.net/helper/pause-v2.svg" : "https://drg2mhzb9zcts.cloudfront.net/helper/play-v2.svg";
    }
  },
  methods: {
    hideControls() {
      var _this = this;
      if (this.playing) {
        this.hideButtonTimeout = setTimeout(function () {
          _this.showButton = false;
        }, 500);
      }
    },
    hidePlayButtonTemporarily() {
      this.hideControls();
    },
    toggleControlsOnMobile() {
      if (this.playing) {
        this.showButton = !this.showButton;
      }
    },
    togglePlay() {
      if (this.$refs.videoPlayer.paused) {
        this.$refs.videoPlayer.play();
        this.playing = true;
        this.startUpdatingSeekBar();
      } else {
        this.$refs.videoPlayer.pause();
        this.playing = false;
        cancelAnimationFrame(this.animationFrameId);
      }
    },
    pauseVideo() {
      this.$refs.videoPlayer.pause();
      this.playing = false;
    },
    showControls() {
      this.showButton = true;
      clearTimeout(this.hideButtonTimeout);
    },
    updateSeekBar() {
      this.currentTime = this.$refs.videoPlayer.currentTime;
      this.videoDuration = this.$refs.videoPlayer.duration;
      this.animationFrameId = requestAnimationFrame(this.updateSeekBar);
    },
    seekVideo() {
      this.$refs.videoPlayer.currentTime = this.currentTime;
      if (this.$refs.videoPlayer.paused) {
        this.$refs.videoPlayer.play();
        this.playing = true;
        this.startUpdatingSeekBar();
      }
    },
    startUpdatingSeekBar() {
      this.animationFrameId = requestAnimationFrame(this.updateSeekBar);
    },
    resetHideControlsTimeout() {
      clearTimeout(this.mouseMoveTimeout);
      this.showControls();
      this.mouseMoveTimeout = setTimeout(this.hideControls, 500);
    }
  },
  mounted() {
    this.$refs.videoPlayer.addEventListener("play", this.hidePlayButtonTemporarily);
    this.$refs.videoPlayer.addEventListener("pause", this.showControls);
  },
  deactivated() {
    // Called when the component is hidden
    this.$refs.videoPlayer.pause();
    this.playing = false;
    cancelAnimationFrame(this.animationFrameId);
  }
});
;// CONCATENATED MODULE: ./src/components/HelperVideo.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/HelperVideo.vue




;


const HelperVideo_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(HelperVideovue_type_script_lang_js, [['render',HelperVideovue_type_template_id_16ce8516_render]])

/* harmony default export */ const HelperVideo = (HelperVideo_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/Typer.vue?vue&type=template&id=de8e6348

var Typervue_type_template_id_de8e6348_hoisted_1 = {
  ref: "content",
  class: "d-none"
};
function Typervue_type_template_id_de8e6348_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    ref: "target",
    class: (0,shared_esm_bundler/* normalizeClass */.C4)({
      invisible: !$props.show
    })
  }, null, 2 /* CLASS */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", Typervue_type_template_id_de8e6348_hoisted_1, [(0,runtime_core_esm_bundler/* renderSlot */.RG)(_ctx.$slots, "default")], 512 /* NEED_PATCH */)], 64 /* STABLE_FRAGMENT */);
}
;// CONCATENATED MODULE: ./src/components/Typer.vue?vue&type=template&id=de8e6348

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/Typer.vue?vue&type=script&lang=js
function Typervue_type_script_lang_js_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function Typervue_type_script_lang_js_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { Typervue_type_script_lang_js_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { Typervue_type_script_lang_js_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* harmony default export */ const Typervue_type_script_lang_js = ({
  name: "typer",
  props: {
    show: Boolean
  },
  data() {
    return {
      cursorPosition: 0,
      writingTag: false,
      tagOpen: false,
      typeSpeed: 5,
      tempTypeSpeed: 0,
      writing: false,
      sections: []
    };
  },
  computed: {
    target() {
      return this.$refs.target;
    }
  },
  watch: {
    show: {
      handler(newShow) {
        console.log("new value", newShow);
        if (newShow) {
          this.type();
          this.reset();
        } else {}
      }
      // immediate: true,
    }
  },
  components: {},
  methods: {
    type() {
      var _this = this;
      return Typervue_type_script_lang_js_asyncToGenerator(function* () {
        var delay = function delay(ms) {
          return new Promise(function (res) {
            return setTimeout(res, ms);
          });
        };
        yield delay(60);
        var totalDuration = 190; //ms
        var content = _this.$refs.content.innerHTML;
        for (var c of _this.$refs.content.innerHTML) {
          _this.target.innerHTML += c;
          yield delay(totalDuration / content.length);
        }
      })();
    },
    reset() {
      var _this2 = this;
      return Typervue_type_script_lang_js_asyncToGenerator(function* () {
        var delay = function delay(ms) {
          return new Promise(function (res) {
            return setTimeout(res, ms);
          });
        };
        _this2.target.innerHTML = "";
      })();
    }
  },
  mounted() {
    if (this.show) {
      this.type();
      this.reset();
    }
  }
});
;// CONCATENATED MODULE: ./src/components/Typer.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/Typer.vue




;


const Typer_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(Typervue_type_script_lang_js, [['render',Typervue_type_template_id_de8e6348_render]])

/* harmony default export */ const Typer = (Typer_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/ConfiguratorV3.vue?vue&type=script&lang=js
function ConfiguratorV3vue_type_script_lang_js_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function ConfiguratorV3vue_type_script_lang_js_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { ConfiguratorV3vue_type_script_lang_js_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { ConfiguratorV3vue_type_script_lang_js_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ConfiguratorV3vue_type_script_lang_js_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ConfiguratorV3vue_type_script_lang_js_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ConfiguratorV3vue_type_script_lang_js_ownKeys(Object(t), !0).forEach(function (r) { ConfiguratorV3vue_type_script_lang_js_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ConfiguratorV3vue_type_script_lang_js_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ConfiguratorV3vue_type_script_lang_js_defineProperty(e, r, t) { return (r = ConfiguratorV3vue_type_script_lang_js_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function ConfiguratorV3vue_type_script_lang_js_toPropertyKey(t) { var i = ConfiguratorV3vue_type_script_lang_js_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function ConfiguratorV3vue_type_script_lang_js_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






/* harmony default export */ const ConfiguratorV3vue_type_script_lang_js = ({
  name: "ConfiguratorV3",
  props: {
    aspectRatio: String,
    components: Object,
    estimatedShipDate: String,
    available: Boolean,
    imgHeight: Number,
    cybUrl: String,
    description: String,
    handle: String,
    title: String,
    products: Object,
    generatedVariants: Object,
    renderHost: String,
    capsDefault: String,
    showThumbnails: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AddToBag: AddToBag,
    ExtrasModal: ExtrasModal,
    DropDown: DropDown,
    HelperVideo: HelperVideo,
    Typer: Typer
  },
  data() {
    var selections = {};
    var productsCalc = [...this.products];
    for (var p of productsCalc) {
      p.showMore = true;
      var variant = p.variants[0];
      selections[p.id] = ConfiguratorV3vue_type_script_lang_js_objectSpread(ConfiguratorV3vue_type_script_lang_js_objectSpread({
        productId: p.id,
        productName: p.title,
        minPrice: p.price_min
      }, variant), {}, {
        estimatedShipDate: variant.estimatedShipDate
      });
    }
    return {
      selectedImage: undefined,
      buildCode: "",
      images: [],
      selections,
      componentSelections: {},
      // cartVariants: [],
      estimatedShipDateCalc: this.estimatedShipDate,
      switchesProduct: {},
      stabsProduct: {},
      foamProduct: {},
      angle: "side",
      background: "bg-white",
      caps: this.capsDefault,
      capsIndex: 2,
      loadingRender: true,
      selectedParents: {},
      newCode: "",
      copied: false,
      cart: {},
      productsCalc,
      keyboard: undefined,
      keyboards: {
        sonnet2024: {
          name: "sonnet",
          codePrefix: "N",
          angles: ["side", "front", "bottom"],
          visibleParts: {
            front: ["0", "2", "5"],
            side: ["0", "1", "3", "5"],
            bottom: ["0", "1", "2", "3", "4"]
          },
          transparentParts: [],
          excludedProducts: [],
          excludedVariants: ["v-p3-alu-gry", "v-p3-fr4", "v-p3-pc", "v-p1-brs", "v-p1-pom", "v-p1-pp", "v-weight-brs", "v-weight-ssb", "v-weight-rgb"],
          packagingWeight: 581,
          components: [{
            title: "Select Your Keycaps",
            type: "keycaps",
            subtitle: "",
            skus: ["keycaps-anth", "keycaps-tmrw", "keycaps-obsc", "keycaps-lotus"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Keycaps", "");
            }
          }, {
            title: "Select Your Switches",
            type: "switches",
            subtitle: "",
            skus: ["switch-anth-v2-90", "switch-tmrw-v2-90", "switch-obsc-90", "switch-lotus-90"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Switches - 90", "");
            }
          }, {
            title: "Select Your Stabilizers",
            type: "stabs",
            subtitle: "",
            skus: ["stabs-dur-v2-blk", "stabs-dur-v2", "stabs-mode-v1"],
            renameFunction: function renameFunction(name) {
              return name.replace("Stabilizers", "");
            }
          }, {
            title: "Add Foam?",
            type: "foam",
            subtitle: "Foam is optional. The foam kit includes case, plate and PE foam.",
            skus: ["v2-foam-kit"],
            renameFunction: function renameFunction(name) {
              return name;
            }
          }]
        },
        envoy: {
          name: "envoy",
          codePrefix: "Y",
          angles: ["side", "front", "bottom"],
          visibleParts: {
            front: ["0", "1", "3"],
            side: ["0", "1", "2", "3"],
            bottom: ["0", "1", "2", "5"]
          },
          transparentParts: [],
          excludedProducts: [],
          excludedVariants: [],
          packagingWeight: 525,
          components: [{
            title: "Select Your Keycaps",
            type: "keycaps",
            subtitle: "",
            skus: ["keycaps-anth", "keycaps-tmrw", "keycaps-obsc", "keycaps-lotus"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Keycaps", "");
            }
          }, {
            title: "Select Your Switches",
            type: "switches",
            subtitle: "",
            skus: ["switch-anth-v2-70", "switch-tmrw-v2-70", "switch-obsc-70", "switch-lotus-70"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Switches - 70", "");
            }
          }, {
            title: "Select Your Stabilizers",
            type: "stabs",
            subtitle: "",
            skus: ["stabs-dur-v2-blk", "stabs-dur-v2", "stabs-mode-v1"],
            renameFunction: function renameFunction(name) {
              return name.replace("Stabilizers", "");
            }
          }, {
            title: "Add Foam?",
            type: "foam",
            subtitle: "Foam is optional. The foam kit includes case, plate and PE foam.",
            skus: ["y-foam-kit"],
            renameFunction: function renameFunction(name) {
              return name;
            }
          }]
        },
        tempo: {
          name: "tempo",
          codePrefix: "T",
          angles: ["side", "front", "bottom"],
          visibleParts: {
            front: ["0", "1", "3"],
            side: ["0", "1", "2", "5"],
            bottom: ["0", "1", "2", "5"]
          },
          transparentParts: [],
          excludedProducts: ["Tempo Feet"],
          excludedVariants: [],
          packagingWeight: 525,
          components: [{
            title: "Select Your Keycaps",
            type: "keycaps",
            subtitle: "",
            skus: ["keycaps-anth", "keycaps-tmrw", "keycaps-obsc", "keycaps-lotus"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Keycaps", "");
            }
          }, {
            title: "Select Your Switches",
            type: "switches",
            subtitle: "",
            skus: ["switch-anth-v2-70", "switch-tmrw-v2-70", "switch-obsc-70", "switch-lotus-70"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Switches - 70", "");
            }
          }, {
            title: "Select Your Stabilizers",
            type: "stabs",
            subtitle: "",
            skus: ["stabs-dur-v2-blk", "stabs-dur-v2", "stabs-mode-v1"],
            renameFunction: function renameFunction(name) {
              return name.replace("Stabilizers", "");
            }
          }, {
            title: "Add Foam?",
            type: "foam",
            subtitle: "Foam is optional. The foam kit includes case, plate and PE foam.",
            skus: ["t-foam-kit"],
            renameFunction: function renameFunction(name) {
              return name;
            }
          }]
        },
        loop: {
          name: "loop",
          codePrefix: "G",
          angles: ["side", "front", "bottom"],
          visibleParts: {
            front: ["0", "1", "3", "4"],
            side: ["0", "1"],
            bottom: ["0", "1", "2", "6"]
          },
          transparentParts: [],
          excludedProducts: ["Loop Feet"],
          excludedVariants: [],
          packagingWeight: 950,
          components: [{
            title: "Select Your Plate",
            type: "plate",
            subtitle: "Plate will be added to the cart as a separate item. It is not included in the build code",
            skus: ["g-plate-fr4", "g-plate-pom", "g-plate-pc", "g-plate-pp", "g-plate-nylon", "g-plate-alu", "g-plate-cf", "g-plate-cu"],
            renameFunction: function renameFunction(name) {
              return name.replace("Loop Plate - ", "");
            }
          }, {
            title: "Select Your PCB",
            type: "pcb",
            subtitle: "PCB will be added to the cart as a separate item. It is not included in the build code",
            skus: ["ey-pcb-s", "ey-pcb-hs"],
            renameFunction: function renameFunction(name) {
              return name.replace("TKL PCB - ", "");
            }
          }, {
            title: "Select Your Keycaps",
            type: "keycaps",
            subtitle: "",
            skus: ["keycaps-anth", "keycaps-tmrw", "keycaps-obsc", "keycaps-lotus"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Keycaps", "");
            }
          }, {
            title: "Select Your Switches",
            type: "switches",
            subtitle: "",
            skus: ["switch-anth-v2-90", "switch-tmrw-v2-90", "switch-obsc-90", "switch-lotus-90"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Switches - 90", "");
            }
          }, {
            title: "Select Your Stabilizers",
            type: "stabs",
            subtitle: "",
            skus: ["stabs-dur-v2-blk", "stabs-dur-v2", "stabs-mode-v1"],
            renameFunction: function renameFunction(name) {
              return name.replace("Stabilizers", "");
            }
          }, {
            title: "Add Foam?",
            type: "foam",
            subtitle: "Foam is optional. The foam kit includes case, plate and PE foam.",
            skus: ["g-foam-kit"],
            renameFunction: function renameFunction(name) {
              return name;
            }
          }]
        },
        sixtyfive2024: {
          name: "sixtyfive",
          codePrefix: "S",
          angles: ["side", "front", "bottom"],
          visibleParts: {
            front: ["1", "3"],
            side: ["1", "2", "3", "7", "8"],
            bottom: ["1", "2", "5", "8"]
          },
          transparentParts: [],
          excludedProducts: ["SixtyFive Badge"],
          excludedVariants: [],
          packagingWeight: 893,
          components: [{
            title: "Select Your Plate",
            type: "plate",
            subtitle: "Plate will be added to the cart as a separate item. It is not included in the build code",
            skus: ["s-plate-fr4", "s-plate-pom", "s-plate-pc", "s-plate-pp", "s-plate-nyl", "s-plate-alu", "s-plate-cf", "s-plate-cu"],
            renameFunction: function renameFunction(name) {
              return name.replace("65% Plate - ", "");
            }
          }, {
            title: "Select Your PCB",
            type: "pcb",
            subtitle: "PCB will be added to the cart as a separate item. It is not included in the build code.",
            skus: ["y-pcb-s", "y-pcb-hs"],
            renameFunction: function renameFunction(name) {
              return name.replace("65% PCB - ", "");
            }
          }, {
            title: "Select Your Keycaps",
            type: "keycaps",
            subtitle: "",
            skus: ["keycaps-anth", "keycaps-tmrw", "keycaps-obsc", "keycaps-lotus"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Keycaps", "");
            }
          }, {
            title: "Select Your Switches",
            type: "switches",
            subtitle: "",
            skus: ["switch-anth-v2-70", "switch-tmrw-v2-70", "switch-obsc-70", "switch-lotus-70"],
            renameFunction: function renameFunction(name) {
              return name.replace(" Switches - 70", "");
            }
          }, {
            title: "Select Your Stabilizers",
            type: "stabs",
            subtitle: "",
            skus: ["stabs-dur-v2-blk", "stabs-dur-v2", "stabs-mode-v1"],
            renameFunction: function renameFunction(name) {
              return name.replace("Stabilizers", "");
            }
          }, {
            title: "Add Foam?",
            type: "foam",
            subtitle: "Foam is optional. The foam kit includes case, plate and PE foam.",
            skus: ["s-foam-kit"],
            renameFunction: function renameFunction(name) {
              return name;
            }
          }]
        }
      }
    };
  },
  computed: {
    cartVariants() {
      var _this = this;
      var components = Object.values(this.componentSelections).map(function (c) {
        if (c.id === "use-my-own") return undefined;
        return {
          id: c.id,
          items: 1,
          available: c.available,
          estimatedShipDate: _this.estimatedShipDateCalc
        };
      }).filter(function (item) {
        return item !== undefined;
      });
      var properties = {};
      // Add a value for the day. Safari cannot parse the date unless a day is provided
      var date = new Date("28 ".concat(this.estimatedShipDateCalc));
      var isDate = date instanceof Date && !isNaN(date);
      if (isDate) {
        properties = {
          "_Estimated ship date": this.estimatedShipDateCalc
        };
      }
      var config = {
        id: this.configId,
        items: 1,
        available: this.incompatibilities == 0,
        properties
      };
      return [config, ...components];
    },
    imgHeightStyle() {
      return "".concat(this.imgHeight, "px");
    },
    rendersOrImages() {
      return this.selectedImage ? "images" : "renders";
    },
    aspectRatioClass() {
      return "aspect-".concat(this.aspectRatio);
    },
    price() {
      var _this2 = this;
      var componentsPrice = Object.values(this.componentSelections).reduce(function (sum, selection) {
        return sum + selection.originalPrice;
      }, 0);
      var variant = this.generatedVariants.find(function (e) {
        return e.buildCode.toLowerCase() === _this2.buildCode.toLowerCase();
      });
      if (!variant) {
        variant = {
          price: Object.values(this.selections).reduce(function (sum, selection) {
            return sum + selection.price;
          }, 0)
        };
      }
      return variant.price + componentsPrice;
    },
    renderUrl() {
      var caps = this.caps;
      var url = this.renderHost;
      var qs = "".concat(this.angle, "_").concat(this.background, "_").concat(this.optimizedBuildCode, "_").concat(caps, ".jpg");
      return "".concat(url, "/").concat(qs);
    },
    weight() {
      var _this3 = this;
      var variant = this.generatedVariants.find(function (variant) {
        return variant.buildCode.toLowerCase() === _this3.buildCode.toLowerCase();
      });
      var componentsWeight = Object.values(this.componentSelections).reduce(function (sum, _ref) {
        var {
          configWeight
        } = _ref;
        return sum + (Number(configWeight) || 0);
      }, 0);
      var partsWeight = Object.values(this.selections).reduce(function (sum, selection) {
        return sum + (Number(selection.configWeight) || 0);
      }, 0);
      var variantWeight = variant ? Number(variant.weight) || 0 : partsWeight;
      var packagingWeight = Number(this.keyboard.packagingWeight) || 0;
      var totalWeight = variant ? (variantWeight + componentsWeight - packagingWeight) * 0.00220462 : (variantWeight + componentsWeight) * 0.00220462;
      return totalWeight.toFixed(2);
    },
    buildCode() {
      var _this4 = this;
      var segments = [];
      var _loop = function _loop() {
          var sku = _this4.selections[p.id].sku;
          if (!sku) return 0; // continue
          var part = _this4.keyboard.parts.find(function (i) {
            return i.sku === sku;
          });
          if (part !== undefined) {
            // TODO: do this more intelligently
            if (p.handle === "loop-feet") {
              // When the black mirror weight(2a) is selected change feet to black (6b)
              var feetCode = segments.includes("2a") ? "6b" : "6a";
              segments.push(feetCode);
            } else if (p.handle === "sixtyfive-bottom-case") {
              var badgeCode = "6".concat(part.code[1]);
              segments.push(badgeCode);
              segments.push(part.code);
            } else if (p.handle === "sixtyfive-badge") {
              return 0; // continue
            } else {
              segments.push(part.code);
            }
          }
        },
        _ret;
      for (var p of this.productsCalc) {
        _ret = _loop();
        if (_ret === 0) continue;
      }
      this.buildCode = "".concat(this.keyboard.codePrefix).concat(segments.sort().join(""));
      return this.buildCode;
    },
    visibleBuildCode() {
      var _this5 = this;
      var segments = [];
      var _loop2 = function _loop2() {
          var sku = _this5.selections[p.id].sku;
          if (!sku) return 0; // continue
          var part = _this5.keyboard.parts.find(function (i) {
            return i.sku === sku;
          });
          // TODO: do this more intelligently
          if (p.handle === "loop-feet") {
            // When the black mirror weight(2a) is selected change feet to black (6b)
            var feetCode = segments.includes("2a") ? "6b" : "6a";
            segments.push(feetCode);
          } else if (p.handle === "sixtyfive-bottom-case") {
            var badgeCode = "6".concat(part.code[1]);
            segments.push(part.code);
            segments.push(badgeCode);
          } else if (p.handle === "sixtyfive-badge") {
            return 0; // continue
          } else if (p.handle === "sixtyfive-top-case" && part.code === "1e") {
            var _sku = _this5.componentSelections.plate.sku;
            var _code = _sku === "s-plate-cu" ? "7d" : "7a";
            segments.push(part.code);
            segments.push(_code);
          } else {
            segments.push(part.code);
          }
        },
        _ret2;
      for (var p of this.productsCalc) {
        _ret2 = _loop2();
        if (_ret2 === 0) continue;
      }
      var combinedVisibleParts = Object.values(this.keyboard.visibleParts).flat();
      var alwaysVisibleParts = [...new Set(combinedVisibleParts)];
      if (this.keyboard.name === "sonnet") {
        segments = this.replaceSonnetTopSegment(segments);
      }
      var code = segments.reduce(function (result, segment) {
        var isVisiblePart = alwaysVisibleParts.find(function (p) {
          return segment.includes(p);
        });
        if (isVisiblePart) {
          //Swap transparent part for the part that shows underneath it
          var transparentPart = _this5.keyboard.transparentParts.find(function (p) {
            return p.part === segment;
          });
          if (transparentPart) {
            var newSegment = segments.find(function (segment) {
              return segment.charAt(0) === transparentPart.show;
            });
            return result.concat(newSegment);
          } else {
            return result.concat(segment);
          }
        }
        return result;
      }, []).join("");
      return "".concat(this.keyboard.codePrefix).concat(code);
    },
    configId() {
      var _this6 = this;
      if (this.generatedVariants.length === 0) return "bundle-config";
      var variant = this.generatedVariants.find(function (e) {
        return e.buildCode.toLowerCase() === _this6.buildCode.toLowerCase();
      });
      return (variant === null || variant === void 0 ? void 0 : variant.id) || "bundle-config";
    },
    needsDark() {
      return this.background !== "bg-walnut";
    },
    optimizedBuildCode() {
      var _this7 = this;
      var segments = [];
      var _loop3 = function _loop3() {
          var sku = _this7.selections[p.id].sku;
          if (!sku) return 0; // continue
          var part = _this7.keyboard.parts.find(function (i) {
            return i.sku === sku;
          });
          // TODO: do this more intelligently
          if (p.handle === "loop-feet") {
            // When the black mirror weight(2a) is selected change feet to black (6b)
            var feetCode = segments.includes("2a") ? "6b" : "6a";
            segments.push(feetCode);
          } else if (p.handle === "sixtyfive-bottom-case") {
            var badgeCode = "6".concat(part.code[1]);
            segments.push(part.code);
            segments.push(badgeCode);
          } else if (p.handle === "sixtyfive-badge") {
            return 0; // continue
          } else if (p.handle === "sixtyfive-top-case" && part.code === "1e") {
            var _sku2 = _this7.componentSelections.plate.sku;
            var _code2 = _sku2 === "s-plate-cu" ? "7d" : "7a";
            segments.push(part.code);
            segments.push(_code2);
          } else {
            segments.push(part.code);
          }
        },
        _ret3;
      for (var p of this.productsCalc) {
        _ret3 = _loop3();
        if (_ret3 === 0) continue;
      }
      if (this.keyboard.name === "sonnet") {
        segments = this.replaceSonnetTopSegment(segments);
      }
      var code = segments.reduce(function (result, segment) {
        var isVisiblePart = _this7.keyboard.visibleParts[_this7.angle].find(function (p) {
          return segment.includes(p);
        });
        if (isVisiblePart) {
          //Swap transparent part for the part that shows underneath it
          var transparentPart = _this7.keyboard.transparentParts.find(function (p) {
            return p.part === segment;
          });
          if (transparentPart) {
            var newSegment = segments.find(function (segment) {
              return segment.charAt(0) === transparentPart.show;
            });
            return result.concat(newSegment);
          } else {
            return result.concat(segment);
          }
        }
        return result;
      }, []).join("");
      return "".concat(this.keyboard.codePrefix).concat(code);
    },
    incompatibilities() {
      var _this8 = this;
      var incompatibilities = [];
      var outOfStock = false;
      for (var s of Object.values(this.componentSelections)) {
        if (s.id === "use-my-own") continue;
        if (!s.instock) outOfStock = true;
      }
      for (var s of Object.values(this.selections)) {
        var _this$keyboard;
        if (!s.sku) continue;
        if (!s.instock) outOfStock = true;
        var part = (_this$keyboard = this.keyboard) === null || _this$keyboard === void 0 || (_this$keyboard = _this$keyboard.parts) === null || _this$keyboard === void 0 ? void 0 : _this$keyboard.find(function (i) {
          return i.sku === s.sku;
        });
        if (part !== undefined && part.incompatibilities) {
          for (var i of part.incompatibilities) {
            var intersection = i.parts.filter(function (x) {
              return _this8.buildCode.includes(x);
            });
            if (intersection.length > 0) {
              incompatibilities.push(i.message);
            }
          }
        }
      }
      if (outOfStock) incompatibilities.push("Some parts are unavailable.");
      return incompatibilities;
    }
  },
  methods: {
    copy(target) {
      var _this9 = this;
      return ConfiguratorV3vue_type_script_lang_js_asyncToGenerator(function* () {
        var element = document.getElementById(target);
        element.disabled = false;
        element.focus();
        element.select();
        element.setSelectionRange(0, 99999); /* For mobile devices */
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        element.blur();
        element.disabled = true;
        _this9.copied = true;
        setTimeout(function () {
          _this9.copied = false;
        }, 2500);
      })();
    },
    replaceSonnetTopSegment(segments) {
      var sonnetTopSegment = segments.find(function (segment) {
        return segment === "0g";
      });
      if (sonnetTopSegment) {
        var plateSegmentIndex = segments.findIndex(function (segment) {
          return segment.startsWith('5');
        });
        if (plateSegmentIndex !== -1 && segments[plateSegmentIndex] !== "5g") {
          segments[plateSegmentIndex] = "5a";
        }
      }
      return segments;
    },
    closeImage() {
      this.selectedImage = undefined;
    },
    thumbnailNavigationHelper() {
      var _this10 = this;
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      document.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach(function (elm, i) {
        if (i == index) {
          elm.classList.add("active");
          _this10.selectedImage = index;
        } else elm.classList.remove("active");
      });
    },
    convertToHTML(node) {
      var _this11 = this;
      if (!node) return;
      var html = "";
      switch (node.type) {
        case "root":
          node.children.forEach(function (child) {
            html += _this11.convertToHTML(child);
          });
          break;
        case "paragraph":
          html += "<p>";
          node.children.forEach(function (child) {
            html += _this11.convertToHTML(child);
          });
          html += "</p>";
          break;
        case "text":
          if (node.bold && node.italic) {
            html += "<strong><em>".concat(node.value, "</em></strong>");
          } else if (node.bold) {
            html += "<strong>".concat(node.value, "</strong>");
          } else if (node.italic) {
            html += "<em>".concat(node.value, "</em>");
          } else {
            html += node.value;
          }
          break;
        case "list":
          var listTag = node.listType === "unordered" ? "ul" : "ol";
          html += "<".concat(listTag, ">");
          node.children.forEach(function (child) {
            html += _this11.convertToHTML(child);
          });
          html += "</".concat(listTag, ">");
          break;
        case "list-item":
          html += "<li>";
          node.children.forEach(function (child) {
            html += _this11.convertToHTML(child);
          });
          html += "</li>";
          break;
        case "heading":
          html += "<h".concat(node.level, ">");
          node.children.forEach(function (child) {
            html += _this11.convertToHTML(child);
          });
          html += "</h".concat(node.level, ">");
          break;
        case "link":
          html += "<a href=\"".concat(node.url, "\" title=\"").concat(node.title, "\" target=\"").concat(node.target || "_self", "\">");
          node.children.forEach(function (child) {
            html += _this11.convertToHTML(child);
          });
          html += "</a>";
          break;
        default:
          break;
      }
      return html;
    },
    extractOptions(product) {
      var options = {};
      for (var v of product.variants) {
        if (!(v.option2 in options)) {
          options[v.option2] = [];
        }
        options[v.option2].push(v);
      }
      return options;
    },
    fetchKeyboards() {
      var _this12 = this;
      return ConfiguratorV3vue_type_script_lang_js_asyncToGenerator(function* () {
        var response = yield fetch("https://mode-parts.s3.amazonaws.com/parts.json", {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        });
        var data = yield response.json();
        _this12.hasKeyboardData = true;
        for (var key of Object.keys(data)) {
          if (_this12.keyboards[key.toLowerCase()]) {
            _this12.keyboards[key.toLowerCase()].parts = data[key];
          }
        }
        _this12.keyboard = _this12.keyboards[_this12.handle.toLowerCase()];
        return;
      })();
    },
    getComponentProduct(componentType) {
      var _this13 = this;
      var parentProduct = {};
      var variants = [];
      var name = "I'll Use My Own";
      if (componentType === "foam") name = "No Foam";
      if (componentType === "pcb") name = "No PCB";
      if (componentType !== "plate") {
        variants.push({
          name,
          price: 0,
          originalPrice: 0,
          sku: "use-my-own",
          id: "use-my-own",
          instock: true,
          configWeight: 0
        });
      }
      var _loop4 = function _loop4() {
        if (product.tags.includes(componentType)) {
          parentProduct = JSON.parse(JSON.stringify(product)); // Any product can serve as parent product
          var boardComponents = _this13.keyboard.components.find(function (c) {
            return c.type === componentType;
          });
          var newVariants = product.variants.filter(function (v) {
            return boardComponents.skus.includes(v.sku);
          });
          variants.push(...newVariants);
        }
      };
      for (var product of this.components) {
        _loop4();
      }
      parentProduct.id = componentType;
      parentProduct.variants = variants;
      return parentProduct;
    },
    getRenderUrl() {
      var caps = this.caps;
      var url = this.renderHost;
      var qs = "".concat(this.angle, "_").concat(this.background, "_").concat(this.optimizedBuildCode, "_").concat(caps, ".jpg");
      return "".concat(url, "/").concat(qs);
    },
    getVariantCost(variant, minPrice) {
      if (!variant.instock && this.available) return "Unavailable";
      var priceChange = variant.price - minPrice;
      if (priceChange === 0) {
        return "No Cost";
      }
      return this.formatPrice(priceChange);
    },
    formatPrice(amount) {
      if (amount == 0) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      });
      return formatter.format(amount / 100); // Shopfiy provides price as cents
    },
    removeProductName(title) {
      title = title.split(" ");
      title.shift();
      title = title.join(" ");
      return title;
    },
    openCodeModal() {
      var codeModal = document.getElementById("codeModal");
      var bsCodeModal = new bootstrap_esm/* Modal */.aF(codeModal);
      bsCodeModal.show();
      var input = document.getElementById("codeInput");
      codeModal.addEventListener("shown.bs.modal", function () {
        input.focus();
      });
    },
    renderLoaded() {
      this.loadingRender = false;
    },
    updateAngle(index) {
      var angles = this.keyboard.angles;
      this.loadingRender = true;
      this.angle = angles[index];
    },
    updateCaps(set) {
      var caps = ["caps-dark", "caps-light", "caps-tmr", "caps-lotus"];
      if (set) {
        this.loadingRender = true;
        var capsIndex = caps.indexOf(set);
        this.caps = caps[capsIndex];
      }
    },
    updateBuildCode() {
      var newCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var codeModal = document.getElementById("codeModal");
      var bsCodeModal = bootstrap_esm/* Modal */.aF.getInstance(codeModal);
      newCode = newCode.substring(1);
      var regex = /([0]\w){0,1}([1]\w){1}([2]\w){1}([3]\w){1}([4]\w){0,1}([5]\w){0,1}([6]\w){0,1}([7]\w){0,1}([8]\w){0,1}([9]\w){0,1}/g;
      var matched = newCode.match(regex);
      if (matched && newCode.length <= 21) {
        this.buildCode === "".concat(this.keyboard.codePrefix).concat(newCode);
        var segments = newCode.match(/(\d\w)/g);
        var skus = [];
        for (var s of segments) {
          var part = this.keyboard.parts.find(function (i) {
            return i.code === s.toLowerCase();
          });
          if (part !== -1) {
            skus.push(part.sku);
          }
        }
        for (var [productId, oldVariant] of Object.entries(this.selections)) {
          productId = Number(productId);
          var product = this.productsCalc.find(function (p) {
            return p.id == productId;
          });
          if (product === -1) return;
          var variant = product.variants.find(function (v) {
            return skus.indexOf(v.sku) !== -1;
          });
          if (variant !== undefined) {
            this.updateSelection(productId, variant);
            if (variant.option2 !== null) {
              this.selectedParents[productId] = variant.option2;
            }
          } else {
            // If the segment wasn't provided use the default option
            this.updateSelection(productId, product.variants[0]);
          }
        }
      }
      if (bsCodeModal) bsCodeModal.hide();
    },
    setSelectedOption(productId, option) {
      var product = this.productsCalc.find(function (p) {
        return p.id == productId;
      });
      var variant = product.variants.find(function (v) {
        return v.option2 === option;
      });
      this.updateSelection(productId, variant);
    },
    findInstockVariant(productId) {
      var product = this.productsCalc.find(function (p) {
        return p.id == productId;
      });
      var variant = product.variants.find(function (v) {
        return v.instock;
      });
      if (variant) this.updateSelection(productId, variant);
    },
    updateSelection(productId, variant) {
      this.selections[productId] = Object.assign(this.selections[productId], ConfiguratorV3vue_type_script_lang_js_objectSpread({
        productId,
        estimatedShipDate: variant.estimatedShipDate
      }, variant));
      var hasMultipleOptions = variant.option2 !== null;
      if (hasMultipleOptions) {
        this.selectedParents[productId] = variant.option2;
      }

      // Get latest selection ship date
      var today = new Date();
      var latestSelectionShip = today;
      for (var s of [...Object.values(this.selections), ...Object.values(this.componentSelections)]) {
        if (s.estimatedShipDate) {
          // Add a value for the day. Safari cannot parse the date unless a day is provided
          var selectionEstimatedShip = new Date("28 ".concat(s.estimatedShipDate));
          latestSelectionShip = selectionEstimatedShip > latestSelectionShip ? selectionEstimatedShip : latestSelectionShip;
        }
      }

      // Get latest between variant and product
      // Add a value for the day. Safari cannot parse the date unless a day is provided
      var latestShipDate = new Date("28 ".concat(this.estimatedShipDate));
      var isDate = latestShipDate instanceof Date && !isNaN(latestShipDate);
      var dateFormat = {
        month: "long",
        year: "numeric"
      };
      if (isDate) {
        latestShipDate = latestSelectionShip > latestShipDate ? latestSelectionShip : latestShipDate;
        this.estimatedShipDateCalc = latestShipDate.toLocaleDateString("en-US", dateFormat);
      } else if (latestSelectionShip > today) {
        latestShipDate = latestSelectionShip;
        this.estimatedShipDateCalc = latestShipDate.toLocaleDateString("en-US", dateFormat);
      } else {
        this.estimatedShipDateCalc = this.estimatedShipDate;
      }
    },
    updateComponentsSelection(productId, variant) {
      this.closeImage();
      if (productId === "keycaps") {
        var capMap = {
          "keycaps-tmrw": "caps-tmr",
          "keycaps-anth": "caps-light",
          "keycaps-obsc": "caps-dark",
          "keycaps-lotus": "caps-lotus"
        };
        this.updateCaps(capMap[variant.sku]);
      }
      this.componentSelections[productId] = variant;
      // Get latest selection ship date
      var today = new Date();
      var latestSelectionShip = today;
      for (var s of [...Object.values(this.selections), ...Object.values(this.componentSelections)]) {
        if (s.estimatedShipDate) {
          // Add a value for the day. Safari cannot parse the date unless a day is provided
          var selectionEstimatedShip = new Date("28 ".concat(s.estimatedShipDate));
          latestSelectionShip = selectionEstimatedShip > latestSelectionShip ? selectionEstimatedShip : latestSelectionShip;
        }
      }

      // Get latest between variant and product
      // Add a value for the day. Safari cannot parse the date unless a day is provided
      var latestShipDate = new Date("28 ".concat(this.estimatedShipDate));
      var isDate = latestShipDate instanceof Date && !isNaN(latestShipDate);
      var dateFormat = {
        month: "long",
        year: "numeric"
      };
      if (isDate) {
        latestShipDate = latestSelectionShip > latestShipDate ? latestSelectionShip : latestShipDate;
        this.estimatedShipDateCalc = latestShipDate.toLocaleDateString("en-US", dateFormat);
      } else if (latestSelectionShip > today) {
        latestShipDate = latestSelectionShip;
        this.estimatedShipDateCalc = latestShipDate.toLocaleDateString("en-US", dateFormat);
      } else {
        this.estimatedShipDateCalc = this.estimatedShipDate;
      }
    },
    fetchBundleVariant(buildcode) {
      return ConfiguratorV3vue_type_script_lang_js_asyncToGenerator(function* () {
        var query = "\n        query FindVariantBySku($sku: String!) {\n          productVariants(first: 1, query: $sku) {\n            edges {\n              node {\n                id\n                legacyResourceId\n                sku\n                title\n                price\n                product {\n                  id\n                  title\n                }\n              }\n            }\n          }\n        }\n      ";
        var variables = {
          sku: buildcode
        };
        try {
          var response = yield fetch('https://238l8kaug8.execute-api.us-east-1.amazonaws.com/prod/graphql', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              query,
              variables
            })
          });
          var result = yield response.json();
          if (result.errors) {
            console.error('GraphQL errors:', result.errors);
            return null;
          }
          return result.data.productVariants[0];
        } catch (error) {
          console.error('Error fetching variant:', error);
          return null;
        }
      })();
    },
    fetchMediaImages() {
      var _this14 = this;
      return ConfiguratorV3vue_type_script_lang_js_asyncToGenerator(function* () {
        var response = yield fetch("https://1bg3w07gu8.execute-api.us-east-1.amazonaws.com/getImages?code=".concat(_this14.visibleBuildCode, "&limit=30"), {
          method: "GET",
          headers: {
            "Content-Type": "application/json"
          }
        });
        var data = yield response.json();
        _this14.images = data.map(function (x) {
          return x.url;
        });
        return data;
      })();
    },
    mountImages() {
      var _this15 = this;
      return ConfiguratorV3vue_type_script_lang_js_asyncToGenerator(function* () {
        var data = yield _this15.fetchMediaImages();
        var productGalleryThumbnails = document.querySelector(".product-gallery__thumbnails-holder");
        document.querySelectorAll(".product-gallery__thumbnails .thumbnail").forEach(function (elm, i) {
          if (i === 0) {
            elm.classList.add("active");
          }
          elm.addEventListener("click", function (e) {
            var index = e.currentTarget.dataset.index;
            _this15.thumbnailNavigationHelper(index);
            productGalleryThumbnails.scrollTo({
              left: elm.offsetLeft - 50,
              behavior: "smooth"
            });
          });
        });
        return data;
      })();
    },
    pauseVideo(refId) {
      var videoRef = this.$refs[refId];
      if (videoRef) {
        videoRef[0].pauseVideo();
      }
    }
  },
  mounted() {
    var _this16 = this;
    return ConfiguratorV3vue_type_script_lang_js_asyncToGenerator(function* () {
      yield _this16.fetchKeyboards();
      _this16.mountImages();
      _this16.$watch("optimizedBuildCode", function () {
        _this16.loadingRender = true;
      });
      _this16.$watch("buildCode", function () {
        _this16.closeImage();
      });
      _this16.$watch("visibleBuildCode", function () {
        _this16.mountImages();
      });
      for (var c of _this16.keyboard.components) {
        c.product = _this16.getComponentProduct(c.type);
        var isPlateOrPCB = c.type === "plate" || c.type === "pcb";
        var index = isPlateOrPCB ? 1 : 0;
        _this16.componentSelections[c.type] = c.product.variants[index];
      }
      _this16.$nextTick(function () {
        var _this17 = this;
        var carousel = document.getElementById("viewportCarousel");
        var bsCarousel = new bootstrap_esm/* Carousel */.FN(carousel, {
          interval: false,
          ride: false
        });
        carousel.addEventListener("slide.bs.carousel", function (event) {
          _this17.updateAngle(event.to);
        });

        // Set default option for products with multiple options
        for (var _p of this.products) {
          var hasMultipleOptions = _p.variants[0].option2 !== null;
          if (hasMultipleOptions) {
            var secondOption = _p.variants[0].option2;
            this.selectedParents[_p.id] = secondOption;
          }
        }
        var urlParams = new URLSearchParams(window.location.search);
        var queryBuildCode = urlParams.get("code");
        var keycapsSku = urlParams.get("keycaps");
        var switchesSku = urlParams.get("switches");
        var stabsSku = urlParams.get("stabilizers");
        if (queryBuildCode) {
          this.updateBuildCode(queryBuildCode);
        } else {
          for (var p of this.productsCalc) {
            this.findInstockVariant(p.id);
          }
        }
        if (keycapsSku) {
          var components = this.keyboard.components;
          var keycaps = components.find(function (c) {
            return c.type === "keyboard";
          });
          var keycapVariants = keycaps.product.variants;
          var variant = keycapVariants.find(function (v) {
            return v.sku === keycapsSku;
          });
          if (variant) {
            this.updateComponentsSelection(keycaps.product.id, variant);
          }
        }
        if (switchesSku) {
          var _components = this.keyboard.components;
          var switches = _components.find(function (c) {
            return c.type === "switches";
          });
          var switchVariants = switches.product.variants;
          var _variant = switchVariants.find(function (v) {
            return v.sku === switchesSku;
          });
          if (_variant) {
            this.updateComponentsSelection(switches.product.id, _variant);
          }
        }
        if (stabsSku) {
          var _components2 = this.keyboard.components;
          var stabs = _components2.find(function (c) {
            return c.type === "stabs";
          });
          var stabVariants = stabs.product.variants;
          var _variant2 = stabVariants.find(function (v) {
            return v.sku === stabsSku;
          });
          if (_variant2) {
            this.updateComponentsSelection(stabs.product.id, _variant2);
          }
        }
        var _loop5 = function _loop5(_p2) {
          var helperModalElement = document.getElementById("".concat(_p2.handle, "-detail"));
          if (!helperModalElement) {
            return 1; // continue
          }
          helperModalElement.addEventListener("hide.bs.modal", function () {
            _this17.pauseVideo("".concat(_p2.handle, "-helper-video"));
          });
        };
        for (var _p2 of this.productsCalc) {
          if (_loop5(_p2)) continue;
        }
        var _loop6 = function _loop6(_c) {
          var helperModalElement = document.getElementById("".concat(_c.type, "-detail"));
          if (!helperModalElement) {
            return 1; // continue
          }
          helperModalElement.addEventListener('hide.bs.modal', function () {
            _this17.pauseVideo("".concat(_c.type, "-helper-video"));
          });
        };
        for (var _c of this.keyboard.components) {
          if (_loop6(_c)) continue;
        }
      });
    })();
  },
  watch: {
    background() {
      this.loadingRender = true;
    }
    // buildCode: {
    //   handler: async function() {
    //     await this.fetchCartVariants();
    //   },
    //   immediate: true
    // },
    // componentSelections: {
    //   handler: async function() {
    //     await this.fetchCartVariants();
    //   },
    //   deep: true
    // }
  }
});
;// CONCATENATED MODULE: ./src/Apps/ConfiguratorV3.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Apps/ConfiguratorV3.vue




;


const ConfiguratorV3_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(ConfiguratorV3vue_type_script_lang_js, [['render',render]])

/* harmony default export */ const ConfiguratorV3 = (ConfiguratorV3_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/BuildGuide.vue?vue&type=template&id=007cd7f5

var BuildGuidevue_type_template_id_007cd7f5_hoisted_1 = {
  class: "container px-md-5",
  "data-bs-spy": "scroll",
  "data-bs-target": "#nav-items"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_2 = {
  id: "introduction",
  class: "row mb-4"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_3 = {
  class: "col col-12 col-md-10 offset-md-1 title"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_4 = ["innerHTML"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_5 = {
  class: "row"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_6 = {
  class: "col col-12 col-md-10 offset-md-1 parts mb-4"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_7 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", null, "Parts", -1 /* HOISTED */);
var BuildGuidevue_type_template_id_007cd7f5_hoisted_8 = {
  class: "parts-list"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_9 = {
  key: 0
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_10 = {
  key: 1
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_11 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", {
  class: "text-muted"
}, "Not Included", -1 /* HOISTED */);
var BuildGuidevue_type_template_id_007cd7f5_hoisted_12 = [BuildGuidevue_type_template_id_007cd7f5_hoisted_11];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_13 = {
  class: "col col-12 col-md-10 offset-md-1"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_14 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", null, "Additional Tools")], -1 /* HOISTED */);
var BuildGuidevue_type_template_id_007cd7f5_hoisted_15 = {
  class: "tools-list"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_16 = {
  key: 0
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_17 = {
  class: "text-muted"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_18 = {
  class: "row section"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_19 = {
  class: "col col-12 col-md-10 offset-md-1"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_20 = {
  class: "row"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_21 = {
  key: 0,
  class: "col col-12 offset-md-1 col-md-6"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_22 = ["src"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_23 = {
  class: "modal fade",
  id: 'step-modal-A',
  tabindex: "-1",
  "aria-hidden": "true"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_24 = {
  class: "modal-dialog modal-lg"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_25 = {
  class: "modal-content"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_26 = {
  class: "modal-body p-0"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_27 = ["src"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_28 = ["innerHTML"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_29 = ["id"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_30 = {
  class: "row section"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_31 = {
  class: "col col-12 col-md-10 offset-md-1 mb-4"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_32 = {
  class: "row"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_33 = {
  key: 0,
  class: "col col-12 offset-md-1 col-md-6"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_34 = ["src", "data-bs-target"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_35 = ["id"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_36 = {
  class: "modal-dialog modal-lg"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_37 = {
  class: "modal-content"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_38 = {
  class: "modal-body p-0"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_39 = ["src"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_40 = {
  key: 0,
  class: "d-flex mb-3 mt-3 mt-md-0"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_41 = ["src", "onMouseover", "onClick"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_42 = {
  key: 0
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_43 = {
  class: "alert alert-warning d-flex",
  role: "alert"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_44 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex flex-column justify-content-center"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("i", {
  class: "bi bi-exclamation-triangle me-3"
})], -1 /* HOISTED */);
var BuildGuidevue_type_template_id_007cd7f5_hoisted_45 = ["innerHTML"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_46 = {
  key: 1
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_47 = {
  class: "alert alert-secondary d-flex",
  role: "alert"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_48 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex flex-column justify-content-center"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("i", {
  class: "bi bi-info-circle me-3"
})], -1 /* HOISTED */);
var BuildGuidevue_type_template_id_007cd7f5_hoisted_49 = ["innerHTML"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_50 = {
  key: 2,
  class: "standard-li"
};
var BuildGuidevue_type_template_id_007cd7f5_hoisted_51 = ["innerHTML"];
var BuildGuidevue_type_template_id_007cd7f5_hoisted_52 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col col-12 col-md-6 offset-md-3 text-center outro"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", null, "Happy Typing"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", null, " We hope you had a smooth build experience and would love to see the end result! Post your build in our photos channels on Discord or tag us on Instagram @modekeyboards. If you have any feedback you’d like to share with us, you can reach out to hi@modedesigns.com. "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "text-right"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, " - Team Mode")])], -1 /* HOISTED */);
function BuildGuidevue_type_template_id_007cd7f5_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
    id: "build-guide-app",
    onScroll: _cache[0] || (_cache[0] = function ($event) {
      return $options.updateNavIndicator();
    })
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_1, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" INTRODUCTION "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_2, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_3, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", null, (0,shared_esm_bundler/* toDisplayString */.v_)($props.content.title), 1 /* TEXT */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
    innerHTML: $props.content.introduction
  }, null, 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_4)])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" TOOLS AND PARTS "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_5, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_6, [BuildGuidevue_type_template_id_007cd7f5_hoisted_7, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("ul", BuildGuidevue_type_template_id_007cd7f5_hoisted_8, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.content.parts, function (part) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("li", {
      key: part.name
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(part.name) + " ", 1 /* TEXT */), part.quantity > 1 ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("small", BuildGuidevue_type_template_id_007cd7f5_hoisted_9, "x" + (0,shared_esm_bundler/* toDisplayString */.v_)(part.quantity), 1 /* TEXT */)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), !part.included ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_10, BuildGuidevue_type_template_id_007cd7f5_hoisted_12)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)])]);
  }), 128 /* KEYED_FRAGMENT */))])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_13, [BuildGuidevue_type_template_id_007cd7f5_hoisted_14, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("ul", BuildGuidevue_type_template_id_007cd7f5_hoisted_15, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.content.tools, function (tool) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("li", {
      key: tool.name
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, (0,shared_esm_bundler/* toDisplayString */.v_)(tool.name), 1 /* TEXT */), tool.optional ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_16, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", BuildGuidevue_type_template_id_007cd7f5_hoisted_17, "Optional: " + (0,shared_esm_bundler/* toDisplayString */.v_)(tool.optional), 1 /* TEXT */)])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)]);
  }), 128 /* KEYED_FRAGMENT */))])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" PREAMBLES "), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.content.preambles, function (preamble) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: preamble.title
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_18, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h2", BuildGuidevue_type_template_id_007cd7f5_hoisted_19, (0,shared_esm_bundler/* toDisplayString */.v_)(preamble.title), 1 /* TEXT */)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_20, [preamble.image ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_21, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      src: preamble.image,
      width: "598",
      height: "399",
      class: "img-fluid step-img",
      alt: "...",
      "data-bs-toggle": "modal",
      "data-bs-target": '#step-modal-A'
    }, null, 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_22), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_23, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_24, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_25, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_26, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      src: preamble.image,
      width: "598",
      height: "399",
      class: "img-fluid",
      alt: "..."
    }, null, 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_27)])])])])])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
      class: (0,shared_esm_bundler/* normalizeClass */.C4)(["col col-12 col-md-5", {
        'col-md-10 offset-md-1': preamble.image == undefined
      }])
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
      innerHTML: preamble.text
    }, null, 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_28)], 2 /* CLASS */)])]);
  }), 128 /* KEYED_FRAGMENT */)), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" STEPS "), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.content.steps, function (step, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: step.title,
      id: 'step-' + index
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_30, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h2", BuildGuidevue_type_template_id_007cd7f5_hoisted_31, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, "Step " + (0,shared_esm_bundler/* toDisplayString */.v_)(step.index) + " - " + (0,shared_esm_bundler/* toDisplayString */.v_)(step.title), 1 /* TEXT */)])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_32, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" IMAGE "), step.images ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_33, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      src: $data.activeImages[index],
      width: "598",
      height: "399",
      class: "img-fluid step-img",
      "data-bs-toggle": "modal",
      "data-bs-target": '#step-modal-' + index,
      alt: "..."
    }, null, 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_34)])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
      class: "modal fade",
      id: 'step-modal-' + index,
      tabindex: "-1",
      "aria-hidden": "true"
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_36, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_37, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_38, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      src: $data.activeImages[index],
      width: "598",
      height: "399",
      class: "img-fluid",
      alt: "..."
    }, null, 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_39)])])])], 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_35), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" BULLETS "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
      class: (0,shared_esm_bundler/* normalizeClass */.C4)(["col col-12 col-md-4", {
        'col-md-10 offset-md-1': step.images == undefined
      }])
    }, [step.images ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_40, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(step.images, function (image) {
      return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("img", {
        key: image,
        src: image,
        width: "84",
        height: "56",
        onMouseover: function onMouseover($event) {
          return $options.updateStepImage(image, index);
        },
        onClick: function onClick($event) {
          return $options.updateStepImage(image, index);
        },
        class: (0,shared_esm_bundler/* normalizeClass */.C4)(["img-thumbnail step-thumbnail", {
          'active-img': $data.activeImages[index] === image
        }]),
        alt: "..."
      }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, BuildGuidevue_type_template_id_007cd7f5_hoisted_41);
    }), 128 /* KEYED_FRAGMENT */))])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(step.bullets, function (bullet, index) {
      return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("ul", {
        key: index,
        class: (0,shared_esm_bundler/* normalizeClass */.C4)(["step-list", {
          'no-bullet': bullet.type != 'standard'
        }])
      }, [bullet.type === 'warning' ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("li", BuildGuidevue_type_template_id_007cd7f5_hoisted_42, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_43, [BuildGuidevue_type_template_id_007cd7f5_hoisted_44, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
        innerHTML: bullet.text
      }, null, 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_45)])])) : bullet.type === 'info' ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("li", BuildGuidevue_type_template_id_007cd7f5_hoisted_46, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", BuildGuidevue_type_template_id_007cd7f5_hoisted_47, [BuildGuidevue_type_template_id_007cd7f5_hoisted_48, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
        innerHTML: bullet.text
      }, null, 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_49)])])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("li", BuildGuidevue_type_template_id_007cd7f5_hoisted_50, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
        innerHTML: bullet.text
      }, null, 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_51)]))], 2 /* CLASS */);
    }), 128 /* KEYED_FRAGMENT */))], 2 /* CLASS */)])], 8 /* PROPS */, BuildGuidevue_type_template_id_007cd7f5_hoisted_29);
  }), 128 /* KEYED_FRAGMENT */)), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" GOODBYE "), BuildGuidevue_type_template_id_007cd7f5_hoisted_52])], 32 /* NEED_HYDRATION */);
}
;// CONCATENATED MODULE: ./src/Apps/BuildGuide.vue?vue&type=template&id=007cd7f5

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/BuildGuide.vue?vue&type=script&lang=js
/* harmony default export */ const BuildGuidevue_type_script_lang_js = ({
  name: "build-guide",
  props: {
    content: Object
  },
  components: {},
  data() {
    return {
      activeImages: [],
      navOpen: false
    };
  },
  methods: {
    updateStepImage(image, index) {
      this.activeImages[index] = image;
      this.activeImages = [...this.activeImages];
    },
    updateNavIndicator() {}
  },
  mounted() {
    var stepIndex = 0;
    for (var [index, step] of this.content.steps.entries()) {
      if (step.alternate) {
        step.index = stepIndex;
      } else {
        stepIndex += 1;
        step.index = stepIndex;
      }
      if (step.images) {
        this.activeImages[index] = step.images[0];
      }
    }
  }
});
;// CONCATENATED MODULE: ./src/Apps/BuildGuide.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Apps/BuildGuide.vue




;


const BuildGuide_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(BuildGuidevue_type_script_lang_js, [['render',BuildGuidevue_type_template_id_007cd7f5_render]])

/* harmony default export */ const BuildGuide = (BuildGuide_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/KeycapsLandingPage.vue?vue&type=template&id=5f538d08

var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_1 = {
  id: "keycaps-page-app"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_2 = {
  class: "container"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_3 = {
  id: "keycaps-header",
  class: "row hero content-section mb-6"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_4 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"col-12 col-md-7 d-flex flex-column justify-content-start\"><div class=\"d-flex flex-column align-items-start py-4\"><h6 class=\"text-muted fw-normal mb-4 text-upper\"><span style=\"letter-spacing:0.05rem;font-weight:500;\">NOW AVAILABLE</span></h6><h1 class=\"oversized-title fw-light me-3 w-75\"> The keycaps <strong> you&#39;ve been <span style=\"white-space:pre-line;\"> waiting for</span></strong></h1></div><div class=\"tagline\"><div class=\"fw-light\"><p class=\"mt-0 mt-md-4 mb-4 tagline\"> Our MX-compatible keycaps provide the perfect finishing touch to <strong class=\"fw-bold\"> your dream keyboard</strong> — whether it’s your first build or your endgame. </p></div></div><div><a type=\"button\" href=\"https://modedesigns.com/collections/keycaps\" class=\"btn btn-outline-dark py-1\"><h6 class=\"mb-0\"><small>Shop Keycaps</small></h6></a></div></div>", 1);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_5 = {
  class: "col-12 col-md-5 mt-4 mt-md-0"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_6 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_7 = {
  class: "row content-section mb-6 px-md-5 block-y-padding grey-row"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_8 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-10 offset-1 col-lg-8 offset-lg-2"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "oversized-title fw-light text-center"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Legends have never "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  style: {
    "white-space": "pre-line"
  }
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" looked"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, " this"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" sharp ")])])])], -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_9 = {
  class: "col-12"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_10 = {
  class: "d-inline-flex flex-row img-legends-container my-5"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_11 = {
  class: "me-3"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_12 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_13 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_14 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"col-8 offset-2 text-left\"><p> Months of collaboration between Mode and veteran designer <strong><a target=\"_blank\" class=\"text-light\" href=\"https://mvkb.com/\">Tim Van Damme (aka MVKB)</a></strong> yielded a bespoke set of <strong>highly-refined legends.</strong></p><p> Derived from the Neue Haas Grotesk typeface and produced with a <strong>doubleshot </strong>process, these timeless legends offer <strong>crisp legibility.</strong> No effort was spared in crafting <strong>consistent iconography</strong> and finding the perfect <strong>visual balance</strong> of elements. </p></div>", 1);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_15 = {
  class: "row content-section mb-6"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_16 = {
  class: "col-12 col-md-10 offset-md-1 mb-0"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_17 = {
  class: "d-flex flex-row flex-wrap flex-md-nowrap align-items-center px-lg-4"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_18 = {
  class: "oversized-title fw-light pe-3",
  style: {
    "flex-basis": "107%"
  }
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_19 = {
  style: {
    "position": "relative"
  }
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_20 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "All the keys ", -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_21 = {
  class: "triangle-icon d-none d-md-block"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_22 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_23 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  class: "d-md-block"
}, "you need", -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_24 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "text-muted mb-0 pt-2 pt-md-0",
  style: {
    "flex-basis": "50%"
  }
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" MX compatible with broad layout support. "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
  class: "text-dark"
}, "A single kit supports a wide variety of popular keyboard layouts and macOS modifiers.")], -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_25 = {
  class: "text-muted compatibility-list mb-0"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_26 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, "Compatibility List ", -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_27 = {
  class: "vertical-align-middle"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_28 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, "The base kit has basic (or greater) support for each of the following layouts: Full-size (104/108 key), 1800, TKL, 75%, 65%, 60%, HHKB, Tsangan/WKL, Alice, GK64, 40s, Terminal ISO, macOS modifier keys.", -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_29 = [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_28];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_30 = {
  class: "col-12"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_31 = {
  style: {
    "position": "relative"
  }
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_32 = {
  id: "carouselExampleIndicators",
  class: "carousel slide carousel-dark",
  "data-bs-ride": "carousel",
  "data-bs-interval": "false"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_33 = {
  class: "carousel-inner"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_34 = {
  class: "carousel-item active"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_35 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_36 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 mb-5"
}, null, -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_37 = {
  class: "row content-section mt-6 mb-6"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_38 = {
  class: "col-12 col-md-6 justify-content-center d-flex flex-column"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_39 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "oversized-title fw-light"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "Uncompromising"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" functionality ")], -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_40 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "mt-md-4 mb-4 mb-lg-5"
}, " Keycaps should stand up to the demands of everyday use. We engineered our keycaps for resilience — as well as a pleasant visual and tactile experience. ", -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_41 = {
  id: "carouselfFunctionalityOne",
  class: "carousel carousel-dark d-block d-md-none",
  "data-bs-ride": "carousel"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_42 = {
  class: "carousel-inner"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_43 = {
  class: "carousel-item active"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_44 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_45 = {
  class: "carousel-item"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_46 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_47 = {
  class: "carousel-item"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_48 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_49 = {
  class: "carousel-item"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_50 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_51 = {
  class: "nav nav-tabs justify-content-between mt-4 mt-md-0",
  id: "functionalityTab",
  role: "tablist"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_52 = {
  class: "nav-item flex-grow-1"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_53 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "mb-1 fw-bold"
}, "Durability", -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_54 = [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_53];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_55 = {
  class: "nav-item flex-grow-1"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_56 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "mb-1 fw-bold"
}, "Color", -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_57 = [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_56];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_58 = {
  class: "nav-item flex-grow-1"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_59 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "mb-1 fw-bold"
}, "Doubleshot", -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_60 = [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_59];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_61 = {
  class: "nav-item flex-grow-1"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_62 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "mb-1 fw-bold"
}, "Feel", -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_63 = [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_62];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_64 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "tab-content mt-4 text-muted",
  id: "functionalityTabContent"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "tab-pane fade show active",
  id: "durability",
  role: "tabpanel",
  "aria-labelledby": "durability-tab"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "mb-0"
}, " We worked with a materials engineer to formulate the ideal PBT/ABS compound, optimized for resistance against shine and scratches in daily use. ")]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "tab-pane fade",
  id: "color",
  role: "tabpanel",
  "aria-labelledby": "color-tab"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "mb-0"
}, " Not only is it durable, but our custom PBT/ABS compound also allows for rich colors and deep blacks — on both the legend and keycap itself. ")]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "tab-pane fade",
  id: "double",
  role: "tabpanel",
  "aria-labelledby": "double-tab"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "mb-0"
}, " Using a precise doubleshot process (involving two discrete injections of plastic for each keycap) results in ultra crisp legends that will never fade. ")]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "tab-pane fade",
  id: "texture",
  role: "tabpanel",
  "aria-labelledby": "texture-tab"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "mb-0"
}, " The sculpt of the classic Cherry profile has been perfectly paired with a satisfying surface optimized for feel and durability. ")])], -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_65 = {
  class: "col-12 col-md-6 d-none d-md-block"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_66 = {
  id: "carouselfFunctionality",
  class: "carousel carousel-dark",
  "data-bs-ride": "carousel"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_67 = {
  class: "carousel-inner"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_68 = {
  class: "carousel-item active"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_69 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_70 = {
  class: "carousel-item"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_71 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_72 = {
  class: "carousel-item"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_73 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_74 = {
  class: "carousel-item"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_75 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_76 = {
  class: "row content-section block-y-padding px-5",
  style: {
    "background-color": "#f2e8dc",
    "border-radius": "4px"
  }
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_77 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "oversized-title fw-light text-center"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)("A "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "Theme"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" for every situation")])])], -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_78 = {
  class: "row"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_79 = {
  class: "col-12"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_80 = {
  class: "tab-content d-flex justify-content-center mt-4 text-muted",
  id: "deskSetupTabContent"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_81 = {
  class: "tab-pane fade show active",
  id: "obscura",
  role: "tabpanel",
  "aria-labelledby": "obscura-tab"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_82 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_83 = {
  class: "tab-pane fade",
  id: "tomorrow",
  role: "tabpanel",
  "aria-labelledby": "tomorrow-tab"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_84 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_85 = {
  class: "tab-pane fade",
  id: "anthracite",
  role: "tabpanel",
  "aria-labelledby": "anthracite-tab"
};
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_86 = ["src"];
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_87 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-center tabs-inversed mt-4"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("ul", {
  class: "nav nav-tabs w-75 mt-4",
  id: "deskSetupTab",
  role: "tablist"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("li", {
  class: "nav-item flex-grow-1"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
  class: "nav-link text-muted active",
  id: "obscura-tab",
  "data-bs-toggle": "tab",
  href: "#obscura",
  role: "tab",
  "aria-controls": "obscura",
  "aria-selected": "true"
}, "Obscura")]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("li", {
  class: "nav-item flex-grow-1"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
  class: "nav-link text-muted",
  id: "tomorrow-tab",
  "data-bs-toggle": "tab",
  href: "#tomorrow",
  role: "tab",
  "aria-controls": "tomorrow",
  "aria-selected": "false"
}, "Tomorrow")]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("li", {
  class: "nav-item flex-grow-1"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
  class: "nav-link text-muted",
  id: "anthracite-tab",
  "data-bs-toggle": "tab",
  href: "#anthracite",
  role: "tab",
  "aria-controls": "anthracite",
  "aria-selected": "false"
}, "Anthracite")])])], -1 /* HOISTED */);
var KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_88 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"row hero content-section mb-6\"><div class=\"col-12 col-lg-6 offset-lg-3 col-md-8 offset-md-2 d-flex flex-column justify-content-center\"><div class=\"d-inline-flex flex-row align-items-center justify-content-center mb-3\"><h1 class=\"oversized-title fw-lightest me-3\">Available <strong>Now</strong></h1></div><div class=\"d-flex fw-light justify-content-center\"><p class=\"mt-3\"> Mode keycaps are now available <strong>for $79</strong></p></div><div class=\"d-flex fw-light justify-content-start mt-3\"><a type=\"button\" href=\"https://modedesigns.com/collections/keycaps\" class=\"btn btn-outline-dark py-1 w-100\"><h6 class=\"mb-0\"><small>Shop Keycaps</small></h6></a></div></div></div>", 1);
function KeycapsLandingPagevue_type_template_id_5f538d08_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_1, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_2, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" HERO "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_3, [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_4, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_5, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid",
    width: "525",
    height: "700",
    style: {
      "width": "120%"
    },
    src: this.assetHost + '/keycaps-hero.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_6)])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" LEGENDS "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_7, [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_8, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_9, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_10, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_11, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-legends",
    height: "525",
    width: "840",
    src: this.assetHost + '/keycaps-legends-left.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_12)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-legends",
    height: "525",
    width: "525",
    src: this.assetHost + '/keycaps-legends-right.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_13)])])]), KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_14]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" COVERAGE "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_15, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_16, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_17, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_18, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_19, [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_20, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_21, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "20",
    height: "21",
    src: this.assetHost + '/triangle-icon.svg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_22)])]), KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_23])]), KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_24]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    class: "text-end",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return $data.compatibilityOpen = !$data.compatibilityOpen;
    })
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_25, [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_26, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_27, (0,shared_esm_bundler/* toDisplayString */.v_)($data.compatibilityOpen ? "-" : "+"), 1 /* TEXT */)])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
    class: (0,shared_esm_bundler/* normalizeClass */.C4)([[$data.compatibilityOpen ? 'visible' : 'invisible'], "text-muted px-lg-4 mb-0"])
  }, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_29, 2 /* CLASS */)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_30, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_31, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_32, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_33, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_34, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-legends",
    height: "658",
    width: "1168",
    src: this.assetHost + '/keycaps-kitting-anthracite-v3.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_35)])])])])]), KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_36]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" FUNCTIONALITY "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_37, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_38, [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_39, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_40, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_41, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_42, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_43, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid ps-md-5",
    width: "525",
    height: "700",
    style: {
      "width": "120%"
    },
    src: this.assetHost + '/keycaps-durability-falling.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_44)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_45, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid ps-md-5",
    width: "525",
    height: "700",
    style: {
      "width": "120%"
    },
    src: this.assetHost + '/keycaps-colors.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_46)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_47, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid ps-md-5",
    width: "525",
    height: "700",
    style: {
      "width": "120%"
    },
    src: this.assetHost + '/keycaps-doubleshot.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_48)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_49, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid ps-md-5",
    width: "525",
    height: "700",
    style: {
      "width": "120%"
    },
    src: this.assetHost + '/keycaps-texture.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_50)])])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("ul", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_51, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("li", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_52, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
    class: "nav-link text-muted active",
    id: "durability-tab",
    "data-bs-toggle": "tab",
    href: "#durability",
    role: "tab",
    "aria-controls": "durability",
    "aria-selected": "true",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.updateFunctionalityImage(0);
    })
  }, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_54)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("li", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_55, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
    class: "nav-link text-muted",
    id: "color-tab",
    "data-bs-toggle": "tab",
    href: "#color",
    role: "tab",
    "aria-controls": "color",
    "aria-selected": "false",
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.updateFunctionalityImage(1);
    })
  }, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_57)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("li", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_58, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
    class: "nav-link text-muted",
    id: "double-tab",
    "data-bs-toggle": "tab",
    href: "#double",
    role: "tab",
    "aria-controls": "double",
    "aria-selected": "false",
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.updateFunctionalityImage(2);
    })
  }, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_60)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("li", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_61, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
    class: "nav-link text-muted",
    id: "texture-tab",
    "data-bs-toggle": "tab",
    href: "#texture",
    role: "tab",
    "aria-controls": "texture",
    "aria-selected": "false",
    onClick: _cache[4] || (_cache[4] = function ($event) {
      return $options.updateFunctionalityImage(3);
    })
  }, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_63)])]), KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_64])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_65, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_66, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_67, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_68, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid ps-5",
    width: "525",
    height: "700",
    style: {
      "width": "120%"
    },
    src: this.assetHost + '/keycaps-durability-falling.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_69)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_70, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid ps-5",
    width: "525",
    height: "700",
    style: {
      "width": "120%"
    },
    src: this.assetHost + '/keycaps-colors.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_71)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_72, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid ps-5",
    width: "525",
    height: "700",
    style: {
      "width": "120%"
    },
    src: this.assetHost + '/keycaps-doubleshot.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_73)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_74, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid ps-5",
    width: "525",
    height: "700",
    style: {
      "width": "120%"
    },
    src: this.assetHost + '/keycaps-texture.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_75)])])])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" THEMES "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_76, [KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_77, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_78, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_79, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_80, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_81, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-legends",
    height: "840",
    width: "620",
    src: this.assetHost + '/theme-obscura.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_82)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_83, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-legends",
    height: "840",
    width: "620",
    src: this.assetHost + '/theme-tomorrow.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_84)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_85, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-legends",
    height: "840",
    width: "620",
    src: this.assetHost + '/theme-anthracite.jpg'
  }, null, 8 /* PROPS */, KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_86)])]), KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_87])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" CTA "), KeycapsLandingPagevue_type_template_id_5f538d08_hoisted_88])]);
}
;// CONCATENATED MODULE: ./src/Apps/KeycapsLandingPage.vue?vue&type=template&id=5f538d08

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/RowBackground.vue?vue&type=template&id=f36d3a60

var RowBackgroundvue_type_template_id_f36d3a60_hoisted_1 = ["id"];
var RowBackgroundvue_type_template_id_f36d3a60_hoisted_2 = {
  class: "col-12"
};
function RowBackgroundvue_type_template_id_f36d3a60_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
    id: $data.id,
    class: "row row-bg",
    style: (0,shared_esm_bundler/* normalizeStyle */.Tr)({
      backgroundColor: $props.bgColor
    })
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", RowBackgroundvue_type_template_id_f36d3a60_hoisted_2, [(0,runtime_core_esm_bundler/* renderSlot */.RG)(_ctx.$slots, "default")])], 12 /* STYLE, PROPS */, RowBackgroundvue_type_template_id_f36d3a60_hoisted_1);
}
;// CONCATENATED MODULE: ./src/components/RowBackground.vue?vue&type=template&id=f36d3a60

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/RowBackground.vue?vue&type=script&lang=js
/* harmony default export */ const RowBackgroundvue_type_script_lang_js = ({
  name: "row-background",
  props: {
    bgColor: String,
    bgImage: String
  },
  data() {
    return {
      id: "rowbg-".concat(Math.ceil(Math.random() * 100))
    };
  },
  mounted() {
    var _this = this;
    this.$nextTick(function () {
      if (_this.bgImage) {
        document.getElementById(_this.id).style.backgroundImage = "url(".concat(_this.bgImage, ")");
      }
    });
  }
});
;// CONCATENATED MODULE: ./src/components/RowBackground.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/RowBackground.vue




;


const RowBackground_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(RowBackgroundvue_type_script_lang_js, [['render',RowBackgroundvue_type_template_id_f36d3a60_render]])

/* harmony default export */ const RowBackground = (RowBackground_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/KeycapsLandingPage.vue?vue&type=script&lang=js


/* harmony default export */ const KeycapsLandingPagevue_type_script_lang_js = ({
  name: "keycaps-page",
  props: {
    assetHost: {
      type: String,
      default: "../src/assets"
    }
  },
  components: {
    RowBackground: RowBackground
  },
  data() {
    return {
      cube: {},
      scene: {},
      renderer: {},
      resizeTimeout: undefined,
      updateFaces: true,
      updateZNegative: true,
      rotations: 1,
      images: {},
      selectedCoverage: "option1",
      compatibilityOpen: false,
      carouselfFunctionality: {},
      carouselfFunctionalityOne: {}
    };
  },
  methods: {
    updateFunctionalityImage(target) {
      this.carouselfFunctionality.to(target);
      this.carouselfFunctionalityOne.to(target);
    }
  },
  mounted() {
    this.$nextTick(function () {
      var functionalityTab = document.querySelector("#functionalityTab");
      var tab = new bootstrap_esm/* Tab */.oz(functionalityTab);
      var carouselOne = document.querySelector("#carouselfFunctionalityOne");
      this.carouselfFunctionalityOne = new bootstrap_esm/* Carousel */.FN(carouselOne, {
        interval: false,
        wrap: false
      });
      var carousel = document.querySelector("#carouselfFunctionality");
      this.carouselfFunctionality = new bootstrap_esm/* Carousel */.FN(carousel, {
        interval: false,
        wrap: false
      });
    });
  }
});
;// CONCATENATED MODULE: ./src/Apps/KeycapsLandingPage.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Apps/KeycapsLandingPage.vue




;


const KeycapsLandingPage_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(KeycapsLandingPagevue_type_script_lang_js, [['render',KeycapsLandingPagevue_type_template_id_5f538d08_render]])

/* harmony default export */ const KeycapsLandingPage = (KeycapsLandingPage_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/SonnetProductPage.vue?vue&type=template&id=3fb090a6

var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_1 = {
  id: "sonnet-product-page-app",
  class: "pb-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_2 = {
  class: "container-fluid container--negative-margin py-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_3 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"row img-header flex-column\"><div class=\"d-flex justify-content-start content-section mt-3 flex-wrap\"><h1 class=\"oversized-title text-left w-100\">The New Sonnet</h1><h1 class=\"oversized-title text-left text-grey w-100\">It&#39;s time to rethink keyboards</h1><a type=\"button\" href=\"https://modedesigns.com/products/sonnet\" class=\"mt-4 btn align-self-start btn-outline-dark btn-wide\"><h5 class=\"m-0 px-3 py-1 d-flex\"><span>Configure Yours</span></h5></a></div></div>", 1);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_4 = {
  class: "row tagline text-light justify-content-start content-section"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_5 = {
  class: "dots h-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_6 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_7 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "pt-3 fw-lighter"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, "Elevate your workspace")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_8 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("hr", {
  class: "divider text-light"
})], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_9 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "tagline-content d-flex flex-column justify-content-center"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-bold"
}, " Great tools inspire great work. Like a finely-tuned instrument, a great keyboard brings out your best. ")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_10 = {
  class: "row content-section section-one header d-flex flex-wrap justify-content-center pb-0 mb-5 mb-md-0 mt-4"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_11 = {
  class: "col-12"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_12 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_13 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-md-6 d-flex justify-content-start align-items-end"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-bolder mb-0 title z-index-top"
}, "Exceptional Design")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_14 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-md-6 d-flex justify-content-end align-items-end"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h2", {
  class: "fw-light w-md-75 z-index-top"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Superlative in every manner. "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("br"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Alluring from every angle. ")])], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_15 = {
  class: "row content-section xtra-space d-flex justify-content-center mb-5 mb-md-6 mt-md-6 mt-5"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_16 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 p-0 d-flex flex-column justify-content-start align-items-baseline"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h2", {
  class: "fw-bold mb-3 mb-md-4"
}, "A sleek new centerpiece for your desk.")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_17 = {
  class: "col-12 d-flex m-0 p-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_18 = {
  class: "p-0 d-flex flex-row"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_19 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_20 = {
  class: "row content-section d-flex justify-content-center mb-md-6 mb-5"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_21 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 p-0 d-flex flex-column justify-content-start"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h2", {
  class: "fw-bold"
}, " A culmination of meticulous attention to detail and commitment to craft. ")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_22 = {
  class: "col-12 p-0 d-flex flex-row mt-md-4 mt-3"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_23 = {
  class: "row content-section text-dark d-flex justify-content-center flex-wrap pb-0 pb-md-5"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_24 = {
  class: "col-12"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_25 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_26 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 d-flex justify-content-start align-items-baseline"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-bolder mb-0"
}, "Incredibly Expressive")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_27 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-8 offset-4 d-flex flex justify-content-start align-items-baseline"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h2", {
  class: "fw-light w-md-75"
}, "Tailored to your personal style.")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_28 = {
  class: "row content-section text-dark d-flex justify-content-center flex-wrap pb-0 pb-md-5"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_29 = {
  class: "col-12 mt-md-6 mt-5"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_30 = {
  class: "row content d-flex section-two-background justify-content-start"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_31 = {
  class: "col-12 pe-5"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_32 = {
  class: "w-50"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_33 = {
  key: 0
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_34 = {
  class: "w-50"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_35 = {
  key: 0
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_36 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "Thousands of pairings are available right at your fingertips", -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_37 = {
  class: "row content-section xtra-space d-flex flex-wrap justify-content-center pb-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_38 = {
  class: "col-12 col-lg-6 order-2 order-lg-1"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_39 = {
  class: "d-flex flex-column justify-content-start h-100"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_40 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_41 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-lg-6 order-1 order-lg-2 pt-0 pb-lg-0 pb-md-5 pb-3"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-light oversized-title pt-0"
}, " Refined hues. Upscale finishes. Superior materials. ")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_42 = {
  class: "row content-section d-flex flex-wrap justify-content-center pb-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_43 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-lg-6 d-flex flex-column justify-content-center"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "pt-0 collage-text collage-text-2 my-3"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "A carefully formulated selection of finishes"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" designed to integrate seamlessly into any desk setup. "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("br"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("br"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "Curate your own collection"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" of accents to change the look of the Sonnet. Complement your mood -- or your favorite keycap set. ")])], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_44 = {
  class: "col-12 col-lg-6"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_45 = {
  class: "d-flex flex-column justify-content-start h-100"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_46 = {
  id: "accentCarousel",
  class: "carousel slide carousel-fade collage-2",
  "data-bs-ride": "carousel",
  "data-bs-interval": "3000",
  "data-bs-pause": "false"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_47 = {
  class: "carousel-inner"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_48 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_49 = {
  class: "row content-section d-flex flex-wrap mb-5 justify-content-center pb-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_50 = {
  class: "col-12 col-lg-6 order-2 order-lg-1"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_51 = {
  class: "d-flex flex-column justify-content-start h-100"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_52 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_53 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-lg-6 order-1 order-lg-2 d-flex flex-column justify-content-center p-lg-4 py-0"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-end"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "pt-0 collage-text collage-text-3 my-3"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "Beautiful inside and out."), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Fully-finished internal weights and bottoms — in "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "stainless steel, copper, and polycarbonate"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" — allow you to find the perfect blend of heft and acoustics. ")])])], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_54 = {
  class: "row content-section text-dark justify-content-center pb-0 mb-md-6 mb-4 mt-md-2 mt-5"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_55 = {
  class: "col-12"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_56 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_57 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-md-6 mb-md-6 d-flex flex-column justify-content-start"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-bolder mb-0"
}, "Enhanced Productivity")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_58 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-md-6 d-flex mb-md-6 mb-4 justify-content-end align-items-end"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h2", {
  class: "fw-light w-md-75"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Small details. "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("br"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Big improvements. ")])], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_59 = {
  class: "col-12 col-md-7 offset-md-5"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_60 = {
  class: "row text-light"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_61 = {
  class: "col-12 p-0 d-flex flex-row justify-content-center position-relative"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_62 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "img-text-overlay"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-bold"
}, "Make typing an event worth looking forward to")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_63 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_64 = {
  class: "row content-section text-light justify-content-center pb-4"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_65 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 d-flex flex-column justify-content-start"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal mb-1 mt-3"
}, "Features")], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_66 = {
  class: "col-12"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_67 = {
  class: "row content-section d-flex justify-content-center flex-wrap pb-0 pb-md-5"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_68 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 d-flex justify-content-start align-items-baseline mb-6"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-normal mt-4 mb-0"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Technical "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("br"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Specifications ")])], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_69 = {
  class: "col-12"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_70 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "Supported Layouts"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "text-muted-light mb-0 d-flex flex-column justify-content-center text-light",
  id: 'arrow-0'
})], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_71 = {
  class: "col-12 justify-content-center mt-4 d-flex"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_72 = ["src"];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_73 = {
  class: "col-11 justify-content-end d-flex"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_74 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h5", {
  class: "fw-light me-2"
}, "Solder", -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_75 = [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_74];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_76 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h5", {
  class: "fw-light"
}, "Hotswap", -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_77 = [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_76];
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_78 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "Box Contents"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "mb-0 d-flex text-muted-light flex-column justify-content-center text-light",
  id: 'arrow-1'
})], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_79 = {
  class: "col-7 offset-3 justify-content-center"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_80 = {
  class: "table table-sm table-borderless my-2 text-light text-muted-light"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_81 = {
  key: 0
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_82 = {
  class: "w-25 pb-1 pt-0 ps-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_83 = {
  class: "fw-normal p-0 m-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_84 = {
  key: 0,
  class: "w-75 pb-1 pt-0 ps-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_85 = {
  class: "fw-normal p-0 m-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_86 = {
  key: 1
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_87 = {
  class: "w-25 pb-1 pt-0 ps-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_88 = {
  class: "fw-normal p-0 m-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_89 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "Measurements"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "mb-0 text-muted-light d-flex flex-column justify-content-center text-light",
  id: 'arrow-2'
})], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_90 = {
  class: "col-7 offset-3 justify-content-center"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_91 = {
  class: "table table-sm table-borderless my-2 text-light text-muted-light"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_92 = {
  class: "w-25 pb-1 pt-0 ps-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_93 = {
  class: "fw-bolder p-0 m-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_94 = {
  class: "w-75 pb-1 pt-0 ps-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_95 = {
  class: "p-0 m-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_96 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "PCB"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "mb-0 d-flex text-muted-light flex-column justify-content-center text-light",
  id: 'arrow-3'
})], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_97 = {
  class: "col-7 offset-3 justify-content-center"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_98 = {
  class: "table table-sm table-borderless my-2 text-light text-muted-light"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_99 = {
  class: "w-25 pb-1 pt-0 ps-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_100 = {
  class: "fw-bolder p-0 m-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_101 = {
  class: "w-75 pb-1 pt-0 ps-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_102 = {
  class: "p-0 m-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_103 = {
  class: "text-muted-light"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_104 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "Materials"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "mb-0 d-flex text-muted-light flex-column justify-content-center text-light",
  id: 'arrow-4'
})], -1 /* HOISTED */);
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_105 = {
  class: "col-7 offset-3 justify-content-center"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_106 = {
  class: "table table-sm table-borderless my-2 text-light text-muted-light"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_107 = {
  class: "w-25 pb-1 pt-0 ps-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_108 = {
  class: "fw-bolder p-0 m-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_109 = {
  class: "w-75 pb-1 pt-0 ps-0"
};
var SonnetProductPagevue_type_template_id_3fb090a6_hoisted_110 = {
  class: "p-0 m-0"
};
function SonnetProductPagevue_type_template_id_3fb090a6_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_row_background = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("row-background");
  var _component_scroll_effect = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("scroll-effect");
  var _component_card_group = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("card-group");
  var _component_text_card_group = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("text-card-group");
  var _component_icon_card_group = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("icon-card-group");
  var _component_drop_down = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("drop-down");
  var _component_typer = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("typer");
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_1, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_2, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" HEADER "), SonnetProductPagevue_type_template_id_3fb090a6_hoisted_3, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" TAGLINE "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_row_background, {
    "bg-color": "#525556"
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_4, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_5, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
        width: "170",
        height: "170",
        src: $data.images.dots
      }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_6), SonnetProductPagevue_type_template_id_3fb090a6_hoisted_7, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_8]), SonnetProductPagevue_type_template_id_3fb090a6_hoisted_9])];
    }),
    _: 1 /* STABLE */
  }), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" CALL TO ACTION "), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" <div class=\"row content-section d-flex justify-content-center mt-4 mb-md-6 mb-5\">\n        <div class=\"col-12\"><hr class=\"mb-2\" /></div>\n\n        <div class=\"col-12 col-md-6 mb-4 mb-md-5 d-flex flex-column justify-content-start\">\n          <h3 class=\"fw-bolder m-0 mb-2\">Make it your own</h3>\n          <h6 class=\"fw-normal m-0 mb-3\"><u>From $299</u></h6>\n          <a\n            type=\"button\"\n            href=\"https://modedesigns.com/products/sonnet\"\n            target=\"_blank\"\n            class=\"btn btn-dark btn-wide\">\n            <h6 class=\"m-0 px-3\"><small>Configure Yours</small></h6>\n          </a>\n        </div>\n        <div class=\"col-12 col-md-6 d-flex flex-row justify-content-md-end\">\n          <h4 class=\"fw-normal w-md-75 text-md-start\">\n            Need some inspiration?\n            <br />\n            Start from the builds below.\n          </h4>\n        </div> "), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" CONFIG CARDS "), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" <div class=\"col-12\">\n          <div class=\"row justify-content-between\">\n            <config-card-group :configs=\"configs\"></config-card-group>\n          </div>\n        </div>\n      </div> "), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SECTION 01 "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_10, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_11, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "233",
    height: "173",
    src: $data.images.section1,
    class: "img-fluid z-index-top"
  }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_12)]), SonnetProductPagevue_type_template_id_3fb090a6_hoisted_13, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_14, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SCROLL EFFECT "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_scroll_effect, {
    sections: $data.sectionOneCopy,
    scrollHeight: 4000,
    framesSource: "".concat($props.assetHost, "/design-scroll/sonnet_scroll_animation_sequence_"),
    frameCount: 143
  }, null, 8 /* PROPS */, ["sections", "framesSource"])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" DESK SHOT 01 "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_15, [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_16, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" FULL WIDTH IMAGE "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_17, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_18, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "1400",
    height: "738",
    class: "img-fluid",
    loading: "lazy",
    src: $data.images.desk1
  }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_19)])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SECTION-03 "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_20, [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_21, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" THREE IMAGE SEQUENCE "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_22, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_card_group, {
    cards: $options.cards
  }, null, 8 /* PROPS */, ["cards"])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SECTION 04 "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_23, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_24, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "233",
    height: "173",
    src: $data.images.section2,
    class: "img-fluid"
  }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_25)]), SonnetProductPagevue_type_template_id_3fb090a6_hoisted_26, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_27]), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_row_background, {
    "bg-image": $data.images.expressiveHeader
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_28, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_29, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_30, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_31, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_32, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
        class: (0,shared_esm_bundler/* normalizeClass */.C4)({
          'fw-bold': !$options.isMobile()
        })
      }, " A keyboard that is a reflection of you. ", 2 /* CLASS */), !$options.isMobile() ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("span", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_33, " Whether you’re seeking a minimalist aesthetic or trying to make a bold statement, the Sonnet has you covered. ")) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_34, [(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Visualize your dream keyboard in real time through our live configurator. "), !$options.isMobile() ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("span", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_35, [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_36, (0,runtime_core_esm_bundler/* createTextVNode */.eW)(" — none of which you can go wrong with. ")])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)])])])])])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["bg-image"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SECTION 05 "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_37, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_38, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_39, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "636",
    height: "509",
    class: "img-fluid collage-1",
    src: $data.images.materialsSpread
  }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_40)])]), SonnetProductPagevue_type_template_id_3fb090a6_hoisted_41]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_42, [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_43, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_44, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_45, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_46, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_47, [((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(6, function (i) {
    return (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
      key: i,
      class: (0,shared_esm_bundler/* normalizeClass */.C4)(["carousel-item", {
        active: i === 1
      }])
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      width: "636",
      height: "636",
      src: $data.images.accents + "".concat(1, "-v2.webp"),
      class: "d-block w-100"
    }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_48)], 2 /* CLASS */);
  }), 64 /* STABLE_FRAGMENT */))])])])])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_49, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_50, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_51, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "636",
    height: "795",
    class: "img-fluid collage-3",
    src: $data.images.bottoms
  }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_52)])]), SonnetProductPagevue_type_template_id_3fb090a6_hoisted_53]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" <div class=\"row content-section\">\n        <div class=\"col-12 col-md-6\">\n          <h1 class=\"fw-light oversized-title pt-0 mb-md-5 mb-3\">\n            Find your signature sound and feel.\n          </h1>\n        </div>\n        <div class=\"col-12\">\n          <scroll-effect\n            :sections=\"mountScrollCopy\"\n            :scrollHeight=\"2900\"\n            :textMiddle=\"true\"\n            :framesSource=\"`${assetHost}/mount-scroll/scroll2_`\"\n            :frameCount=\"58\"></scroll-effect>\n        </div>\n      </div> "), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SECTION 06 "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_54, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_55, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "233",
    height: "173",
    src: $data.images.section3,
    class: "img-fluid"
  }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_56)]), SonnetProductPagevue_type_template_id_3fb090a6_hoisted_57, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_58, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_59, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_text_card_group, {
    cards: $options.textCards
  }, null, 8 /* PROPS */, ["cards"])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" </row-background> "), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SECTION 07 "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_row_background, {
    bgColor: "#1b1d1c"
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_60, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_61, [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_62, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
        width: "3840",
        height: "2160",
        class: "img-full-width",
        loading: "lazy",
        src: $data.images.desk2
      }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_63)])])];
    }),
    _: 1 /* STABLE */
  }), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SECTION 08 "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_row_background, {
    bgColor: "#333333"
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_64, [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_65, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_66, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_icon_card_group, {
        class: "mt-5",
        cards: $options.featureCards
      }, null, 8 /* PROPS */, ["cards"])])])];
    }),
    _: 1 /* STABLE */
  }), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" TECHNICAL SPECIFICATIONS "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_row_background, {
    bgColor: "#1b1c1d",
    class: "text-light"
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_67, [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_68, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_69, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SUPPORTED LAYOUTS"), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.layouts.show,
        arrow: 'arrow-0',
        light: true,
        class: "mb-4",
        onToggle: _cache[2] || (_cache[2] = function ($event) {
          return $options.specs.layouts.show = !$options.specs.layouts.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_70];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_71, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
            width: "1296",
            height: "456",
            class: "img-fluid text-muted-light",
            src: $data.showSolder ? $options.specs.layouts.solderImg : $options.specs.layouts.hotswapImg
          }, null, 8 /* PROPS */, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_72)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_73, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return $data.showSolder = true;
            }),
            class: (0,shared_esm_bundler/* normalizeClass */.C4)(["clickable", [$data.showSolder ? 'text-decoration-underline' : '']])
          }, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_75, 2 /* CLASS */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return $data.showSolder = false;
            }),
            class: (0,shared_esm_bundler/* normalizeClass */.C4)(["clickable", [$data.showSolder ? '' : 'text-decoration-underline']])
          }, SonnetProductPagevue_type_template_id_3fb090a6_hoisted_77, 2 /* CLASS */)])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" BOX CONTENTS "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.boxContents.show,
        arrow: 'arrow-1',
        light: true,
        class: "mb-4",
        onToggle: _cache[3] || (_cache[3] = function ($event) {
          return $options.specs.boxContents.show = !$options.specs.boxContents.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_78];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_79, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("table", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_80, [!$options.isMobile() ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tbody", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_81, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.boxContents.rows, function (i) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: i
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_82, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_83, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.boxContents.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)($options.specs.boxContents.contents[i - 1]), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])]), $options.specs.boxContents.contents.length - i > i ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("td", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_84, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_85, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.boxContents.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)($options.specs.boxContents.contents[$options.specs.boxContents.contents.length - i]), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)]);
          }), 128 /* KEYED_FRAGMENT */))])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tbody", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_86, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.boxContents.contents, function (c) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: c
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_87, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_88, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.boxContents.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(c), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])]);
          }), 128 /* KEYED_FRAGMENT */))]))])])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" MEASUREMENTS "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.measurements.show,
        arrow: 'arrow-2',
        light: true,
        class: "mb-4",
        onToggle: _cache[4] || (_cache[4] = function ($event) {
          return $options.specs.measurements.show = !$options.specs.measurements.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_89];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_90, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("table", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_91, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("tbody", null, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.measurements.data, function (m, i) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: i
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_92, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_93, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.measurements.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.name), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_94, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_95, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.measurements.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.value), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])]);
          }), 128 /* KEYED_FRAGMENT */))])])])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" PCB "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.pcb.show,
        arrow: 'arrow-3',
        light: true,
        class: "mb-4",
        onToggle: _cache[5] || (_cache[5] = function ($event) {
          return $options.specs.pcb.show = !$options.specs.pcb.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_96];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_97, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("table", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_98, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("tbody", null, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.pcb.data, function (m, i) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: i
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_99, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_100, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.pcb.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.name), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_101, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_102, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.pcb.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.value), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])]);
          }), 128 /* KEYED_FRAGMENT */))])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_103, (0,shared_esm_bundler/* toDisplayString */.v_)($options.specs.pcb.footnote), 1 /* TEXT */)])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" MATERIALS "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.pcb.show,
        arrow: 'arrow-4',
        light: true,
        class: "mb-4",
        onToggle: _cache[6] || (_cache[6] = function ($event) {
          return $options.specs.materials.show = !$options.specs.materials.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [SonnetProductPagevue_type_template_id_3fb090a6_hoisted_104];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_105, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("table", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_106, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("tbody", null, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.materials.data, function (m, i) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: i
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_107, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_108, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.materials.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.name), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_109, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", SonnetProductPagevue_type_template_id_3fb090a6_hoisted_110, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.materials.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.value), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])]);
          }), 128 /* KEYED_FRAGMENT */))])])])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"])])])];
    }),
    _: 1 /* STABLE */
  })])]);
}
;// CONCATENATED MODULE: ./src/Apps/SonnetProductPage.vue?vue&type=template&id=3fb090a6

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/CardGroup.vue?vue&type=template&id=486ca6e5

var CardGroupvue_type_template_id_486ca6e5_hoisted_1 = {
  class: "row"
};
var CardGroupvue_type_template_id_486ca6e5_hoisted_2 = {
  class: "card border-light me-sm-5"
};
var CardGroupvue_type_template_id_486ca6e5_hoisted_3 = ["src"];
var CardGroupvue_type_template_id_486ca6e5_hoisted_4 = {
  class: "card-body row pt-1 pt-md-2"
};
var CardGroupvue_type_template_id_486ca6e5_hoisted_5 = {
  class: "col-12"
};
var CardGroupvue_type_template_id_486ca6e5_hoisted_6 = {
  class: "card-title"
};
var CardGroupvue_type_template_id_486ca6e5_hoisted_7 = {
  class: "col-12"
};
var CardGroupvue_type_template_id_486ca6e5_hoisted_8 = {
  class: "card-text"
};
function CardGroupvue_type_template_id_486ca6e5_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" <div class=\"card-group\"> "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", CardGroupvue_type_template_id_486ca6e5_hoisted_1, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.cards, function (card, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: index,
      class: (0,shared_esm_bundler/* normalizeClass */.C4)(["col-12 col-lg-4", [index < $props.cards.length - 1 ? 'mb-3' : 'mb-0']])
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", CardGroupvue_type_template_id_486ca6e5_hoisted_2, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      width: "2250",
      height: "auto",
      src: card.image,
      class: "card-img-top",
      alt: "..."
    }, null, 8 /* PROPS */, CardGroupvue_type_template_id_486ca6e5_hoisted_3), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", CardGroupvue_type_template_id_486ca6e5_hoisted_4, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", CardGroupvue_type_template_id_486ca6e5_hoisted_5, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", CardGroupvue_type_template_id_486ca6e5_hoisted_6, (0,shared_esm_bundler/* toDisplayString */.v_)(card.title), 1 /* TEXT */)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", CardGroupvue_type_template_id_486ca6e5_hoisted_7, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", CardGroupvue_type_template_id_486ca6e5_hoisted_8, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, (0,shared_esm_bundler/* toDisplayString */.v_)(card.caption), 1 /* TEXT */)])])])])], 2 /* CLASS */);
  }), 128 /* KEYED_FRAGMENT */))]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" </div> ")], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */);
}
;// CONCATENATED MODULE: ./src/components/CardGroup.vue?vue&type=template&id=486ca6e5

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/CardGroup.vue?vue&type=script&lang=js
/* harmony default export */ const CardGroupvue_type_script_lang_js = ({
  name: "card-group",
  props: {
    cards: Array
  }
});
;// CONCATENATED MODULE: ./src/components/CardGroup.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/CardGroup.vue




;
const CardGroup_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(CardGroupvue_type_script_lang_js, [['render',CardGroupvue_type_template_id_486ca6e5_render]])

/* harmony default export */ const CardGroup = (CardGroup_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/ConfigCardGroup.vue?vue&type=template&id=919727f2

var ConfigCardGroupvue_type_template_id_919727f2_hoisted_1 = ["src"];
var ConfigCardGroupvue_type_template_id_919727f2_hoisted_2 = ["onClick"];
var ConfigCardGroupvue_type_template_id_919727f2_hoisted_3 = {
  class: "mb-0 title"
};
var ConfigCardGroupvue_type_template_id_919727f2_hoisted_4 = ["href"];
var ConfigCardGroupvue_type_template_id_919727f2_hoisted_5 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "m-0 px-3"
}, "Select", -1 /* HOISTED */);
var ConfigCardGroupvue_type_template_id_919727f2_hoisted_6 = [ConfigCardGroupvue_type_template_id_919727f2_hoisted_5];
function ConfigCardGroupvue_type_template_id_919727f2_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($data.mutableConfigs, function (config, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: index,
      class: "col-12 col-md-4 config-card mb-5 mb-md-0"
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      width: "auto",
      height: "auto",
      src: config.image,
      class: "img-fluid"
    }, null, 8 /* PROPS */, ConfigCardGroupvue_type_template_id_919727f2_hoisted_1), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
      class: "d-flex justify-content-between mt-3 mb-2 clickable",
      onClick: function onClick($event) {
        return $options.toggle(index);
      }
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", ConfigCardGroupvue_type_template_id_919727f2_hoisted_3, (0,shared_esm_bundler/* toDisplayString */.v_)(config.name), 1 /* TEXT */)], 8 /* PROPS */, ConfigCardGroupvue_type_template_id_919727f2_hoisted_2), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
      type: "button",
      href: 'https://modedesigns.com/products/sonnet?code=' + config.code,
      class: "btn btn-outline-dark w-100",
      target: "_blank"
    }, ConfigCardGroupvue_type_template_id_919727f2_hoisted_6, 8 /* PROPS */, ConfigCardGroupvue_type_template_id_919727f2_hoisted_4)]);
  }), 128 /* KEYED_FRAGMENT */);
}
;// CONCATENATED MODULE: ./src/components/ConfigCardGroup.vue?vue&type=template&id=919727f2

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/ConfigCardGroup.vue?vue&type=script&lang=js

/* harmony default export */ const ConfigCardGroupvue_type_script_lang_js = ({
  name: "text-card-group",
  components: {
    Typer: Typer
  },
  props: {
    configs: Array,
    images: {
      type: Object,
      default: {
        more: "https://mode-storefront.s3.us-east-2.amazonaws.com/sonnet/more.svg"
      }
    }
  },
  data() {
    return {
      mutableConfigs: this.configs
    };
  },
  methods: {
    toggle(i) {
      console.log("clicked");
      this.mutableConfigs[i].showMore = !this.mutableConfigs[i].showMore;
    },
    getConfigParts(config) {
      return [{
        type: "Top",
        option: config.top
      }, {
        type: "Bottom",
        option: config.bot
      }, {
        type: "Accent",
        option: config.accent
      }, {
        type: "Weight",
        option: config.weight
      }, {
        type: "PCB",
        option: config.pcb
      }, {
        type: "Plate",
        option: config.plate
      }, {
        type: "Foam",
        option: config.foam
      }];
    }
  }
});
;// CONCATENATED MODULE: ./src/components/ConfigCardGroup.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/ConfigCardGroup.vue




;


const ConfigCardGroup_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(ConfigCardGroupvue_type_script_lang_js, [['render',ConfigCardGroupvue_type_template_id_919727f2_render]])

/* harmony default export */ const ConfigCardGroup = (ConfigCardGroup_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/IconCardGroup.vue?vue&type=template&id=47e30cea

var IconCardGroupvue_type_template_id_47e30cea_hoisted_1 = {
  class: "row"
};
var IconCardGroupvue_type_template_id_47e30cea_hoisted_2 = {
  class: "d-flex flex-column align-items-center"
};
var IconCardGroupvue_type_template_id_47e30cea_hoisted_3 = ["src"];
var IconCardGroupvue_type_template_id_47e30cea_hoisted_4 = {
  class: "caption text-start mt-2"
};
function IconCardGroupvue_type_template_id_47e30cea_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", IconCardGroupvue_type_template_id_47e30cea_hoisted_1, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.cards, function (card, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: index,
      class: (0,shared_esm_bundler/* normalizeClass */.C4)(["col-6 col-md-4 p-2 text-center icon-card", [index + 1 > $props.cards.length / 2 ? 'mb-md-0 mb-4' : 'mb-md-5 mb-4']])
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", IconCardGroupvue_type_template_id_47e30cea_hoisted_2, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      width: "140",
      height: "100",
      class: "img-fluid",
      src: card.image
    }, null, 8 /* PROPS */, IconCardGroupvue_type_template_id_47e30cea_hoisted_3), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", IconCardGroupvue_type_template_id_47e30cea_hoisted_4, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, (0,shared_esm_bundler/* toDisplayString */.v_)(card.caption), 1 /* TEXT */)])])])], 2 /* CLASS */);
  }), 128 /* KEYED_FRAGMENT */))]);
}
;// CONCATENATED MODULE: ./src/components/IconCardGroup.vue?vue&type=template&id=47e30cea

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/IconCardGroup.vue?vue&type=script&lang=js
/* harmony default export */ const IconCardGroupvue_type_script_lang_js = ({
  name: "icon-card-group",
  props: {
    cards: Array
  }
});
;// CONCATENATED MODULE: ./src/components/IconCardGroup.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/IconCardGroup.vue




;


const IconCardGroup_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(IconCardGroupvue_type_script_lang_js, [['render',IconCardGroupvue_type_template_id_47e30cea_render]])

/* harmony default export */ const IconCardGroup = (IconCardGroup_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/ScrollEffect.vue?vue&type=template&id=4de5909e

var ScrollEffectvue_type_template_id_4de5909e_hoisted_1 = ["id"];
var ScrollEffectvue_type_template_id_4de5909e_hoisted_2 = {
  class: "col-12 p-0"
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_3 = {
  key: 0
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_4 = ["src"];
var ScrollEffectvue_type_template_id_4de5909e_hoisted_5 = {
  class: "px-3"
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_6 = {
  key: 1,
  class: "sticky-top"
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_7 = {
  class: "row"
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_8 = {
  class: "col-5 d-flex flex-column justify-content-center"
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_9 = {
  key: 0,
  class: "text-middle"
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_10 = {
  class: ""
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_11 = {
  class: "col-7"
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_12 = ["id"];
var ScrollEffectvue_type_template_id_4de5909e_hoisted_13 = {
  key: 2,
  class: "sticky-top"
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_14 = ["id"];
var ScrollEffectvue_type_template_id_4de5909e_hoisted_15 = {
  key: 0,
  class: "text-bottom"
};
var ScrollEffectvue_type_template_id_4de5909e_hoisted_16 = {
  class: "w-75"
};
function ScrollEffectvue_type_template_id_4de5909e_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SCROLL DEBUG "), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" <div\n    class=\"fixed\"\n    style=\"position: sticky; top: 5px; left: 5px; z-index: 2000\"\n  >\n    <strong>Scroll status</strong>\n    <div>Frame Index: {{ frameIndex }}</div>\n    <div>Scroll Fraction: {{ scrollFraction }}</div>\n    <div>Scroll Percent: {{ scrollFraction * 100 }}</div>\n    <div>Scroll Top: {{ scrollTop }}</div>\n    <div>maxScrollTop: {{ maxScrollTop }}</div>\n    <div>sectionIndex: {{ sectionIndex }}</div>\n  </div> "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
    id: $data.id,
    class: "row scroll-effect content flex-row-reverse mb-0 px-0 z-index-middle",
    style: (0,shared_esm_bundler/* normalizeStyle */.Tr)({
      height: $options.height
    })
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ScrollEffectvue_type_template_id_4de5909e_hoisted_2, [$options.isMobile ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ScrollEffectvue_type_template_id_4de5909e_hoisted_3, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.sections, function (section, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: index
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
      class: "img-fluid",
      src: $options.getMobileFrame(index)
    }, null, 8 /* PROPS */, ScrollEffectvue_type_template_id_4de5909e_hoisted_4), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", ScrollEffectvue_type_template_id_4de5909e_hoisted_5, (0,shared_esm_bundler/* toDisplayString */.v_)(section), 1 /* TEXT */)]);
  }), 128 /* KEYED_FRAGMENT */))])) : $props.textMiddle ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ScrollEffectvue_type_template_id_4de5909e_hoisted_6, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ScrollEffectvue_type_template_id_4de5909e_hoisted_7, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ScrollEffectvue_type_template_id_4de5909e_hoisted_8, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.sections, function (t, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: index
    }, [(0,runtime_core_esm_bundler/* createVNode */.bF)(runtime_dom_esm_bundler/* Transition */.eB, {
      name: "slide-fade",
      tag: "div"
    }, {
      default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
        return [$data.sectionIndex == index && $data.showText ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ScrollEffectvue_type_template_id_4de5909e_hoisted_9, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", ScrollEffectvue_type_template_id_4de5909e_hoisted_10, (0,shared_esm_bundler/* toDisplayString */.v_)(t), 1 /* TEXT */)])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)];
      }),
      _: 2 /* DYNAMIC */
    }, 1024 /* DYNAMIC_SLOTS */)]);
  }), 128 /* KEYED_FRAGMENT */))]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", ScrollEffectvue_type_template_id_4de5909e_hoisted_11, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("canvas", {
    id: $data.canvasId,
    class: "canvas-1-1 row"
  }, null, 8 /* PROPS */, ScrollEffectvue_type_template_id_4de5909e_hoisted_12)])])])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ScrollEffectvue_type_template_id_4de5909e_hoisted_13, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("canvas", {
    id: $data.canvasId,
    class: "canvas-16-9 row"
  }, null, 8 /* PROPS */, ScrollEffectvue_type_template_id_4de5909e_hoisted_14), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.sections, function (t, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: index,
      class: "col-12 col-md-6",
      style: {
        "max-height": "0"
      }
    }, [(0,runtime_core_esm_bundler/* createVNode */.bF)(runtime_dom_esm_bundler/* Transition */.eB, {
      name: "slide-fade",
      tag: "div"
    }, {
      default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
        return [$data.sectionIndex == index && $data.showText ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", ScrollEffectvue_type_template_id_4de5909e_hoisted_15, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", ScrollEffectvue_type_template_id_4de5909e_hoisted_16, (0,shared_esm_bundler/* toDisplayString */.v_)(t), 1 /* TEXT */)])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)];
      }),
      _: 2 /* DYNAMIC */
    }, 1024 /* DYNAMIC_SLOTS */)]);
  }), 128 /* KEYED_FRAGMENT */))]))])], 12 /* STYLE, PROPS */, ScrollEffectvue_type_template_id_4de5909e_hoisted_1)], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */);
}
;// CONCATENATED MODULE: ./src/components/ScrollEffect.vue?vue&type=template&id=4de5909e

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/ScrollEffect.vue?vue&type=script&lang=js
/* harmony default export */ const ScrollEffectvue_type_script_lang_js = ({
  name: "scrollEffect",
  props: {
    sections: Array,
    scrollHeight: Number,
    framesSource: String,
    frameCount: Number,
    textMiddle: Boolean
  },
  data() {
    return {
      id: "scroll-".concat(Math.ceil(Math.random() * 100)),
      canvasId: "canvas-".concat(Math.ceil(Math.random() * 100)),
      canvas: {},
      showText: false,
      sectionIndex: 0,
      scrollTop: 0,
      frameIndex: 0,
      scrollFraction: 0
    };
  },
  computed: {
    canvasContext() {
      return this.canvas.getContext("2d");
    },
    height() {
      return this.isMobile ? "auto" : "".concat(this.scrollHeight, "px");
    },
    isMobile() {
      var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      return vw < 768;
    }
  },
  methods: {
    currentFrame(index) {
      return "".concat(this.framesSource).concat(index, ".webp");
    },
    getMobileFrame(index) {
      var framePercent = this.frameCount / (index + 1);
      var frame = Math.ceil(this.frameCount - framePercent + 1);
      if (index === 0) frame = 1;
      if (index === this.sections.length - 1) frame = this.frameCount;
      return "".concat(this.framesSource).concat(frame, ".webp");
    },
    updateImage(img, index) {
      img.src = this.currentFrame(index);
      this.canvasContext.drawImage(img, 0, 0);
    },
    preloadImages() {
      if (this.isMobile) return;
      console.log("preloading scroll");
      for (var i = 1; i < this.frameCount; i++) {
        var res = document.createElement("link");
        res.rel = "preload";
        res.as = "image";
        res.href = this.currentFrame(i);
        document.head.appendChild(res);
      }
    }
  },
  mounted() {
    this.preloadImages();
    this.$nextTick(function () {
      var _this = this;
      if (this.isMobile) return;
      this.canvas = document.getElementById(this.canvasId);
      this.canvas.width = this.textMiddle ? 1350 : 1920;
      this.canvas.height = this.textMiddle ? 1350 : 1080;
      var img = new Image();
      img.src = this.currentFrame(1);
      img.onload = function () {
        _this.canvasContext.drawImage(img, 0, 0);
      };
      window.addEventListener("scroll", function () {
        var scrollElement = document.getElementById(_this.id);
        if (!scrollElement) return;
        var boundingRect = scrollElement.getBoundingClientRect();
        var scrollTop = boundingRect.top * -1;
        _this.scrollTop = scrollTop;
        if (scrollTop < 0) return;
        var maxScrollTop = scrollElement.scrollHeight - window.innerHeight;
        var scrollFraction = Math.min(scrollTop / maxScrollTop, 1); //maxScrollTop - 0.26; //offset on when to start effect
        var togglePoints = _this.sections.length * 2 - 2;
        _this.scrollFraction = scrollFraction;
        _this.maxScrollTop = maxScrollTop;
        var sectionIndex = Math.min(_this.sections.length, Math.floor(scrollFraction * togglePoints));
        _this.showText = Math.min(togglePoints, Math.floor(scrollFraction * togglePoints)) % 2 === 0 || scrollFraction > 0.89;
        var frameIndex = Math.min(_this.frameCount, Math.ceil(scrollFraction * _this.frameCount) || 1);
        _this.frameIndex = frameIndex;
        _this.sectionIndex = Math.min(Math.max(sectionIndex - 1, 0), _this.sections.length - 1);
        requestAnimationFrame(function () {
          return _this.updateImage(img, frameIndex);
        });
      }, {
        passive: true
      });
    });
  }
});
;// CONCATENATED MODULE: ./src/components/ScrollEffect.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/ScrollEffect.vue




;


const ScrollEffect_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(ScrollEffectvue_type_script_lang_js, [['render',ScrollEffectvue_type_template_id_4de5909e_render]])

/* harmony default export */ const ScrollEffect = (ScrollEffect_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/TextCardGroup.vue?vue&type=template&id=67fda8cd

var TextCardGroupvue_type_template_id_67fda8cd_hoisted_1 = {
  class: "row content d-flex flex justify-content-between"
};
var TextCardGroupvue_type_template_id_67fda8cd_hoisted_2 = {
  class: "d-flex flex-column justify-content-between",
  style: {
    "height": "130px"
  }
};
var TextCardGroupvue_type_template_id_67fda8cd_hoisted_3 = {
  class: "superscript"
};
var TextCardGroupvue_type_template_id_67fda8cd_hoisted_4 = {
  class: "title"
};
var TextCardGroupvue_type_template_id_67fda8cd_hoisted_5 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("hr", {
  class: "divider"
}, null, -1 /* HOISTED */);
var TextCardGroupvue_type_template_id_67fda8cd_hoisted_6 = {
  class: "text"
};
function TextCardGroupvue_type_template_id_67fda8cd_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", TextCardGroupvue_type_template_id_67fda8cd_hoisted_1, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.cards, function (card, index) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: index,
      class: "col-12 col-md-4 text-card"
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", TextCardGroupvue_type_template_id_67fda8cd_hoisted_2, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", TextCardGroupvue_type_template_id_67fda8cd_hoisted_3, "0" + (0,shared_esm_bundler/* toDisplayString */.v_)(index), 1 /* TEXT */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", TextCardGroupvue_type_template_id_67fda8cd_hoisted_4, (0,shared_esm_bundler/* toDisplayString */.v_)(card.title), 1 /* TEXT */), TextCardGroupvue_type_template_id_67fda8cd_hoisted_5]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", TextCardGroupvue_type_template_id_67fda8cd_hoisted_6, (0,shared_esm_bundler/* toDisplayString */.v_)(card.caption), 1 /* TEXT */)]);
  }), 128 /* KEYED_FRAGMENT */))]);
}
;// CONCATENATED MODULE: ./src/components/TextCardGroup.vue?vue&type=template&id=67fda8cd

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/components/TextCardGroup.vue?vue&type=script&lang=js
/* harmony default export */ const TextCardGroupvue_type_script_lang_js = ({
  name: "text-card-group",
  props: {
    cards: Array
  }
});
;// CONCATENATED MODULE: ./src/components/TextCardGroup.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/components/TextCardGroup.vue




;


const TextCardGroup_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(TextCardGroupvue_type_script_lang_js, [['render',TextCardGroupvue_type_template_id_67fda8cd_render]])

/* harmony default export */ const TextCardGroup = (TextCardGroup_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/SonnetProductPage.vue?vue&type=script&lang=js








/* harmony default export */ const SonnetProductPagevue_type_script_lang_js = ({
  name: "sonnet-product-page",
  props: {
    assetHost: {
      type: String,
      default: "../src/assets"
    }
  },
  components: {
    Typer: Typer,
    ScrollEffect: ScrollEffect,
    RowBackground: RowBackground,
    CardGroup: CardGroup,
    TextCardGroup: TextCardGroup,
    IconCardGroup: IconCardGroup,
    ConfigCardGroup: ConfigCardGroup,
    DropDown: DropDown
  },
  data() {
    return {
      selectedMounting: "stack",
      showSolder: true,
      images: {
        header: "".concat(this.assetHost, "/header-v2.jpg"),
        desk1: "".concat(this.assetHost, "/desk-1-v2.webp"),
        closeup1: "".concat(this.assetHost, "/closeup-1-v2.webp"),
        closeup2: "".concat(this.assetHost, "/closeup-2-v2.webp"),
        closeup3: "".concat(this.assetHost, "/closeup-3-v2.webp"),
        expressiveHeader: "".concat(this.assetHost, "/expressive-header.webp"),
        materialsSpread: "".concat(this.assetHost, "/materials-spread-v2.webp"),
        accents: "".concat(this.assetHost, "/accent-"),
        bottoms: "".concat(this.assetHost, "/bottoms-v2.webp"),
        dots: "".concat(this.assetHost, "/dot_matrix.svg"),
        section1: "".concat(this.assetHost, "/section-1.svg"),
        section2: "".concat(this.assetHost, "/section-2.svg"),
        section3: "".concat(this.assetHost, "/section-3.svg"),
        desk2: "".concat(this.assetHost, "/desk-2-v2.webp"),
        feature1: "".concat(this.assetHost, "/feature-1.svg"),
        feature2: "".concat(this.assetHost, "/feature-2.svg"),
        feature3: "".concat(this.assetHost, "/feature-3.svg"),
        feature4: "".concat(this.assetHost, "/feature-4.svg"),
        feature5: "".concat(this.assetHost, "/feature-5.svg"),
        feature6: "".concat(this.assetHost, "/feature-6.svg"),
        config1: "".concat(this.assetHost, "/config-1.webp"),
        config2: "".concat(this.assetHost, "/config-2.webp"),
        config3: "".concat(this.assetHost, "/config-3.webp"),
        arrowLeft: "".concat(this.assetHost, "/arrow-left.svg"),
        arrowRight: "".concat(this.assetHost, "/arrow-right.svg"),
        more: "".concat(this.assetHost, "/more.svg"),
        sonnetSolder: "".concat(this.assetHost, "/sonnet_solder.webp"),
        sonnetHotswap: "".concat(this.assetHost, "/sonnet_hotswap.webp")
      },
      sectionOneCopy: ["The Sonnet’s gently-sculpted, precision-milled form is a testament to our relentless pursuit of the ultimate keyboard.", "The tapered silhouette enhances handling of the Sonnet on your desk — with a smooth surface that’s pleasant to the touch.", "The expansive accent adorning the face of the Sonnet makes a decisive statement with your selection of finish and material."],
      mountScrollCopy: ["Seven versatile plate materials. Two distinct mounting styles. Each providing a unique sound and level of flexibility.", "Isolated Top Mount for an open sound signature and bouncy typing feel.", "Lattice Block Mount for a soft typying feel that can be tuned to be stiffer."]
    };
  },
  computed: {
    cards() {
      return [{
        image: this.images.closeup1,
        title: "Fine Craftsman\u00adship",
        caption: "Intended to last a lifetime, the  precision-milled chassis features durable yet beautiful surface finishes."
      }, {
        image: this.images.closeup2,
        title: "Uncompro\u00admising Standards",
        caption: "Carefully handled and individually inspected, each piece is held to our highest quality standards."
      }, {
        image: this.images.closeup3,
        title: "A Joy to Build",
        caption: "A satisfying and intuitive assembly process that will make you proud to use the Sonnet every day."
      }];
    },
    featureCards() {
      return [{
        image: this.images.feature1,
        caption: "macOS, Windows, and Linux support"
      }, {
        image: this.images.feature2,
        caption: "Programmable through QMK/VIA"
      }, {
        image: this.images.feature3,
        caption: "Hotswap or solder PCB"
      }, {
        image: this.images.feature4,
        caption: "Isolated Top Mount or Lattice Block Mount"
      }, {
        image: this.images.feature5,
        caption: "ANSI or ISO"
      }, {
        image: this.images.feature6,
        caption: "Optional sound dampening"
      }];
    },
    textCards() {
      return [{
        title: "Optimized form factor",
        caption: "A symmetrical, compact layout that retains a full function row and arrow keys."
      }, {
        title: "Increased focus",
        caption: "Reduced travel between keyboard and mouse, improving ergonomics and focus."
      }, {
        title: "The power of keymaps",
        caption: "Easy access to your own shortcuts on any key, making you more efficient than ever."
      }];
    },
    configs() {
      return [{
        name: "Alexotos' Build",
        description: "Alex’s personal configuration. A subtle colorway and perfectly neutral sound profile.",
        top: "Green",
        bot: "Silver Mirror",
        accent: "Silver Mirror",
        weight: "Brushed Stainless",
        pcb: "Solder",
        plate: "Aluminum",
        mount: "Isolated Top",
        foam: "Yes",
        showMore: true,
        image: this.images.config1,
        code: "V0B1G2H3A4A5B6E7B9A"
      }, {
        name: "Taeha Types' Build",
        description: "Taeha’s personal configuration. A classy exterior with a crisp and clean sound profile.",
        top: "Black",
        bot: "Silver Mirror",
        accent: "Silver Mirror",
        weight: "Black",
        pcb: "Hotswap",
        plate: "Carbon Fiber",
        mount: "Isolated Top",
        foam: "No",
        showMore: false,
        image: this.images.config2,
        code: "V0A1G2H3C4B5B6A7A8B9A"
      }, {
        name: "Featured Build",
        description: "A crowd-favorite specification and an excellent starting point for your journey with the Sonnet.",
        top: "White",
        bot: "Gold",
        accent: "Gold",
        weight: "Black",
        pcb: "Hotswap",
        plate: "Aluminum",
        mount: "Stack",
        foam: "Yes",
        showMore: false,
        image: this.images.config3,
        code: "V0G1D2E3E4B5B6A7B8B9A"
      }];
    },
    specs() {
      return {
        layouts: {
          show: true,
          solderImg: this.images.sonnetSolder,
          hotswapImg: this.images.sonnetHotswap
        },
        boxContents: {
          show: false,
          rows: 7,
          contents: ["Top case", "Bottom case", "Plate", "Internal weight", "Accent", "PCB", "Carry case", "Daughterboard", "Mounting Blocks", "Feet", "Fasteners", "Keycap and switch puller", "Screwdriver"]
        },
        measurements: {
          show: false,
          data: [{
            name: "Typing angle",
            value: "5.5 degrees"
          }, {
            name: "Front Height",
            value: "19mm"
          }, {
            name: "Width",
            value: "315mm"
          }, {
            name: "Depth",
            value: "143mm"
          }, {
            name: "Weight",
            value: "3lbs-7.5lbs assembled"
          }]
        },
        pcb: {
          show: false,
          data: [{
            name: "Switches",
            value: "80-83 MX-style switches"
          }, {
            name: "Connection",
            value: "USB-C"
          }, {
            name: "Thickness",
            value: "1.6mm"
          }, {
            name: "Options",
            value: "Hotswap or Solder"
          }, {
            name: "Firmware",
            value: "QMK/VIA supported"
          }, {
            name: "MCU",
            value: "ARM"
          }],
          footnote: "Designed by Gondolindrim"
        },
        materials: {
          show: false,
          data: [{
            name: "Top Case",
            value: "Aluminum, Polycarbonate"
          }, {
            name: "Bottom Case",
            value: "Aluminum, Copper, Polycarbonate"
          }, {
            name: "Accent",
            value: "Aluminum, Stainless Steel, Copper, Maple, Walnut"
          }, {
            name: "Weight",
            value: "Aluminum, Copper, Stainless Steel"
          }, {
            name: "Plate",
            value: "Aluminum, Carbon Fiber, Copper, FR4, POM, Polycarbonate, Polypropelene"
          }]
        }
      };
    }
  },
  methods: {
    isMobile() {
      var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      return vw < 768;
    },
    preloadImages() {
      var images = [this.images.header, this.images.dots];
      for (var img of images) {
        var res = document.createElement("link");
        res.rel = "preload";
        res.as = "image";
        res.href = img;
        document.head.appendChild(res);
      }
    }
  },
  mounted() {
    console.log("preloading images");
    this.preloadImages();
  }
});
;// CONCATENATED MODULE: ./src/Apps/SonnetProductPage.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Apps/SonnetProductPage.vue




;


const SonnetProductPage_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(SonnetProductPagevue_type_script_lang_js, [['render',SonnetProductPagevue_type_template_id_3fb090a6_render]])

/* harmony default export */ const SonnetProductPage = (SonnetProductPage_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/OakAccentLanding.vue?vue&type=template&id=48b0e31f

var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_1 = {
  id: "oak-accent-page-app"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_2 = {
  class: "container-fluid"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_3 = {
  id: "keycaps-header",
  class: "row hero content-section mb-5"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_4 = {
  class: "col-12 d-flex justify-content-center mb-4"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_5 = ["src"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_6 = {
  class: "col-12 mt-4 mt-md-0 mb-3"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_7 = ["src"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_8 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 mt-4 mt-md-0 text-center"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "text-muted text-uppercase"
}, "Special Edition White Oak Accent")], -1 /* HOISTED */);
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_9 = {
  class: "col-12 position-relative d-flex justify-content-center"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_10 = {
  class: "scroll-indicator"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_11 = ["src"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_12 = {
  class: "row content-section px-md-5 pb-md-0 my-5 justify-content-between"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_13 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-lg-6 justify-content-center d-flex flex-column text-light px-md-4"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "email-card px-4 py-3"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h3", {
  class: "fw-light"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" A "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "Mod Musings"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Collaboration ")]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "mt-md-4 fw-light mb-3"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" We teamed up with Mod Musings to create the "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "Special Edition White Oak Accent"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" for the "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
  class: "dark-link",
  href: "/pages/sonnet"
}, "Sonnet"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(". It combines industrial and organic materials to bring an air of warmth and sophistication to your desk. ")])]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "mb-2 fw-light"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("strong", null, "Available Now."), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" While supplies last. ")])]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "mt-4"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
  type: "button",
  href: "https://modedesigns.com/products/special-edition-white-oak-accent",
  class: "btn btn-outline-light py-1 w-100"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "mb-0"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, "Purchase")])])])])], -1 /* HOISTED */);
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_14 = {
  class: "col-12 col-lg-6 d-none d-lg-block px-md-4"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_15 = {
  class: ""
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_16 = ["src"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_17 = {
  class: "row content-section mt-6 mb-lg-6"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_18 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-lg-6 text-center order-2 order-lg-1"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex flex-column justify-content-center h-100"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h3", {
  class: "fw-bold"
}, "About Mod Musings"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, "Mod Musings is a design studio out of Los Angeles, California. The maker and media brand creates content and products focused on improving the way we work.")]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, "Mod Musings is the solo practice of creative director Matthew Encina, a multi-disciplinary creative with a 19-year background in design, advertising, branding, and education. He is recognized by the creative industry, winning multiple awards, including 3 CLIOS for his work with Xbox and 3 Webby Awards for “Ink,” the groundbreaking interactive music video for Coldplay.")]), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", null, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", null, " Previously Matthew served as a creative director at Blind and was the Chief Content Officer at The Futur. Now Matthew spends his days tinkering, building, and documenting his process in his studio to explore his creativity. ")])])], -1 /* HOISTED */);
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_19 = {
  class: "col-12 col-lg-6 text-center order-1 order-lg-2 mb-3 mb-lg-0"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_20 = ["src"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_21 = {
  class: "row content-section mt-5 mb-md-6"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_22 = {
  class: "col-12 text-start"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_23 = ["poster"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_24 = ["src"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_25 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "text-muted position-relative"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", {
  style: {
    "font-size": "0.675rem",
    "position": "relative",
    "top": "-10px"
  }
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("em", null, "Purchase includes premium white oak accent in special edition packaging. Sonnet keyboard not included.")])], -1 /* HOISTED */);
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_26 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"row content-section mt-5\"><div class=\"col-12 col-md-6 text-start\"><div class=\"d-flex flex-column justify-content-start h-100\"><h1 class=\"fw-bold\">Inspiration and accent details</h1><p><small>The combination of organic materials like wood with industrial materials like aluminum creates a modern and sophisticated aesthetic. This blend of natural and man-made elements brings warmth and texture to a space.</small></p></div></div><div class=\"col-12 col-md-6 text-start\"><p><strong>Why White Oak</strong><br><small> Its warm color and distinct grain pattern add a touch of elegance to your desk. It’s durability and resistance to warping make it a wonderful choice for this application. </small></p><p><strong>Hand Finished</strong><br><small> Each accent is sanded by hand for a smooth and refined finish. Finally, we coat the wood with natural oil to enhance its beauty and protect it from daily wear and tear. Each piece is unique and no two will look exactly the same. </small></p></div></div>", 1);
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_27 = {
  class: "row content-section"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_28 = {
  class: "d-none d-md-block col-md-6 text-center"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_29 = ["src"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_30 = {
  class: "col-12 col-md-6 text-start d-flex flex-column justify-content-center"
};
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_31 = ["src"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_32 = ["src"];
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_33 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "text-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", {
  style: {
    "font-size": "0.675rem",
    "position": "relative",
    "line-height": "0.675rem"
  }
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("em", null, "Expect variances in the color and grain pattern from the accent shown.")])])], -1 /* HOISTED */);
var OakAccentLandingvue_type_template_id_48b0e31f_hoisted_34 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"row hero content-section mb-6\"><div class=\"col-12 col-lg-6 offset-lg-3 col-md-8 offset-md-2 d-flex flex-column justify-content-center\"><div class=\"d-inline-flex flex-row align-items-center justify-content-center mb-3\"><h3 class=\"fw-lightest me-3\">Available <strong>Now</strong></h3></div><div class=\"d-flex fw-light justify-content-center\"><p class=\"mt-3\"> The <strong>Special edition White Oak Accent is</strong> available now <strong>in-stock for $45.</strong> Follow the link below to order. </p></div><div class=\"d-flex fw-light justify-content-start mt-2\"><a type=\"button\" href=\"https://modedesigns.com/products/special-edition-white-oak-accent\" class=\"btn btn-outline-dark py-1 w-100\"><h6 class=\"mb-0\"><small>Purchase</small></h6></a></div></div></div>", 1);
function OakAccentLandingvue_type_template_id_48b0e31f_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _this = this;
  var _component_row_background = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("row-background");
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_1, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_2, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" HERO "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_3, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_4, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img",
    width: "478",
    height: "61",
    alt: "Mode and Mod Musings logos",
    src: this.assetHost + '/oak-landing/oak-accent-logo.svg'
  }, null, 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_5)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_6, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid",
    width: "1100",
    height: "530",
    src: this.assetHost + '/oak-landing/oak-accent-header-v2.jpg'
  }, null, 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_7)]), OakAccentLandingvue_type_template_id_48b0e31f_hoisted_8, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_9, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_10, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img",
    width: "80",
    height: "80",
    alt: "indicator showing you can scroll down",
    src: this.assetHost + '/oak-landing/scroll-indicator.svg'
  }, null, 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_11)])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" EMAIL FORM "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_row_background, {
    "bg-color": "#5A5A5A",
    "bg-image": $props.assetHost + '/oak-landing/wood_grain-v2.svg'
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_12, [OakAccentLandingvue_type_template_id_48b0e31f_hoisted_13, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_14, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_15, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
        class: "img-fluid obscura-img-workspace",
        width: "440",
        height: "660",
        style: {
          "width": "170%"
        },
        src: _this.assetHost + '/oak-landing/oak-accent-feature-v2.jpg'
      }, null, 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_16)])])])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["bg-image"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" ABOUT MOD MUSINGS "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_17, [OakAccentLandingvue_type_template_id_48b0e31f_hoisted_18, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_19, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid obscura-img-workspace",
    width: "500",
    height: "500",
    src: this.assetHost + '/oak-landing/oak-accent-modmusings.jpg'
  }, null, 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_20)])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" FULL WIDTH IMAGE "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_21, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_22, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" <img\n            class=\"img-fluid obscura-img-workspace\"\n            width=\"1100\"\n            height=\"620\"\n            :src=\"this.assetHost + '/oak-landing/oak-accent-banner.jpg'\"\n          /> "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("video", {
    ref: "videoPlayer",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.togglePlay && $options.togglePlay(...arguments);
    }),
    width: "1100",
    height: "620",
    style: {
      "cursor": "pointer"
    },
    autoplay: "",
    class: "img-fluid",
    muted: "",
    loop: "",
    poster: this.assetHost + '/oak-landing/oak-accent-banner.jpg'
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("source", {
    src: this.assetHost + '/oak-landing/oak-landing-video.mp4',
    type: "video/mp4"
  }, null, 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_24), (0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Your browser does not support the video tag. ")], 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_23), OakAccentLandingvue_type_template_id_48b0e31f_hoisted_25])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" ACCENT DETAILS "), OakAccentLandingvue_type_template_id_48b0e31f_hoisted_26, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" GALLERY "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_27, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_28, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid obscura-img-workspace",
    width: "562",
    height: "831",
    src: this.assetHost + '/oak-landing/oak-accent-tall.jpg'
  }, null, 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_29)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", OakAccentLandingvue_type_template_id_48b0e31f_hoisted_30, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid obscura-img-workspace mb-4",
    width: "528",
    height: "292",
    src: this.assetHost + '/oak-landing/oak-accent-small-1.jpg'
  }, null, 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_31)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid obscura-img-workspace",
    width: "528",
    height: "292",
    src: this.assetHost + '/oak-landing/oak-accent-small-2.jpg'
  }, null, 8 /* PROPS */, OakAccentLandingvue_type_template_id_48b0e31f_hoisted_32)])]), OakAccentLandingvue_type_template_id_48b0e31f_hoisted_33]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" CTA "), OakAccentLandingvue_type_template_id_48b0e31f_hoisted_34])]);
}
;// CONCATENATED MODULE: ./src/Apps/OakAccentLanding.vue?vue&type=template&id=48b0e31f

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/OakAccentLanding.vue?vue&type=script&lang=js


/* harmony default export */ const OakAccentLandingvue_type_script_lang_js = ({
  name: "oak-accent-page",
  props: {
    assetHost: {
      type: String,
      default: "../src/assets"
    }
  },
  components: {
    RowBackground: RowBackground
  },
  data() {
    return {
      cube: {},
      scene: {},
      renderer: {},
      resizeTimeout: undefined,
      updateFaces: true,
      updateZNegative: true,
      rotations: 1,
      images: {},
      selectedCoverage: "option1",
      compatibilityOpen: false,
      carouselfFunctionality: {},
      carouselfFunctionalityOne: {}
    };
  },
  methods: {
    updateFunctionalityImage(target) {
      this.carouselfFunctionality.to(target);
      this.carouselfFunctionalityOne.to(target);
    },
    togglePlay() {
      console.log("taoggl", this.$refs.videoPlayer);
      if (this.$refs.videoPlayer.paused) {
        this.$refs.videoPlayer.play();
      } else {
        this.$refs.videoPlayer.pause();
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      var functionalityTab = document.querySelector("#functionalityTab");
      var tab = new bootstrap_esm/* Tab */.oz(functionalityTab);
      var carouselOne = document.querySelector("#carouselfFunctionalityOne");
      this.carouselfFunctionalityOne = new bootstrap_esm/* Carousel */.FN(carouselOne, {
        interval: false,
        wrap: false
      });
      var carousel = document.querySelector("#carouselfFunctionality");
      this.carouselfFunctionality = new bootstrap_esm/* Carousel */.FN(carousel, {
        interval: false,
        wrap: false
      });
    });
  }
});
;// CONCATENATED MODULE: ./src/Apps/OakAccentLanding.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Apps/OakAccentLanding.vue




;


const OakAccentLanding_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(OakAccentLandingvue_type_script_lang_js, [['render',OakAccentLandingvue_type_template_id_48b0e31f_render]])

/* harmony default export */ const OakAccentLanding = (OakAccentLanding_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/EnvoyLandingPage.vue?vue&type=template&id=e1dd7e5c

var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_1 = {
  id: "envoy-landing-page-app"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_2 = {
  class: "container-fluid"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_3 = {
  id: "envoy-header",
  class: "row hero content-section"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_4 = {
  class: "col-12 mt-4 mt-md-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_5 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_6 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 mt-5 mb-5 text-center"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "text-muted fw-light my-4"
}, "The next stop on your keyboard voyage"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("a", {
  type: "button",
  href: "https://modedesigns.com/products/envoy",
  class: "mt-4 btn align-self-start btn-outline-dark btn-wide"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h5", {
  class: "m-0 px-3 py-1 d-flex"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, "Configure Yours")])])], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_7 = {
  class: "row content-section"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_8 = {
  class: "col-12 col-md-6 text-center px-4 p-md-2 mb-3 mb-md-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_9 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_10 = {
  class: "col-12 col-md-6 px-4 p-md-2 text-center d-flex flex-column justify-content-center"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_11 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_12 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_13 = {
  class: "row content-section mt-5 mt-md-6 mb-5"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_14 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"col-12 col-md-5 text-start\"><div class=\"d-flex flex-column justify-content-start h-100\"><h1 class=\"fw-light section-header\">About Envoy</h1><p><small> The Envoy is Mode Designs’ latest iteration of the 65% keyboard layout. Whether you’re working from home, in the office, or gaming - the Envoy has hundreds of combinations to help you craft your perfect keyboard. </small></p></div></div><div class=\"col-12 col-md-7 text-start\"><p class=\"mt-2\"><strong>Futuristic Design for Today</strong><br><small> Sharp angles balanced by smooth edges, and an impressive accent that spans the width of the board come together to give the Envoy a futuristic but not overwhelming look. </small></p><p><strong>All New Mounting System</strong><br><small> Utilizing an industry first Lattice Block Mount system you can tune your typing experience to be more flexible or responsive in minutes by simply swapping out the blocks used. </small></p><p><strong>Dream Board at a Dream Cost</strong><br><small> Decisively refined - the Envoy takes classic Mode customization and brings new materials and options for you to choose from. Starting at just $199, there’s something for everyone. </small></p></div>", 2);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_16 = {
  style: {
    "background-color": "#393939"
  },
  class: "col-12 mt-4 img-rounded"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_17 = {
  class: "row content-section"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_18 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 d-flex flex-column justify-content-start"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal mb-0 mt-3 text-light"
}, "Features")], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_19 = {
  class: "d-flex row content-section mt-0 mb-md-6"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_20 = {
  class: "d-none d-lg-flex col-12 text-start mounting-container"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_21 = {
  class: "mounting-img",
  style: {
    "z-index": "-10"
  }
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_22 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_23 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "text-center mt-4"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-light"
}, "Flexible mounting block system"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "text-muted px-5 mounting-text",
  style: {
    "min-height": "90px"
  }
}, " We’ve partnered with Carbon 3D, utilizing the Carbon DLS™ 3D printing process to develop an elastomeric blocks which offer a uniquely bouncy typing feel or a classic stiffer typing experience. The whole system is secured by two fasteners that prevent the internal assembly from moving upwards but have no impact on downwards movement. ")], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_24 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-lg-none d-flex col-12 text-start mounting-container"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "text-center mt-4"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-light"
}, "Flexible mounting block system"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "text-muted px-md-5 mounting-text",
  style: {
    "min-height": "90px"
  }
}, " We’ve partnered with Carbon 3D, utilizing the Carbon DLS™ 3D printing process to create an elastomeric blocks which offer a uniquely bouncy typing feel or a classic stiffer typing experience. The whole system is secured by two fasteners that prevent the internal assembly from moving upwards but have no impact on downwards movement. ")])], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_25 = {
  class: "d-lg-none d-flex col-12 text-start mounting-container"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_26 = {
  class: "mounting-img"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_27 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_28 = {
  class: "col-12 col-sm-6 d-flex justify-content-md-start justify-content-center"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_29 = {
  class: "card mounting-card ms-lg-4 ms-md-3 mt-lg-4 mt-md-5 mt-3 border-light"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_30 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_31 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"card-body row pt-1 pt-md-2\"><div class=\"col-12\"><strong class=\"card-title\"><small>Lattice Block Mount</small></strong></div><div class=\"col-12\"><p class=\"card-text\"> The lattice block mount combines Carbon’s DLS printing process and Voronoi lattices to create a dreamy, flexible typing experience. </p></div></div>", 1);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_32 = {
  class: "col-12 col-sm-6 d-flex justify-content-md-end justify-content-center"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_33 = {
  class: "card mounting-card me-lg-4 me-md-3 mt-lg-4 mt-md-5 mt-3 border-light"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_34 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_35 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"card-body row pt-1 pt-md-2\"><div class=\"col-12\"><strong class=\"card-title\"><small>Solid Block Mount</small></strong></div><div class=\"col-12\"><p class=\"card-text\"> The solid block mount produces a firmer, more responsive, yet still comfortable typing experience. </p></div></div>", 1);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_36 = {
  class: "row content-section mt-5 mb-6 mt-md-6"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_37 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "section-header"
}, "Get Inspired"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", null, " Choose from one of our hand selected configurations, or create your own from hundreds of combinations of colors and materials. Configurator coming soon. ")], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_38 = {
  class: "col-12 col-md-8 text-center px-4 p-md-2 mb-3 mb-md-0 flex-column d-flex justify-content-end"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_39 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_40 = {
  class: "col-12 col-md-4 px-4 p-md-2 text-center d-flex flex-column justify-content-between"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_41 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_42 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_43 = {
  class: "col-12 col-md-6 px-4 p-md-2 text-center d-flex flex-column justify-content-start"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_44 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_45 = {
  class: "col-12 col-md-6 px-4 p-md-2 text-center d-flex flex-column justify-content-start"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_46 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_47 = {
  class: "row content-section d-flex justify-content-center flex-wrap pb-0 pb-md-5"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_48 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 d-flex justify-content-start align-items-baseline mb-6"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", {
  class: "fw-normal mt-4 mb-0"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Technical "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("br"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createTextVNode */.eW)(" Specifications ")])], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_49 = {
  class: "col-12"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_50 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "Supported Layouts"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "text-muted-light mb-0 d-flex flex-column justify-content-center text-light",
  id: 'arrow-0'
})], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_51 = {
  class: "col-12 justify-content-center mt-4 d-flex"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_52 = ["src"];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_53 = {
  class: "col-11 justify-content-end d-flex"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_54 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h5", {
  class: "fw-light me-2"
}, "Solder", -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_55 = [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_54];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_56 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h5", {
  class: "fw-light"
}, "Hotswap", -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_57 = [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_56];
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_58 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "Box Contents"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "mb-0 d-flex text-muted-light flex-column justify-content-center text-light",
  id: 'arrow-1'
})], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_59 = {
  class: "col-7 offset-3 justify-content-center"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_60 = {
  class: "table table-sm table-borderless my-2 text-light text-muted-light"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_61 = {
  key: 0
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_62 = {
  class: "w-30 pb-1 pt-0 ps-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_63 = {
  class: "fw-normal p-0 m-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_64 = {
  key: 0,
  class: "w-75 pb-1 pt-0 ps-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_65 = {
  class: "fw-normal p-0 m-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_66 = {
  key: 1
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_67 = {
  class: "w-30 pb-1 pt-0 ps-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_68 = {
  class: "fw-normal p-0 m-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_69 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "Measurements"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "mb-0 text-muted-light d-flex flex-column justify-content-center text-light",
  id: 'arrow-2'
})], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_70 = {
  class: "col-7 offset-3 justify-content-center"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_71 = {
  class: "table table-sm table-borderless my-2 text-light text-muted-light"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_72 = {
  class: "w-30 pb-1 pt-0 ps-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_73 = {
  class: "fw-bolder p-0 m-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_74 = {
  class: "w-75 pb-1 pt-0 ps-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_75 = {
  class: "p-0 m-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_76 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "PCB"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "mb-0 d-flex text-muted-light flex-column justify-content-center text-light",
  id: 'arrow-3'
})], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_77 = {
  class: "col-7 offset-3 justify-content-center"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_78 = {
  class: "table table-sm table-borderless my-2 text-light text-muted-light"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_79 = {
  class: "w-30 pb-1 pt-0 ps-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_80 = {
  class: "fw-bolder p-0 m-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_81 = {
  class: "w-75 pb-1 pt-0 ps-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_82 = {
  class: "p-0 m-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_83 = {
  class: "text-muted-light"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_84 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex justify-content-between border-bottom border-light border-muted"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "fw-normal"
}, "Materials"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", {
  class: "mb-0 d-flex text-muted-light flex-column justify-content-center text-light",
  id: 'arrow-4'
})], -1 /* HOISTED */);
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_85 = {
  class: "col-7 offset-3 justify-content-center"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_86 = {
  class: "table table-sm table-borderless my-2 text-light text-muted-light"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_87 = {
  class: "w-30 pb-1 pt-0 ps-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_88 = {
  class: "fw-bolder p-0 m-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_89 = {
  class: "w-75 pb-1 pt-0 ps-0"
};
var EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_90 = {
  class: "p-0 m-0"
};
function EnvoyLandingPagevue_type_template_id_e1dd7e5c_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_icon_card_group = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("icon-card-group");
  var _component_drop_down = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("drop-down");
  var _component_typer = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("typer");
  var _component_row_background = (0,runtime_core_esm_bundler/* resolveComponent */.g2)("row-background");
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_1, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_2, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" HERO "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_3, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_4, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid",
    width: "1281",
    height: "706",
    src: this.assetHost + '/envoy/envoy-65-banner-v6.jpg'
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_5)]), EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_6]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" GALLERY "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_7, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_8, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid obscura-img-workspace me-md-3 img-rounded",
    width: "513",
    height: "912",
    src: this.assetHost + '/envoy/envoy-65-gallery-tall.jpg'
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_9)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_10, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid mb-3 mb-md-4 img-rounded",
    width: "531",
    height: "434",
    src: this.assetHost + '/envoy/envoy-65-gallery-short-1.jpg'
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_11)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-rounded",
    width: "531",
    height: "434",
    src: this.assetHost + '/envoy/envoy-65-gallery-short-2.jpg'
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_12)])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" ENVOY DETAILS "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_13, [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_14, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" FEATURES "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_16, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_17, [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_18, (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_icon_card_group, {
    class: "mb-0 mt-4 mb-3 text-light",
    cards: $options.featureCards
  }, null, 8 /* PROPS */, ["cards"])])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" MOUNTING SYSTEM "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_19, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_20, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_21, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    src: this.assetHost + '/envoy/envoy-65-exploded-v2.jpg',
    width: "1100",
    height: "683",
    class: "img-fluid img-rounded"
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_22)]), EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_23]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" MEDIUM DOWN "), EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_24, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_25, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_26, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    src: this.assetHost + '/envoy/envoy-65-exploded-v2.jpg',
    width: "1100",
    height: "683",
    class: "img-fluid img-rounded"
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_27)])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" MOUTING INFO CARDS "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_28, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_29, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "376",
    height: "251",
    src: this.assetHost + '/envoy/envoy-65-lattice.png',
    class: "img-fluid card-img-top px-3 pt-0 pb-1",
    alt: "..."
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_30), EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_31])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_32, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_33, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    width: "376",
    height: "251",
    src: this.assetHost + '/envoy/envoy-65-solid-v2.png',
    class: "img-fluid card-img-top px-3 pt-0 pb-1",
    alt: "..."
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_34), EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_35])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" GET INSPIRED "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_36, [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_37, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_38, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid obscura-img-workspace me-md-3 img-rounded",
    width: "728",
    height: "728",
    src: this.assetHost + '/envoy/envoy-65-gallery-2.jpg'
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_39)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_40, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid mb-3 img-rounded",
    width: "531",
    height: "531",
    src: this.assetHost + '/envoy/envoy-65-gallery-4-v2.jpg'
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_41)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid mb-3 mb-md-0 img-rounded",
    width: "531",
    height: "531",
    src: this.assetHost + '/envoy/envoy-65-gallery-5.jpg'
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_42)])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_43, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid mb-3 mb-md-4 img-rounded",
    width: "531",
    height: "531",
    src: this.assetHost + '/envoy/envoy-65-gallery-1.jpg'
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_44)])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_45, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-rounded",
    width: "531",
    height: "531",
    src: this.assetHost + '/envoy/envoy-65-gallery-3.jpg'
  }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_46)])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" TECHNICAL SPECIFICATIONS "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_row_background, {
    bgColor: "#1b1c1d",
    class: "text-light"
  }, {
    default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
      return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_47, [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_48, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_49, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SUPPORTED LAYOUTS"), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.layouts.show,
        arrow: 'arrow-0',
        light: true,
        class: "mb-4",
        onToggle: _cache[2] || (_cache[2] = function ($event) {
          return $options.specs.layouts.show = !$options.specs.layouts.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_50];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_51, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
            width: "1296",
            height: "456",
            class: "img-fluid text-muted-light",
            src: $data.showSolder ? $options.specs.layouts.solderImg : $options.specs.layouts.hotswapImg
          }, null, 8 /* PROPS */, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_52)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_53, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return $data.showSolder = true;
            }),
            class: (0,shared_esm_bundler/* normalizeClass */.C4)(["clickable", [$data.showSolder ? 'text-decoration-underline' : '']])
          }, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_55, 2 /* CLASS */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return $data.showSolder = false;
            }),
            class: (0,shared_esm_bundler/* normalizeClass */.C4)(["clickable", [$data.showSolder ? '' : 'text-decoration-underline']])
          }, EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_57, 2 /* CLASS */)])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" BOX CONTENTS "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.boxContents.show,
        arrow: 'arrow-1',
        light: true,
        class: "mb-4",
        onToggle: _cache[3] || (_cache[3] = function ($event) {
          return $options.specs.boxContents.show = !$options.specs.boxContents.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_58];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_59, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("table", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_60, [!$options.isMobile() ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tbody", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_61, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.boxContents.rows, function (i) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: i
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_62, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_63, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.boxContents.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)($options.specs.boxContents.contents[i - 1]), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])]), $options.specs.boxContents.contents.length - i > i ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("td", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_64, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_65, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.boxContents.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)($options.specs.boxContents.contents[$options.specs.boxContents.contents.length - i]), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)]);
          }), 128 /* KEYED_FRAGMENT */))])) : ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tbody", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_66, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.boxContents.contents, function (c) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: c
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_67, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_68, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.boxContents.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(c), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])]);
          }), 128 /* KEYED_FRAGMENT */))]))])])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" MEASUREMENTS "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.measurements.show,
        arrow: 'arrow-2',
        light: true,
        class: "mb-4",
        onToggle: _cache[4] || (_cache[4] = function ($event) {
          return $options.specs.measurements.show = !$options.specs.measurements.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_69];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_70, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("table", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_71, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("tbody", null, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.measurements.data, function (m, i) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: i
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_72, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_73, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.measurements.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.name), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_74, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_75, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.measurements.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.value), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])]);
          }), 128 /* KEYED_FRAGMENT */))])])])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" PCB "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.pcb.show,
        arrow: 'arrow-3',
        light: true,
        class: "mb-4",
        onToggle: _cache[5] || (_cache[5] = function ($event) {
          return $options.specs.pcb.show = !$options.specs.pcb.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_76];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_77, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("table", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_78, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("tbody", null, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.pcb.data, function (m, i) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: i
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_79, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_80, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.pcb.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.name), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_81, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_82, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.pcb.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.value), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])]);
          }), 128 /* KEYED_FRAGMENT */))])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_83, (0,shared_esm_bundler/* toDisplayString */.v_)($options.specs.pcb.footnote), 1 /* TEXT */)])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" MATERIALS "), (0,runtime_core_esm_bundler/* createVNode */.bF)(_component_drop_down, {
        active: $options.specs.pcb.show,
        arrow: 'arrow-4',
        light: true,
        class: "mb-4",
        onToggle: _cache[6] || (_cache[6] = function ($event) {
          return $options.specs.materials.show = !$options.specs.materials.show;
        })
      }, {
        header: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_84];
        }),
        content: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
          return [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_85, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("table", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_86, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("tbody", null, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($options.specs.materials.data, function (m, i) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("tr", {
              key: i
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_87, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_88, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.materials.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.name), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("td", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_89, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", EnvoyLandingPagevue_type_template_id_e1dd7e5c_hoisted_90, [(0,runtime_core_esm_bundler/* createVNode */.bF)(_component_typer, {
              show: $options.specs.materials.show
            }, {
              default: (0,runtime_core_esm_bundler/* withCtx */.k6)(function () {
                return [(0,runtime_core_esm_bundler/* createTextVNode */.eW)((0,shared_esm_bundler/* toDisplayString */.v_)(m.value), 1 /* TEXT */)];
              }),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["show"])])])]);
          }), 128 /* KEYED_FRAGMENT */))])])])];
        }),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["active"])])])];
    }),
    _: 1 /* STABLE */
  })])]);
}
;// CONCATENATED MODULE: ./src/Apps/EnvoyLandingPage.vue?vue&type=template&id=e1dd7e5c

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/EnvoyLandingPage.vue?vue&type=script&lang=js




/* harmony default export */ const EnvoyLandingPagevue_type_script_lang_js = ({
  name: "envoy-landing-page",
  props: {
    assetHost: {
      type: String,
      default: "../src/assets"
    }
  },
  components: {
    IconCardGroup: IconCardGroup,
    RowBackground: RowBackground,
    DropDown: DropDown
  },
  computed: {
    featureCards() {
      return [{
        image: "".concat(this.assetHost, "/envoy/feature-1.svg"),
        caption: "macOS, Windows, and Linux"
      }, {
        image: "".concat(this.assetHost, "/envoy/feature-2.svg"),
        caption: "Programmable with QMK/VIA"
      }, {
        image: "".concat(this.assetHost, "/envoy/feature-3.svg"),
        caption: "Hotswap or solder PCB"
      }, {
        image: "".concat(this.assetHost, "/envoy/feature-4.svg"),
        caption: "New Mounting System"
      }, {
        image: "".concat(this.assetHost, "/envoy/feature-5.svg"),
        caption: "LED Underglow"
      }, {
        image: "".concat(this.assetHost, "/envoy/feature-6.svg"),
        caption: "Optional sound dampening"
      }];
    },
    specs() {
      return {
        layouts: {
          show: true,
          solderImg: "".concat(this.assetHost, "/envoy/envoy-65-layout-solder.png"),
          hotswapImg: "".concat(this.assetHost, "/envoy/envoy-65-layout-hotswap-v2.png")
        },
        boxContents: {
          show: false,
          rows: 7,
          contents: ["Case", "Plate", "Weight", "Accent", "PCB", "Daughterboard", "Lattice & Solid Mount Blocks", "Feet", "Carry Case", "Fasteners", "Keycap and switch puller", "Screwdriver"]
        },
        boxContentsFull: {
          show: false,
          rows: 3,
          contents: ["Keycap Set", "Switches", "Stabilizers", "Stabilizer lube syringe"]
        },
        measurements: {
          show: false,
          data: [{
            name: "Typing angle",
            value: "5.8 degrees"
          }, {
            name: "Front Height",
            value: "19.5mm"
          }, {
            name: "Width",
            value: "317mm"
          }, {
            name: "Depth",
            value: "112mm"
          }, {
            name: "Weight",
            value: "1.3lbs-3.4lbs unassembled"
          }]
        },
        pcb: {
          show: false,
          data: [{
            name: "Switches",
            value: "66-69 MX-style switches"
          }, {
            name: "Connection",
            value: "USB-C"
          }, {
            name: "Thickness",
            value: "1.6mm"
          }, {
            name: "Options",
            value: "Hotswap or Solder"
          }, {
            name: "Lighting",
            value: "RGB underglow"
          }, {
            name: "Firmware",
            value: "QMK/VIA supported"
          }, {
            name: "MCU",
            value: "ARM"
          }],
          footnote: "Designed by Gondolindrim"
        },
        materials: {
          show: false,
          data: [{
            name: "Case",
            value: "Aluminum, Polycarbonate"
          }, {
            name: "Accent",
            value: "Aluminum, Copper, Stainless Steel, Walnut"
          }, {
            name: "Weight",
            value: "Aluminum, Copper, Stainless Steel"
          }, {
            name: "Plate",
            value: "Aluminum, Carbon Fiber, Copper, FR4, POM"
          }]
        },
        founders: {
          show: false,
          data: [{
            name: "Case",
            value: "Smokey Polycarbonate"
          }, {
            name: "Accent",
            value: "Silver Mirror Aluminum"
          }, {
            name: "Weight",
            value: "Silver Mirror Aluminum"
          }, {
            name: "Plate",
            value: "Carbon Fiber"
          }, {
            name: "PCB",
            value: "Solder Only"
          }, {
            name: "Feet",
            value: "EPU 41 Green"
          }]
        }
      };
    }
  },
  data() {
    return {
      showSolder: true,
      cube: {},
      scene: {},
      renderer: {},
      resizeTimeout: undefined,
      updateFaces: true,
      updateZNegative: true,
      rotations: 1,
      images: {},
      selectedCoverage: "option1",
      compatibilityOpen: false,
      carouselfFunctionality: {},
      carouselfFunctionalityOne: {}
    };
  },
  methods: {
    isMobile() {
      var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
      return vw < 768;
    },
    updateFunctionalityImage(target) {
      this.carouselfFunctionality.to(target);
      this.carouselfFunctionalityOne.to(target);
    },
    togglePlay() {
      console.log("taoggl", this.$refs.videoPlayer);
      if (this.$refs.videoPlayer.paused) {
        this.$refs.videoPlayer.play();
      } else {
        this.$refs.videoPlayer.pause();
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      var functionalityTab = document.querySelector("#functionalityTab");
      var tab = new bootstrap_esm/* Tab */.oz(functionalityTab);
      var carouselOne = document.querySelector("#carouselfFunctionalityOne");
      this.carouselfFunctionalityOne = new bootstrap_esm/* Carousel */.FN(carouselOne, {
        interval: false,
        wrap: false
      });
      var carousel = document.querySelector("#carouselfFunctionality");
      this.carouselfFunctionality = new bootstrap_esm/* Carousel */.FN(carousel, {
        interval: false,
        wrap: false
      });
    });
  }
});
;// CONCATENATED MODULE: ./src/Apps/EnvoyLandingPage.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Apps/EnvoyLandingPage.vue




;


const EnvoyLandingPage_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(EnvoyLandingPagevue_type_script_lang_js, [['render',EnvoyLandingPagevue_type_template_id_e1dd7e5c_render]])

/* harmony default export */ const EnvoyLandingPage = (EnvoyLandingPage_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/AlexotosEditionLanding.vue?vue&type=template&id=2a1c2964

var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_1 = {
  id: "alexotos-edition-app"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_2 = {
  class: "container-fluid"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_3 = {
  id: "keycaps-header",
  class: "row hero content-section mb-5"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_4 = {
  class: "col-12 d-flex justify-content-center mb-4"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_5 = ["src"];
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_6 = {
  class: "col-12 mt-4 mt-md-0 mb-3"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_7 = {
  class: "w-100 d-flex justify-content-center"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_8 = ["src"];
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_9 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 mt-4 mt-md-0 text-center fw-100"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h6", {
  class: "text-muted text-uppercase"
}, "Alexotos Edition Envoy and Switches")], -1 /* HOISTED */);
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_10 = {
  class: "row content-section px-md-5 pb-md-0 my-5 justify-content-between"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_11 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"col-12 col-lg-6 justify-content-center d-flex flex-column px-md-4\"><div class=\"email-card px-4 py-3\"><h3 class=\"fw-light\"> A <strong>Limited</strong> Collaboration </h3><p class=\"mt-md-4 mb-3 fw-light\"> We teamed up with Alexotos to create the <strong>Alexotos Edition <a href=\"/pages/envoy\">Envoy</a> and Switches</strong></p><p class=\"fw-light\"><strong>The Envoy: </strong>A unique combination of a stone colored case with a vibrant orange accent limited to 250 units. Pre-configured with a hotswap pcb, FR4 plate, and grey feet. </p><p class=\"fw-light\"><strong>The Switches: </strong>Based on the Obscura linear and fine-tuned to Alex&#39;s preferred spring weight of 58g, factory lubed with Krytox 205g0. </p><!-- &lt;p class=&quot;mb-2 fw-light&quot;&gt;\n              &lt;strong&gt;Available August 7th.&lt;/strong&gt; Tune-in to\n              &lt;a\n                href=&quot;https://twitch.tv/alexotos&quot;\n                target=&quot;_blank&quot;\n                class=&quot;light-link text-decoration-underline&quot;\n                &gt;Alex&#39;s stream on Twitch at 7:00 PM ET&lt;/a\n              &gt;\n              where he&#39;ll announce the drop.\n            &lt;/p&gt; --><div class=\"mt-4\"><a type=\"button\" href=\"https://modedesigns.com/products/special-edition-white-oak-accent\" class=\"btn btn-outline-light py-1 w-100\"><h6 class=\"mb-0\"><small>Purchase</small></h6></a></div></div></div>", 1);
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_12 = {
  class: "col-12 col-lg-6 d-none d-lg-block px-md-4"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_13 = {
  class: ""
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_14 = ["src"];
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_15 = {
  class: "row content-section mt-5 mb-lg-6"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_16 = {
  class: "col-12 col-lg-6 text-center mb-3 mb-lg-0"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_17 = ["src"];
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_18 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 col-lg-6 text-center"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "d-flex flex-column justify-content-center h-100"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h3", {
  class: "fw-bold"
}, "About Alexotos"), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
  class: "fw-light"
}, " Since 2018, Alex (better known as Alexotos), has been a prominent figure in the custom mechanical keyboard hobby. He's not just a veteran keyboard builder and creator, but also a trusted voice in the keyboard world with a goal to create a welcoming and friendly community in this space. ")])], -1 /* HOISTED */);
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_19 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "row content-section mt-5 mb-md-5"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "col-12 text-start"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" <img\n            class=\"img-fluid\"\n            width=\"1100\"\n            height=\"620\"\n            :src=\"this.assetHost + '/alexotos/oak-accent-banner.jpg'\"\n          /> "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" \n          <video\n            ref=\"videoPlayer\"\n            @click=\"togglePlay\"\n            width=\"1100\"\n            height=\"620\"\n            style=\"cursor: pointer\"\n            autoplay\n            class=\"img-fluid\"\n            muted\n            loop\n            :poster=\"this.assetHost + '/oak-landing/oak-accent-banner.jpg'\"\n          >\n            <source\n              :src=\"this.assetHost + '/oak-landing/oak-landing-video.mp4'\"\n              type=\"video/mp4\"\n            />\n            Your browser does not support the video tag.\n          </video> "), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("iframe", {
  width: "100%",
  height: "100%",
  class: "youtube-video",
  src: "https://www.youtube.com/embed/aA_U_A5x-dc",
  title: "YouTube video player",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
  allowfullscreen: ""
}), /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
  class: "text-muted position-relative"
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("small", {
  style: {
    "font-size": "0.675rem",
    "position": "relative",
    "top": "-10px"
  }
}, [/*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("em", null, "Envoy case and switches are sold separately.")])])])], -1 /* HOISTED */);
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_20 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"row content-section mt-5\"><div class=\"col-12 col-md-6 text-start\"><div class=\"d-flex flex-column justify-content-start h-100\"><h1 class=\"fw-bold\">Inspiration</h1><p><small>In the world of design, where ideas can be as elusive as shadows, it&#39;s often the most unexpected inspirations that birth the most delightful concepts. This truth unveiled itself to the creator known as Alexotos during a seemingly ordinary but ultimately fateful afternoon. While the sun bathed his studio in a soft, warm glow, he casually placed an orange bag alongside a stone-colored planter. At that moment, something extraordinary happened.</small></p></div></div><div class=\"col-12 col-md-6 text-start\"><p><small> The way the two colors met and danced in harmony struck him with an undeniable force. The vibrant orange and the subdued stone didn&#39;t just sit next to each other; they sang, they conversed, they complimented each other in a way that felt both surprising and destined. It was an encounter that seemed to say, &quot;Here is something fresh, something alive.&quot; </small></p><p><small> Since that serendipitous discovery, Alexotos has embraced this colorway, weaving it into the very fabric of his work. It has become more than a theme; it&#39;s a recurring echo of that one beautiful afternoon when inspiration found him in the most unexpected of ways. </small></p></div></div>", 1);
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_21 = {
  class: "row content-section"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_22 = {
  class: "d-none d-md-block col-md-6 text-center"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_23 = ["src"];
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_24 = {
  class: "col-12 col-md-6 text-start d-flex flex-column justify-content-center"
};
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_25 = ["src"];
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_26 = ["src"];
var AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_27 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createStaticVNode */.Fv)("<div class=\"row hero content-section mb-6\"><div class=\"col-12 col-lg-6 offset-lg-3 col-md-8 offset-md-2 d-flex flex-column justify-content-center\"><div class=\"d-inline-flex flex-row align-items-center justify-content-center mb-3\"><h3 class=\"fw-lightest me-3\">Available <strong>August 7th</strong></h3></div><div class=\"d-flex fw-light justify-content-center\"><p class=\"mt-3\"> The <strong>Alexotos Edition Envoy &amp; Switches</strong> available August 7th. Tune-in to <a href=\"https://twitch.tv/alexotos\" target=\"_blank\" class=\"light-link text-decoration-underline\">Alex&#39;s stream on Twitch at 7:00 PM ET</a> where he&#39;ll announce the drop. </p><!-- &lt;p class=&quot;mt-3&quot;&gt;\n              The &lt;strong&gt;Alexotos Edition Envoy &amp; Switches&lt;/strong&gt;\n              available while quantities last.\n            &lt;/p&gt; --></div><div class=\"d-flex fw-light justify-content-start mt-2\"><a type=\"button\" target=\"_blank\" href=\"https://modedesigns.com/products/alexotos-edition-envoy\" class=\"btn btn-outline-dark me-2 py-1 w-100\"><h6 class=\"mb-0\"><small>Envoy</small></h6></a><a type=\"button\" target=\"_blank\" href=\"https://modedesigns.com/products/alexotos-edition-switches\" class=\"btn btn-outline-dark py-1 w-100\"><h6 class=\"mb-0\"><small>Switches</small></h6></a></div></div></div>", 1);
function AlexotosEditionLandingvue_type_template_id_2a1c2964_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_1, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_2, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" HERO "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_3, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_4, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img",
    width: "478",
    height: "61",
    style: {
      "max-width": "290px"
    },
    alt: "Mode and Alexotos logos",
    src: this.assetHost + '/alexotos/otos-accent-logo.svg'
  }, null, 8 /* PROPS */, AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_5)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_6, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_7, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid header-img img-border",
    width: "1100",
    height: "530",
    src: this.assetHost + '/alexotos/otos-rear-head-on.jpg'
  }, null, 8 /* PROPS */, AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_8)])]), AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_9]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" EMAIL FORM "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_10, [AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_11, (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_12, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_13, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-border",
    width: "440",
    height: "660",
    style: {
      "width": "170%"
    },
    src: this.assetHost + '/alexotos/otos-vertical.jpg'
  }, null, 8 /* PROPS */, AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_14)])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" ABOUT "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_15, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_16, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-border",
    width: "500",
    height: "500",
    src: this.assetHost + '/alexotos/otos-headshot.webp'
  }, null, 8 /* PROPS */, AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_17)]), AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_18]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" FULL WIDTH IMAGE "), AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_19, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" ACCENT DETAILS "), AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_20, (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" GALLERY "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_21, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_22, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-border",
    width: "562",
    height: "831",
    src: this.assetHost + '/alexotos/otos-desk.jpg'
  }, null, 8 /* PROPS */, AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_23)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_24, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-border mb-4",
    width: "528",
    height: "292",
    src: this.assetHost + '/alexotos/otos-rear-switches.jpg'
  }, null, 8 /* PROPS */, AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_25)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
    class: "img-fluid img-border",
    width: "528",
    height: "292",
    src: this.assetHost + '/alexotos/otos-facedown-2.jpg'
  }, null, 8 /* PROPS */, AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_26)])])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" CTA "), AlexotosEditionLandingvue_type_template_id_2a1c2964_hoisted_27])]);
}
;// CONCATENATED MODULE: ./src/Apps/AlexotosEditionLanding.vue?vue&type=template&id=2a1c2964

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/AlexotosEditionLanding.vue?vue&type=script&lang=js


/* harmony default export */ const AlexotosEditionLandingvue_type_script_lang_js = ({
  name: "alexotos-edition-page",
  props: {
    assetHost: {
      type: String,
      default: "../src/assets"
    }
  },
  components: {
    RowBackground: RowBackground
  },
  data() {
    return {
      cube: {},
      scene: {},
      renderer: {},
      resizeTimeout: undefined,
      updateFaces: true,
      updateZNegative: true,
      rotations: 1,
      images: {},
      selectedCoverage: "option1",
      compatibilityOpen: false,
      carouselfFunctionality: {},
      carouselfFunctionalityOne: {},
      hovered: false
    };
  },
  methods: {
    updateFunctionalityImage(target) {
      this.carouselfFunctionality.to(target);
      this.carouselfFunctionalityOne.to(target);
    },
    togglePlay() {
      console.log("taoggl", this.$refs.videoPlayer);
      if (this.$refs.videoPlayer.paused) {
        this.$refs.videoPlayer.play();
      } else {
        this.$refs.videoPlayer.pause();
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      var functionalityTab = document.querySelector("#functionalityTab");
      var tab = new bootstrap_esm/* Tab */.oz(functionalityTab);
      var carouselOne = document.querySelector("#carouselfFunctionalityOne");
      this.carouselfFunctionalityOne = new bootstrap_esm/* Carousel */.FN(carouselOne, {
        interval: false,
        wrap: false
      });
      var carousel = document.querySelector("#carouselfFunctionality");
      this.carouselfFunctionality = new bootstrap_esm/* Carousel */.FN(carousel, {
        interval: false,
        wrap: false
      });
    });
  }
});
;// CONCATENATED MODULE: ./src/Apps/AlexotosEditionLanding.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Apps/AlexotosEditionLanding.vue




;


const AlexotosEditionLanding_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(AlexotosEditionLandingvue_type_script_lang_js, [['render',AlexotosEditionLandingvue_type_template_id_2a1c2964_render]])

/* harmony default export */ const AlexotosEditionLanding = (AlexotosEditionLanding_exports_);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/templateLoader.js??ruleSet[1].rules[2]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/PCBGuide.vue?vue&type=template&id=e75439b0

var PCBGuidevue_type_template_id_e75439b0_hoisted_1 = {
  class: "container px-md-5",
  "data-bs-spy": "scroll",
  "data-bs-target": "#nav-items"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_2 = {
  id: "introduction",
  class: "row mb-4"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_3 = {
  class: "col col-12 col-md-10 offset-md-1 title"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_4 = ["innerHTML"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_5 = ["id"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_6 = ["innerHTML"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_7 = ["id"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_8 = {
  class: "subsection-heading"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_9 = ["id"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_10 = {
  class: "row col col-12 col-md-10"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_11 = {
  key: 0
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_12 = ["innerHTML"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_13 = {
  class: "mb-4 text-color--opacity"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_14 = ["innerHTML"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_15 = ["innerHTML"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_16 = {
  key: 0,
  class: "row mb-4"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_17 = ["src", "data-bs-target"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_18 = ["id"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_19 = {
  class: "modal-dialog modal-lg"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_20 = {
  class: "modal-content"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_21 = {
  class: "modal-body p-0"
};
var PCBGuidevue_type_template_id_e75439b0_hoisted_22 = ["src"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_23 = ["innerHTML"];
var PCBGuidevue_type_template_id_e75439b0_hoisted_24 = /*#__PURE__*/(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("hr", {
  class: "separator"
}, null, -1 /* HOISTED */);
function PCBGuidevue_type_template_id_e75439b0_render(_ctx, _cache, $props, $setup, $data, $options) {
  return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
    id: "pcb-guide-app",
    onScroll: _cache[0] || (_cache[0] = function ($event) {
      return $options.updateNavIndicator();
    })
  }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", PCBGuidevue_type_template_id_e75439b0_hoisted_1, [(0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" INTRODUCTION "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", PCBGuidevue_type_template_id_e75439b0_hoisted_2, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", PCBGuidevue_type_template_id_e75439b0_hoisted_3, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h1", null, (0,shared_esm_bundler/* toDisplayString */.v_)($props.content.title), 1 /* TEXT */), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
    innerHTML: $props.content.introduction
  }, null, 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_4)])]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SECTIONS "), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)($props.content.sections, function (section, sectionIndex) {
    return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
      key: section.title,
      class: "row col col-12 col-md-10 offset-md-1 mb-2",
      id: 'section-' + sectionIndex
    }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h2", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, (0,shared_esm_bundler/* toDisplayString */.v_)(section.title), 1 /* TEXT */)]), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("p", {
      innerHTML: section.intro,
      class: "text-color--opacity"
    }, null, 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_6), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SUBSECTIONS "), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(section.subsections, function (subsection, subsectionIndex) {
      return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
        key: subsection.title,
        id: 'step-' + subsectionIndex
      }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("h4", PCBGuidevue_type_template_id_e75439b0_hoisted_8, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, (0,shared_esm_bundler/* toDisplayString */.v_)(subsection.title), 1 /* TEXT */)]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" STEPS "), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(subsection.steps, function (step, stepIndex) {
        return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
          key: step.title,
          id: 'step-' + stepIndex
        }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", PCBGuidevue_type_template_id_e75439b0_hoisted_10, [step.title ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("h4", PCBGuidevue_type_template_id_e75439b0_hoisted_11, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", null, (0,shared_esm_bundler/* toDisplayString */.v_)(stepIndex + 1) + ". " + (0,shared_esm_bundler/* toDisplayString */.v_)(step.title), 1 /* TEXT */)])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), step.subtitle ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("p", {
          key: 1,
          innerHTML: step.subtitle,
          class: "text-color--opacity"
        }, null, 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_12)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" BULLETS "), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", PCBGuidevue_type_template_id_e75439b0_hoisted_13, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(step.bullets, function (bullet, bulletIndex) {
          return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("ul", {
            key: bulletIndex,
            class: "less-padding bullet"
          }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("li", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
            innerHTML: bullet.text
          }, null, 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_14), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" SUBBULLETS "), ((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(bullet.subbullets, function (subbullet, subbulletIndex) {
            return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("ul", {
              key: subbulletIndex,
              class: "less-padding subbullet"
            }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("li", null, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("span", {
              innerHTML: subbullet.text
            }, null, 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_15)])]);
          }), 128 /* KEYED_FRAGMENT */))])]);
        }), 128 /* KEYED_FRAGMENT */))]), (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)(" IMAGE "), step.images ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", PCBGuidevue_type_template_id_e75439b0_hoisted_16, [((0,runtime_core_esm_bundler/* openBlock */.uX)(true), (0,runtime_core_esm_bundler/* createElementBlock */.CE)(runtime_core_esm_bundler/* Fragment */.FK, null, (0,runtime_core_esm_bundler/* renderList */.pI)(step.images, function (image, index) {
          return (0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("div", {
            class: (0,shared_esm_bundler/* normalizeClass */.C4)(['col col-md-' + 12 / step.images.length, step.images.length === 1 ? 'offset-md-1' : ''])
          }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
            src: image,
            width: "598",
            height: "399",
            class: "img-fluid step-img",
            "data-bs-toggle": "modal",
            "data-bs-target": '#section' + sectionIndex + 'subsection-' + subsectionIndex + 'step-' + stepIndex + 'modal-' + index,
            tabindex: "-1",
            "aria-hidden": "true",
            alt: "..."
          }, null, 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_17), (0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", {
            class: "modal fade",
            id: 'section' + sectionIndex + 'subsection-' + subsectionIndex + 'step-' + stepIndex + 'modal-' + index,
            tabindex: "-1",
            "aria-hidden": "true"
          }, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", PCBGuidevue_type_template_id_e75439b0_hoisted_19, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", PCBGuidevue_type_template_id_e75439b0_hoisted_20, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("div", PCBGuidevue_type_template_id_e75439b0_hoisted_21, [(0,runtime_core_esm_bundler/* createElementVNode */.Lk)("img", {
            src: image,
            class: "img-fluid",
            alt: "..."
          }, null, 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_22)])])])], 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_18)], 2 /* CLASS */);
        }), 256 /* UNKEYED_FRAGMENT */))])) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true)], 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_9);
      }), 128 /* KEYED_FRAGMENT */))], 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_7);
    }), 128 /* KEYED_FRAGMENT */)), section.outro ? ((0,runtime_core_esm_bundler/* openBlock */.uX)(), (0,runtime_core_esm_bundler/* createElementBlock */.CE)("p", {
      key: 0,
      innerHTML: section.outro,
      class: "text-color--opacity outro"
    }, null, 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_23)) : (0,runtime_core_esm_bundler/* createCommentVNode */.Q3)("v-if", true), PCBGuidevue_type_template_id_e75439b0_hoisted_24], 8 /* PROPS */, PCBGuidevue_type_template_id_e75439b0_hoisted_5);
  }), 128 /* KEYED_FRAGMENT */))])], 32 /* NEED_HYDRATION */);
}
;// CONCATENATED MODULE: ./src/Apps/PCBGuide.vue?vue&type=template&id=e75439b0

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-3.use[0]!./node_modules/thread-loader/dist/cjs.js??clonedRuleSet-3.use[1]!./node_modules/vue-loader/dist/index.js??ruleSet[1].rules[9].use[0]!./src/Apps/PCBGuide.vue?vue&type=script&lang=js
/* harmony default export */ const PCBGuidevue_type_script_lang_js = ({
  name: "pcb-guide",
  props: {
    content: Object
  },
  components: {},
  data() {
    return {
      navOpen: false
    };
  },
  methods: {
    updateNavIndicator() {}
  },
  mounted() {}
});
;// CONCATENATED MODULE: ./src/Apps/PCBGuide.vue?vue&type=script&lang=js
 
;// CONCATENATED MODULE: ./src/Apps/PCBGuide.vue




;


const PCBGuide_exports_ = /*#__PURE__*/(0,exportHelper/* default */.A)(PCBGuidevue_type_script_lang_js, [['render',PCBGuidevue_type_template_id_e75439b0_render]])

/* harmony default export */ const PCBGuide = (PCBGuide_exports_);
;// CONCATENATED MODULE: ./src/main.js
function main_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function main_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? main_ownKeys(Object(t), !0).forEach(function (r) { main_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : main_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function main_defineProperty(e, r, t) { return (r = main_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function main_toPropertyKey(t) { var i = main_toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function main_toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }










class ConfiguratorV3App {
  constructor(id, data) {
    this._sectionId = id;
    this._appType = "configurator-v3-app";
    this._appInstance = null;
    this._appData = data;
    this._mountingNode = null;
  }
  getSectionId() {
    return this._sectionId;
  }
  setMountingNode() {
    this._mountingNode = document.querySelector("div[data-app-id=\"".concat(this._sectionId, "\"][data-app-type=\"").concat(this._appType, "\"]"));
    if (!this._mountingNode) {
      this._mountingNode = "#app";
    }
  }
  // required
  kill() {
    this._appInstance.kill();
  }
  // required
  init() {
    this.setMountingNode();
    var data = this._appData;
    var app = (0,runtime_dom_esm_bundler/* createApp */.Ef)({
      render() {
        return (0,runtime_core_esm_bundler.h)(ConfiguratorV3, main_objectSpread({}, data));
      },
      methods: {
        kill() {
          this.$destroy();
        }
      }
    });
    app.mount(this._mountingNode);
  }
}
class BuildGuideApp {
  constructor(id, data) {
    this._sectionId = id;
    this._appType = "build-guide-app";
    this._appInstance = null;
    this._appData = data;
    this._mountingNode = null;
  }
  getSectionId() {
    return this._sectionId;
  }
  setMountingNode() {
    this._mountingNode = document.querySelector("div[data-app-id=\"".concat(this._sectionId, "\"][data-app-type=\"").concat(this._appType, "\"]"));
    if (!this._mountingNode) {
      this._mountingNode = "#app";
    }
  }
  // required
  kill() {
    this._appInstance.kill();
  }
  // required
  init() {
    this.setMountingNode();
    var data = this._appData;
    var app = (0,runtime_dom_esm_bundler/* createApp */.Ef)({
      render() {
        return (0,runtime_core_esm_bundler.h)(BuildGuide, main_objectSpread({}, data));
      },
      methods: {
        kill() {
          this.$destroy();
        }
      }
    });
    app.mount(this._mountingNode);
  }
}
class PCBGuideApp {
  constructor(id, data) {
    this._sectionId = id;
    this._appType = "pcb-guide-app";
    this._appInstance = null;
    this._appData = data;
    this._mountingNode = null;
  }
  getSectionId() {
    return this._sectionId;
  }
  setMountingNode() {
    this._mountingNode = document.querySelector("div[data-app-id=\"".concat(this._sectionId, "\"][data-app-type=\"").concat(this._appType, "\"]"));
    if (!this._mountingNode) {
      this._mountingNode = "#app";
    }
  }
  // required
  kill() {
    this._appInstance.kill();
  }
  // required
  init() {
    this.setMountingNode();
    var data = this._appData;
    var app = (0,runtime_dom_esm_bundler/* createApp */.Ef)({
      render() {
        return (0,runtime_core_esm_bundler.h)(PCBGuide, main_objectSpread({}, data));
      },
      methods: {
        kill() {
          this.$destroy();
        }
      }
    });
    app.mount(this._mountingNode);
  }
}
class KeycapsLandingPageApp {
  constructor(id, data) {
    this._sectionId = id;
    this._appType = "keycaps-page-app";
    this._appInstance = null;
    this._appData = data;
    this._mountingNode = null;
  }
  getSectionId() {
    return this._sectionId;
  }
  setMountingNode() {
    this._mountingNode = document.querySelector("div[data-app-id=\"".concat(this._sectionId, "\"][data-app-type=\"").concat(this._appType, "\"]"));
    if (!this._mountingNode) {
      this._mountingNode = "#app";
    }
  }
  // required
  kill() {
    this._appInstance.kill();
  }
  // required
  init() {
    this.setMountingNode();
    var data = this._appData;
    var app = (0,runtime_dom_esm_bundler/* createApp */.Ef)({
      render() {
        return (0,runtime_core_esm_bundler.h)(KeycapsLandingPage, main_objectSpread({}, data));
      },
      methods: {
        kill() {
          this.$destroy();
        }
      }
    });
    app.mount(this._mountingNode);
  }
}
class SonnetProductPageApp {
  constructor(id, data) {
    this._sectionId = id;
    this._appType = "sonnet-product-page-app";
    this._appInstance = null;
    this._appData = data;
    this._mountingNode = null;
  }
  getSectionId() {
    return this._sectionId;
  }
  setMountingNode() {
    this._mountingNode = document.querySelector("div[data-app-id=\"".concat(this._sectionId, "\"][data-app-type=\"").concat(this._appType, "\"]"));
    if (!this._mountingNode) {
      this._mountingNode = "#app";
    }
  }
  // required
  kill() {
    this._appInstance.kill();
  }
  // required
  init() {
    this.setMountingNode();
    var data = this._appData;
    var app = (0,runtime_dom_esm_bundler/* createApp */.Ef)({
      render() {
        return (0,runtime_core_esm_bundler.h)(SonnetProductPage, main_objectSpread({}, data));
      },
      methods: {
        kill() {
          this.$destroy();
        }
      }
    });
    app.mount(this._mountingNode);
  }
}
class OakAccentLandingApp {
  constructor(id, data) {
    this._sectionId = id;
    this._appType = "oak-accent-page-app";
    this._appInstance = null;
    this._appData = data;
    this._mountingNode = null;
  }
  getSectionId() {
    return this._sectionId;
  }
  setMountingNode() {
    this._mountingNode = document.querySelector("div[data-app-id=\"".concat(this._sectionId, "\"][data-app-type=\"").concat(this._appType, "\"]"));
    if (!this._mountingNode) {
      this._mountingNode = "#app";
    }
  }
  // required
  kill() {
    this._appInstance.kill();
  }
  // required
  init() {
    this.setMountingNode();
    var data = this._appData;
    var app = (0,runtime_dom_esm_bundler/* createApp */.Ef)({
      render() {
        return (0,runtime_core_esm_bundler.h)(OakAccentLanding, main_objectSpread({}, data));
      },
      methods: {
        kill() {
          this.$destroy();
        }
      }
    });
    app.mount(this._mountingNode);
  }
}
class EnvoyLandingPageApp {
  constructor(id, data) {
    this._sectionId = id;
    this._appType = "envoy-landing-page-app";
    this._appInstance = null;
    this._appData = data;
    this._mountingNode = null;
  }
  getSectionId() {
    return this._sectionId;
  }
  setMountingNode() {
    this._mountingNode = document.querySelector("div[data-app-id=\"".concat(this._sectionId, "\"][data-app-type=\"").concat(this._appType, "\"]"));
    if (!this._mountingNode) {
      this._mountingNode = "#app";
    }
  }
  // required
  kill() {
    this._appInstance.kill();
  }
  // required
  init() {
    this.setMountingNode();
    var data = this._appData;
    var app = (0,runtime_dom_esm_bundler/* createApp */.Ef)({
      render() {
        return (0,runtime_core_esm_bundler.h)(EnvoyLandingPage, main_objectSpread({}, data));
      },
      methods: {
        kill() {
          this.$destroy();
        }
      }
    });
    app.mount(this._mountingNode);
  }
}
class AlexotosEditionLandingApp {
  constructor(id, data) {
    this._sectionId = id;
    this._appType = "alexotos-edition-app";
    this._appInstance = null;
    this._appData = data;
    this._mountingNode = null;
  }
  getSectionId() {
    return this._sectionId;
  }
  setMountingNode() {
    this._mountingNode = document.querySelector("div[data-app-id=\"".concat(this._sectionId, "\"][data-app-type=\"").concat(this._appType, "\"]"));
    if (!this._mountingNode) {
      this._mountingNode = "#app";
    }
  }
  // required
  kill() {
    this._appInstance.kill();
  }
  // required
  init() {
    this.setMountingNode();
    var data = this._appData;
    var app = (0,runtime_dom_esm_bundler/* createApp */.Ef)({
      render() {
        return (0,runtime_core_esm_bundler.h)(AlexotosEditionLanding, main_objectSpread({}, data));
      },
      methods: {
        kill() {
          this.$destroy();
        }
      }
    });
    app.mount(this._mountingNode);
  }
}
var activeApps = [];
var appTypeClass = [];
appTypeClass["configurator-v3-app"] = ConfiguratorV3App;
appTypeClass["build-guide-app"] = BuildGuideApp;
appTypeClass["pcb-guide-app"] = PCBGuideApp;
appTypeClass["keycaps-page-app"] = KeycapsLandingPageApp;
appTypeClass["sonnet-product-page-app"] = SonnetProductPageApp;
appTypeClass["oak-accent-page-app"] = OakAccentLandingApp;
appTypeClass["envoy-landing-page-app"] = EnvoyLandingPageApp;
appTypeClass["alexotos-edition-app"] = AlexotosEditionLandingApp;
window.theme.vue.availableApps.forEach(function (app) {
  if (appTypeClass[app.type]) {
    var newApp = new appTypeClass[app.type](app.id, app.data);
    activeApps.push(newApp);
    newApp.init();
  } else {
    console.error("App \"".concat(app.type, "\" was not registered."));
  }
});

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [96], () => (__webpack_exec__(784)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);